
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("k8ulM", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$840, foreign$841, heap$842) {
                'use asm';
                var H$843 = new stdlib$840.Int32Array(heap$842);
                function hash$844(k$845, x$846) {
                    // k in bytes
                    k$845 = k$845 | 0;
                    x$846 = x$846 | 0;
                    var i$847 = 0, j$848 = 0, y0$849 = 0, z0$850 = 0, y1$851 = 0, z1$852 = 0, y2$853 = 0, z2$854 = 0, y3$855 = 0, z3$856 = 0, y4$857 = 0, z4$858 = 0, t0$859 = 0, t1$860 = 0;
                    y0$849 = H$843[x$846 + 320 >> 2] | 0;
                    y1$851 = H$843[x$846 + 324 >> 2] | 0;
                    y2$853 = H$843[x$846 + 328 >> 2] | 0;
                    y3$855 = H$843[x$846 + 332 >> 2] | 0;
                    y4$857 = H$843[x$846 + 336 >> 2] | 0;
                    for(i$847 = 0; (i$847 | 0) < (k$845 | 0); i$847 = i$847 + 64 | 0){
                        z0$850 = y0$849;
                        z1$852 = y1$851;
                        z2$854 = y2$853;
                        z3$856 = y3$855;
                        z4$858 = y4$857;
                        for(j$848 = 0; (j$848 | 0) < 64; j$848 = j$848 + 4 | 0){
                            t1$860 = H$843[i$847 + j$848 >> 2] | 0;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[k$845 + j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 64 | 0; (j$848 | 0) < (k$845 + 80 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 80 | 0; (j$848 | 0) < (k$845 + 160 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1859775393 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 160 | 0; (j$848 | 0) < (k$845 + 240 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | y1$851 & y3$855 | y2$853 & y3$855) | 0) + ((t1$860 + y4$857 | 0) - 1894007588 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 240 | 0; (j$848 | 0) < (k$845 + 320 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) - 899497514 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        y0$849 = y0$849 + z0$850 | 0;
                        y1$851 = y1$851 + z1$852 | 0;
                        y2$853 = y2$853 + z2$854 | 0;
                        y3$855 = y3$855 + z3$856 | 0;
                        y4$857 = y4$857 + z4$858 | 0;
                    }
                    H$843[x$846 + 320 >> 2] = y0$849;
                    H$843[x$846 + 324 >> 2] = y1$851;
                    H$843[x$846 + 328 >> 2] = y2$853;
                    H$843[x$846 + 332 >> 2] = y3$855;
                    H$843[x$846 + 336 >> 2] = y4$857;
                }
                return {
                    hash: hash$844
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                _createClass(Hash, [
                    {
                        key: 'state',
                        get: function() {
                            return this._rusha.getState();
                        },
                        set: function(state) {
                            this._rusha.setState(state);
                        }
                    }
                ]);
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("ag6aQ", function(module, exports) {
const $fba53d904c5be787$var$prefix = 'pm-alt-text';
const $fba53d904c5be787$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$fba53d904c5be787$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};
module.exports["ClassNames"] = $fba53d904c5be787$export$9b9c0f9d9f3552b8;

});

parcelRegister("6tl2G", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $584b2e64b69fa432$export$dbdec03917c683f4 = (schema, adf)=>{
    let isTransformed = false;
    const { syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock, unsupportedBlock: unsupportedBlock } = schema.nodes;
    if (!unsupportedBlock) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        syncBlock: (node)=>{
            if (syncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        bodiedSyncBlock: (node)=>{
            if (bodiedSyncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        unsupportedBlock: (node)=>{
            if (!node.attrs?.originalValue) return node;
            if (node.attrs.originalValue.type === 'syncBlock' && syncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            } else if (node.attrs.originalValue.type === 'bodiedSyncBlock' && bodiedSyncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};




// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $1c2816ef0c8b7188$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $1c2816ef0c8b7188$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $1c2816ef0c8b7188$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $1c2816ef0c8b7188$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};




const $c7e8fda47c191e04$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $c7e8fda47c191e04$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $c7e8fda47c191e04$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
            return;
        },
        tableHeader: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};





var $hbEec = parcelRequire("hbEec");

const $5b85afc4a4930f06$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $5b85afc4a4930f06$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $5b85afc4a4930f06$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $hbEec.isEmpty)(node));
        //remove other remaining dupicates
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $5b85afc4a4930f06$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $5b85afc4a4930f06$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $5b85afc4a4930f06$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $1LHXq = parcelRequire("1LHXq");



const $012dd1aff3a76210$export$abd79dcca4cbaf32 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            const { width: width, widthType: widthType } = node.attrs || {};
            // if width is not a number or greater than 100, and widthType is not set, we set width to 100
            if (typeof width === 'number' && width > 100 && !widthType) {
                isTransformed = true;
                const newAttrs = {
                    ...node.attrs,
                    width: 100
                };
                return {
                    ...node,
                    attrs: newAttrs
                };
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $dDZcC = parcelRequire("dDZcC");




var $eyfm5 = parcelRequire("eyfm5");

var $2FFuS = parcelRequire("2FFuS");

var $inmjk = parcelRequire("inmjk");

var $8WrQo = parcelRequire("8WrQo");




const $c977c2fbc5484638$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $c977c2fbc5484638$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $2FFuS.paragraph)()
            ];
        default:
            return [];
    }
};
const $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$createValidEmptyContent(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $c977c2fbc5484638$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $hbEec.isEmpty)(childNode)) {
                    const result = (0, $eyfm5.listItem)([
                        (0, $2FFuS.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $eyfm5.listItem)([
                    (0, $2FFuS.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $eyfm5.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasNonListItemChildren(node) || $c977c2fbc5484638$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $c977c2fbc5484638$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $8WrQo.tableRow)([
                    (0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $8WrQo.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $hbEec.isEmpty)(childNode)) return (0, $8WrQo.tableRow)([
                    ...new Array(maxColsCount).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0) || undefined;
const $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasEmptyTableRowChildren(node) || $c977c2fbc5484638$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return false;
        }
        return;
    };
const $c977c2fbc5484638$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        mediaSingle: $c977c2fbc5484638$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        bulletList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};




const $8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $8fc0fe8ad0751ae2$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $8fc0fe8ad0751ae2$var$removeCodeMarks(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};



var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $sxTNo = parcelRequire("sxTNo");


var $hpdQE = parcelRequire("hpdQE");


var $juTiU = parcelRequire("juTiU");


var $6aq5c = parcelRequire("6aq5c");

const $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dDZcC.transformNestedTablesIncomingDocument)(node);
        if ((0, $dh538.fg)('platform_editor_show_diff_scroll_navigation')) {
            if (isTransformed) {
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                });
                return {
                    transformedAdf: transformedAdf,
                    isTransformed: isTransformed
                };
            }
        } else if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $c8ab5aa71274e362$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    // Convert nested-table extensions into nested tables
    let { transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
    if ((0, $dh538.fg)('platform_editor_sync_block_fallback_transform')) {
        const result = (0, $584b2e64b69fa432$export$dbdec03917c683f4)(schema, transformedAdf);
        if (result.isTransformed && result.transformedAdf) transformedAdf = result.transformedAdf;
    }
    return (0, $5SAOw.Node).fromJSON(schema, transformedAdf);
}
function $c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $5SAOw.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1LHXq.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        if ((0, $dh538.fg)('platform_editor_transform_invalid_media_width')) {
            // Fix mediaSingle width issues
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $012dd1aff3a76210$export$abd79dcca4cbaf32)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).MEDIA_SINGLE_WIDTH_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $1c2816ef0c8b7188$export$af4e387303482581)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $c977c2fbc5484638$export$652814b83c30d251)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $c7e8fda47c191e04$export$c06e4b521519af22)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $5b85afc4a4930f06$export$1c8c16d74c7a63bf)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
        // Validate ADF first before converting nested-table extensions into nested tables
        // This matches the renderer's behavior in render-document.ts
        const allowNestedTables = (0, $sxTNo.isNestedTablesSupported)(schema);
        let entity = (0, $6aq5c.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent, allowNestedTables ? {
            allowNestedTables: allowNestedTables
        } : undefined);
        // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(entity, dispatchAnalyticsEvent));
        entity = transformedAdf;
        const newEntity = $c8ab5aa71274e362$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $5SAOw.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $juTiU.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $c8ab5aa71274e362$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $5SAOw.Fragment).from(adfEntities);
}
function $c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $c8ab5aa71274e362$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $hpdQE.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};
module.exports["processRawValueWithoutValidation"] = $c8ab5aa71274e362$export$cafe23194e65f591;
module.exports["processRawValue"] = $c8ab5aa71274e362$export$f1a0a61081c3ed62;
module.exports["processRawFragmentValue"] = $c8ab5aa71274e362$export$89b7989c347e6a7b;

});

parcelRegister("hbEec", function(module, exports) {
const $5f601bcc1718fb0b$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
module.exports["isEmpty"] = $5f601bcc1718fb0b$export$dd1bc94b04021eeb;

});

parcelRegister("inmjk", function(module, exports) {
const $c51384942fa452cc$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });
module.exports["tableCell"] = $c51384942fa452cc$export$e1e720e5f4603e6a;

});

parcelRegister("8WrQo", function(module, exports) {
const $e620d19b8ea2ca65$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });
module.exports["tableRow"] = $e620d19b8ea2ca65$export$ce666bf02318c957;

});

parcelRegister("sxTNo", function(module, exports) {

var $id9O1 = parcelRequire("id9O1");

const $77ca0e272ecd92cd$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
const $77ca0e272ecd92cd$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
const $77ca0e272ecd92cd$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $id9O1.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};
const $77ca0e272ecd92cd$export$103fe177194b9cb8 = (schema)=>{
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    if (!table || !tableCell || !tableHeader) return false;
    // Check if table cells can contain table nodes by testing their content match
    const tableCellCanContainTable = tableCell.contentMatch.matchType(table)?.validEnd === true;
    const tableHeaderCanContainTable = tableHeader.contentMatch.matchType(table)?.validEnd === true;
    return tableCellCanContainTable || tableHeaderCanContainTable;
};
module.exports["getParentOfTypeCount"] = $77ca0e272ecd92cd$export$d5cbd8b17958f08b;
module.exports["getPositionAfterTopParentNodeOfType"] = $77ca0e272ecd92cd$export$ae584b8f0be37f04;
module.exports["isSelectionTableNestedInTable"] = $77ca0e272ecd92cd$export$3dd46fa6c35aa514;
module.exports["isNestedTablesSupported"] = $77ca0e272ecd92cd$export$103fe177194b9cb8;

});

parcelRegister("id9O1", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $LmqWp = parcelRequire("LmqWp");

const $3161ce52b09cb4d1$export$1ae6a0a4f7784fc4 = (selection)=>(0, $8m4tT.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $3161ce52b09cb4d1$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $8m4tT.findParentNodeClosestToPos)($pos, predicate);
};
const $3161ce52b09cb4d1$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $8m4tT.findParentNodeClosestToPos)($pos, predicate);
};
const $3161ce52b09cb4d1$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $3161ce52b09cb4d1$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $3161ce52b09cb4d1$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};
module.exports["findTable"] = $3161ce52b09cb4d1$export$1ae6a0a4f7784fc4;
module.exports["findTableClosestToPos"] = $3161ce52b09cb4d1$export$9323c80f9a3e899f;
module.exports["findCellClosestToPos"] = $3161ce52b09cb4d1$export$3ac56532a0bf4018;
module.exports["findCellRectClosestToPos"] = $3161ce52b09cb4d1$export$68680ae223aebfa7;

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("7541v", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe99912880d9fde$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $ebe99912880d9fde$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $42omo.useRef)(initialValue);
    (0, $42omo.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("2pjJ5", function(module, exports) {

var $3FxV8 = parcelRequire("3FxV8");


var $aXG5V = parcelRequire("aXG5V");


var $1oCLl = parcelRequire("1oCLl");


var $kTbzR = parcelRequire("kTbzR");

const $a5f7a02a123b6264$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            const docSize = transaction.doc.content.size;
            from = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(newStart < from || from === -1 ? newStart : from, 0, docSize);
            to = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(newEnd > to || to === -1 ? newEnd : to, 0, docSize);
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $a5f7a02a123b6264$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $a5f7a02a123b6264$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $kTbzR.isEmptyParagraph)(nodeChild);
}
function $a5f7a02a123b6264$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $a5f7a02a123b6264$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $a5f7a02a123b6264$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $a5f7a02a123b6264$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $a5f7a02a123b6264$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $a5f7a02a123b6264$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $a5f7a02a123b6264$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $a5f7a02a123b6264$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $a5f7a02a123b6264$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $a5f7a02a123b6264$export$fd9c3e0f31aab835(tr) {
    return $a5f7a02a123b6264$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}
const $a5f7a02a123b6264$export$b81ebf241519dbe1 = (transactions, oldState)=>{
    return transactions.some((tr)=>{
        if (tr.getMeta('replaceDocument')) return true;
        const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
            if (!(step instanceof (0, $aXG5V.ReplaceStep))) return false;
            const isStepReplacingFromDocStart = step.from === 0;
            const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
            if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
            return true;
        });
        return hasStepReplacingEntireDocument;
    });
};
function $a5f7a02a123b6264$var$marksEqualInOrder(m1, m2) {
    if (m1.length !== m2.length) return false;
    return m1.every((m, i)=>m.eq(m2[i]));
}
function $a5f7a02a123b6264$var$marksEqualIgnoringOrder(m1, m2) {
    if (m1.length !== m2.length) return false;
    const m2Used = new Set();
    for (const mark1 of m1){
        const idx = m2.findIndex((mark2, i)=>!m2Used.has(i) && mark1.eq(mark2));
        if (idx === -1) return false;
        m2Used.add(idx);
    }
    return true;
}
function $a5f7a02a123b6264$export$e3b603f98921291f(node1, node2, attributesToIgnore, opts) {
    const ignoreMarkOrder = opts?.ignoreMarkOrder ?? (0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true);
    if (node1.isText) {
        if (ignoreMarkOrder) return node1.text === node2.text && $a5f7a02a123b6264$var$marksEqualIgnoringOrder(node1.marks, node2.marks);
        return node1.eq(node2);
    }
    const marksEqual = ignoreMarkOrder ? $a5f7a02a123b6264$var$marksEqualIgnoringOrder(node1.marks, node2.marks) : $a5f7a02a123b6264$var$marksEqualInOrder(node1.marks, node2.marks);
    // If no attributes to ignore, compare all attributes
    if (!attributesToIgnore || attributesToIgnore.length === 0) {
        if ((0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true)) return node1 === node2 || node1.hasMarkup(node2.type, node1.attrs, node1.marks) && marksEqual && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content, undefined, opts);
        else return node1 === node2 || node1.hasMarkup(node2.type, node1.attrs, node2.marks) && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content);
    }
    // Build attrs to compare by excluding ignored attributes
    const attrsToCompare = (0, $1oCLl.expValEquals)('platform_editor_show_diff_fix_missing_attrs', 'isEnabled', true) ? {
        ...node2.attrs
    } : node2.attrs;
    const ignoreSet = new Set(attributesToIgnore);
    for(const key in node2.attrs)if (ignoreSet.has(key)) attrsToCompare[key] = node1.attrs[key];
    if ((0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true)) return node1 === node2 || node1.type === node2.type && node1.hasMarkup(node2.type, attrsToCompare, node1.marks) && marksEqual && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content, attributesToIgnore, opts);
    else return node1 === node2 || node1.hasMarkup(node2.type, attrsToCompare, node2.marks) && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content, attributesToIgnore);
}
function $a5f7a02a123b6264$var$areFragmentsEqual(frag1, frag2, attributesToIgnore, opts) {
    if (frag1.content.length !== frag2.content.length) return false;
    let childrenEqual = true;
    frag1.content.forEach((child, i)=>{
        const otherChild = frag2.child(i);
        if (child === otherChild || otherChild && $a5f7a02a123b6264$export$e3b603f98921291f(child, otherChild, attributesToIgnore, opts)) return;
        childrenEqual = false;
    });
    return childrenEqual;
}
module.exports["getStepRange"] = $a5f7a02a123b6264$export$c8e611b6ac095e6d;
module.exports["hasDocAsParent"] = $a5f7a02a123b6264$export$f76a7d770092ea11;
module.exports["isEmptyDocument"] = $a5f7a02a123b6264$export$2da47a16c0b6bcb;
module.exports["bracketTyped"] = $a5f7a02a123b6264$export$df0539d254c75c33;
module.exports["nodesBetweenChanged"] = $a5f7a02a123b6264$export$f9e52d2e832a6aae;
module.exports["hasVisibleContent"] = $a5f7a02a123b6264$export$c9083db5521330d3;
module.exports["isSelectionEndOfParagraph"] = $a5f7a02a123b6264$export$435c1d4e61a8723b;
module.exports["getChangedNodes"] = $a5f7a02a123b6264$export$fd9c3e0f31aab835;
module.exports["isReplaceDocOperation"] = $a5f7a02a123b6264$export$b81ebf241519dbe1;
module.exports["areNodesEqualIgnoreAttrs"] = $a5f7a02a123b6264$export$e3b603f98921291f;

});

parcelRegister("3FxV8", function(module, exports) {

var $bCMS0 = parcelRequire("bCMS0");


var $abOaY = parcelRequire("abOaY");

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $2abf835653f9d26a$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $abOaY(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $abOaY(lower);
        lower = lower === lower ? lower : 0;
    }
    return $bCMS0($abOaY(number), lower, upper);
}
module.exports = $2abf835653f9d26a$var$clamp;

});

parcelRegister("kTbzR", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");


var $4vlwG = parcelRequire("4vlwG");

function $ab19fe955bb1fbb0$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $ab19fe955bb1fbb0$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $ab19fe955bb1fbb0$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$ab19fe955bb1fbb0$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $ab19fe955bb1fbb0$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $aXG5V.ReplaceStep)) && !(step instanceof (0, $aXG5V.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $ab19fe955bb1fbb0$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $ks2lK.TextSelection);
const $ab19fe955bb1fbb0$export$5588122b9eea7733 = (element)=>{
    return (0, $4vlwG.closest)(element, 'td, th');
};
const $ab19fe955bb1fbb0$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $ab19fe955bb1fbb0$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $ab19fe955bb1fbb0$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $ab19fe955bb1fbb0$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $ks2lK.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $ab19fe955bb1fbb0$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $7XFGZ.CellSelection).create(state.doc, anchor, head)));
}
function $ab19fe955bb1fbb0$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $ab19fe955bb1fbb0$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $ab19fe955bb1fbb0$export$2de06a6e688827fd = (state)=>{
    return (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $ab19fe955bb1fbb0$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $ab19fe955bb1fbb0$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($ab19fe955bb1fbb0$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $ab19fe955bb1fbb0$var$not = (fn)=>(arg)=>!fn(arg);
module.exports["isEmptyParagraph"] = $ab19fe955bb1fbb0$export$b648602b09795358;
module.exports["stepHasSlice"] = $ab19fe955bb1fbb0$export$53780b185b887309;
module.exports["stepAddsOneOf"] = $ab19fe955bb1fbb0$export$f4d51ccab05f55c9;
module.exports["extractSliceFromStep"] = $ab19fe955bb1fbb0$export$d0a9dfe2556a9577;
module.exports["isTextSelection"] = $ab19fe955bb1fbb0$export$38b50bf35e79aaf3;
module.exports["isElementInTableCell"] = $ab19fe955bb1fbb0$export$5588122b9eea7733;
module.exports["isLastItemMediaGroup"] = $ab19fe955bb1fbb0$export$142c0ee6457f50d6;
module.exports["setNodeSelection"] = $ab19fe955bb1fbb0$export$a367515ca2c9ace1;
module.exports["setTextSelection"] = $ab19fe955bb1fbb0$export$1df6d14df6b0b758;
module.exports["nonNullable"] = $ab19fe955bb1fbb0$export$26128561c93f5847;
module.exports["isValidPosition"] = $ab19fe955bb1fbb0$export$de0495c7bd37bf4e;
module.exports["isInLayoutColumn"] = $ab19fe955bb1fbb0$export$2de06a6e688827fd;
module.exports["filterChildrenBetween"] = $ab19fe955bb1fbb0$export$e46323d96cf32194;
module.exports["removeBlockMarks"] = $ab19fe955bb1fbb0$export$fba8af3b998832b9;

});

parcelRegister("ftzrq", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

const $b4450e5745e49325$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $b4450e5745e49325$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $b4450e5745e49325$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $b4450e5745e49325$var$textRange = function(node, from, to) {
    let range = $b4450e5745e49325$var$reusedRange || ($b4450e5745e49325$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $b4450e5745e49325$var$clearReusedRange = function() {
    $b4450e5745e49325$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $b4450e5745e49325$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, -1) || $b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $b4450e5745e49325$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, dir) {
    var _a;
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $b4450e5745e49325$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $b4450e5745e49325$var$hasBlockDesc(node) || $b4450e5745e49325$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $b4450e5745e49325$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (child.nodeType == 1 && child.contentEditable == "false") {
                if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection) off += dir;
                else return false;
            } else {
                node = child;
                off = dir < 0 ? $b4450e5745e49325$var$nodeSize(node) : 0;
            }
        } else return false;
    }
}
function $b4450e5745e49325$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b4450e5745e49325$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $b4450e5745e49325$var$nodeSize(node);
        } else if (node.parentNode && !$b4450e5745e49325$var$hasBlockDesc(node)) {
            offset = $b4450e5745e49325$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $b4450e5745e49325$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$b4450e5745e49325$var$hasBlockDesc(node)) {
            offset = $b4450e5745e49325$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $b4450e5745e49325$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $b4450e5745e49325$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $b4450e5745e49325$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $b4450e5745e49325$var$nodeSize(node);
    }
}
function $b4450e5745e49325$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $b4450e5745e49325$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $b4450e5745e49325$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $b4450e5745e49325$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $b4450e5745e49325$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $b4450e5745e49325$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($b4450e5745e49325$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($b4450e5745e49325$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $b4450e5745e49325$var$nav = typeof navigator != "undefined" ? navigator : null;
const $b4450e5745e49325$var$doc = typeof document != "undefined" ? document : null;
const $b4450e5745e49325$var$agent = $b4450e5745e49325$var$nav && $b4450e5745e49325$var$nav.userAgent || "";
const $b4450e5745e49325$var$ie_edge = /Edge\/(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie_upto10 = /MSIE \d/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie = !!($b4450e5745e49325$var$ie_upto10 || $b4450e5745e49325$var$ie_11up || $b4450e5745e49325$var$ie_edge);
const $b4450e5745e49325$var$ie_version = $b4450e5745e49325$var$ie_upto10 ? document.documentMode : $b4450e5745e49325$var$ie_11up ? +$b4450e5745e49325$var$ie_11up[1] : $b4450e5745e49325$var$ie_edge ? +$b4450e5745e49325$var$ie_edge[1] : 0;
const $b4450e5745e49325$var$gecko = !$b4450e5745e49325$var$ie && /gecko\/(\d+)/i.test($b4450e5745e49325$var$agent);
$b4450e5745e49325$var$gecko && (/Firefox\/(\d+)/.exec($b4450e5745e49325$var$agent) || [
    0,
    0
])[1];
const $b4450e5745e49325$var$_chrome = !$b4450e5745e49325$var$ie && /Chrome\/(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$chrome = !!$b4450e5745e49325$var$_chrome;
const $b4450e5745e49325$var$chrome_version = $b4450e5745e49325$var$_chrome ? +$b4450e5745e49325$var$_chrome[1] : 0;
const $b4450e5745e49325$var$safari = !$b4450e5745e49325$var$ie && !!$b4450e5745e49325$var$nav && /Apple Computer/.test($b4450e5745e49325$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $b4450e5745e49325$var$ios = $b4450e5745e49325$var$safari && (/Mobile\/\w+/.test($b4450e5745e49325$var$agent) || !!$b4450e5745e49325$var$nav && $b4450e5745e49325$var$nav.maxTouchPoints > 2);
const $b4450e5745e49325$var$mac = $b4450e5745e49325$var$ios || ($b4450e5745e49325$var$nav ? /Mac/.test($b4450e5745e49325$var$nav.platform) : false);
const $b4450e5745e49325$var$windows = $b4450e5745e49325$var$nav ? /Win/.test($b4450e5745e49325$var$nav.platform) : false;
const $b4450e5745e49325$var$android = /Android \d/.test($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$webkit = !!$b4450e5745e49325$var$doc && "webkitFontSmoothing" in $b4450e5745e49325$var$doc.documentElement.style;
const $b4450e5745e49325$var$webkit_version = $b4450e5745e49325$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $b4450e5745e49325$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $b4450e5745e49325$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $b4450e5745e49325$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $b4450e5745e49325$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;;){
        if (!parent) break;
        if (parent.nodeType != 1) {
            parent = $b4450e5745e49325$var$parentNode(parent);
            continue;
        }
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $b4450e5745e49325$var$windowRect(doc) : $b4450e5745e49325$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $b4450e5745e49325$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $b4450e5745e49325$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $b4450e5745e49325$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $b4450e5745e49325$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $b4450e5745e49325$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $b4450e5745e49325$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $b4450e5745e49325$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $b4450e5745e49325$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $b4450e5745e49325$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        let pos = atTop ? "fixed" : getComputedStyle(parent).position;
        if (/^(fixed|sticky)$/.test(pos)) break;
        parent = pos == "absolute" ? parent.offsetParent : $b4450e5745e49325$var$parentNode(parent);
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $b4450e5745e49325$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $b4450e5745e49325$var$scrollStack(view.dom)
    };
}
function $b4450e5745e49325$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $b4450e5745e49325$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $b4450e5745e49325$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $b4450e5745e49325$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $b4450e5745e49325$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $b4450e5745e49325$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $b4450e5745e49325$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($b4450e5745e49325$var$preventScrollSupported) return dom.focus($b4450e5745e49325$var$preventScrollSupported);
    let stored = $b4450e5745e49325$var$scrollStack(dom);
    dom.focus($b4450e5745e49325$var$preventScrollSupported == null ? {
        get preventScroll () {
            $b4450e5745e49325$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$b4450e5745e49325$var$preventScrollSupported) {
        $b4450e5745e49325$var$preventScrollSupported = false;
        $b4450e5745e49325$var$restoreScrollStack(stored, 0);
    }
}
function $b4450e5745e49325$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $b4450e5745e49325$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $b4450e5745e49325$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $b4450e5745e49325$var$findOffsetInNode(closest, coordsClosest);
}
function $b4450e5745e49325$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange(), result;
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $b4450e5745e49325$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($b4450e5745e49325$var$inRect(coords, rect)) {
            result = {
                node: node,
                offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
            };
            break;
        }
    }
    range.detach();
    return result || {
        node: node,
        offset: 0
    };
}
function $b4450e5745e49325$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $b4450e5745e49325$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $b4450e5745e49325$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $b4450e5745e49325$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $b4450e5745e49325$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $b4450e5745e49325$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($b4450e5745e49325$var$inRect(coords, rect)) return $b4450e5745e49325$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $b4450e5745e49325$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $b4450e5745e49325$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$b4450e5745e49325$var$inRect(coords, box)) return null;
        elt = $b4450e5745e49325$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($b4450e5745e49325$var$safari) {
        for(let p = elt; node && p; p = $b4450e5745e49325$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $b4450e5745e49325$var$targetKludge(elt, coords);
    if (node) {
        if ($b4450e5745e49325$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($b4450e5745e49325$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $b4450e5745e49325$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $b4450e5745e49325$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $b4450e5745e49325$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $b4450e5745e49325$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($b4450e5745e49325$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $b4450e5745e49325$var$nonZero) || target.getBoundingClientRect();
}
const $b4450e5745e49325$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $b4450e5745e49325$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $b4450e5745e49325$var$webkit || $b4450e5745e49325$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($b4450e5745e49325$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($b4450e5745e49325$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $b4450e5745e49325$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $b4450e5745e49325$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $b4450e5745e49325$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $b4450e5745e49325$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $b4450e5745e49325$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $b4450e5745e49325$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $b4450e5745e49325$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $b4450e5745e49325$var$textRange(before, $b4450e5745e49325$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $b4450e5745e49325$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $b4450e5745e49325$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(node.nodeType == 3 ? $b4450e5745e49325$var$textRange(node) : node, -side), side >= 0);
}
function $b4450e5745e49325$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $b4450e5745e49325$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $b4450e5745e49325$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $b4450e5745e49325$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $b4450e5745e49325$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $b4450e5745e49325$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $b4450e5745e49325$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $b4450e5745e49325$var$maybeRTL = /[\u0590-\u08ac]/;
function $b4450e5745e49325$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$b4450e5745e49325$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $b4450e5745e49325$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $b4450e5745e49325$var$cachedState = null;
let $b4450e5745e49325$var$cachedDir = null;
let $b4450e5745e49325$var$cachedResult = false;
function $b4450e5745e49325$var$endOfTextblock(view, state, dir) {
    if ($b4450e5745e49325$var$cachedState == state && $b4450e5745e49325$var$cachedDir == dir) return $b4450e5745e49325$var$cachedResult;
    $b4450e5745e49325$var$cachedState = state;
    $b4450e5745e49325$var$cachedDir = dir;
    return $b4450e5745e49325$var$cachedResult = dir == "up" || dir == "down" ? $b4450e5745e49325$var$endOfTextblockVertical(view, state, dir) : $b4450e5745e49325$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $b4450e5745e49325$var$NOT_DIRTY = 0, $b4450e5745e49325$var$CHILD_DIRTY = 1, $b4450e5745e49325$var$CONTENT_DIRTY = 2, $b4450e5745e49325$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $b4450e5745e49325$var$ViewDesc {
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $b4450e5745e49325$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)for(let i = 0; i < child.children.length; i++){
                    let inner = child.children[i];
                    if (inner.size) {
                        child = inner;
                        break;
                    }
                }
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $b4450e5745e49325$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $b4450e5745e49325$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $b4450e5745e49325$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $b4450e5745e49325$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $b4450e5745e49325$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $b4450e5745e49325$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($b4450e5745e49325$var$gecko || $b4450e5745e49325$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $b4450e5745e49325$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($b4450e5745e49325$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $b4450e5745e49325$var$safari) && $b4450e5745e49325$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $b4450e5745e49325$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !(brKludge && $b4450e5745e49325$var$gecko)) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $b4450e5745e49325$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    get ignoreForSelection() {
        return false;
    }
    isText(text) {
        return false;
    }
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $b4450e5745e49325$var$WidgetViewDesc extends $b4450e5745e49325$var$ViewDesc {
    matchesWidget(widget) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get ignoreForSelection() {
        return !!this.widget.type.spec.relaxedSide;
    }
    get side() {
        return this.widget.type.side;
    }
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
}
class $b4450e5745e49325$var$CompositionViewDesc extends $b4450e5745e49325$var$ViewDesc {
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $b4450e5745e49325$var$MarkViewDesc extends $b4450e5745e49325$var$ViewDesc {
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $5SAOw.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $b4450e5745e49325$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $b4450e5745e49325$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $b4450e5745e49325$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $b4450e5745e49325$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $b4450e5745e49325$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $b4450e5745e49325$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $b4450e5745e49325$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $b4450e5745e49325$var$NodeViewDesc extends $b4450e5745e49325$var$ViewDesc {
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $5SAOw.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $b4450e5745e49325$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $b4450e5745e49325$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $b4450e5745e49325$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $b4450e5745e49325$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $5SAOw.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && node.eq(this.node) && $b4450e5745e49325$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $b4450e5745e49325$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $b4450e5745e49325$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view, i);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $5SAOw.Mark).none : this.node.child(i).marks, inline, view, i);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view, i);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view, 0);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $b4450e5745e49325$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $b4450e5745e49325$var$renderDescs(this.contentDOM, this.children, view);
            if ($b4450e5745e49325$var$ios) $b4450e5745e49325$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $ks2lK.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $b4450e5745e49325$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $b4450e5745e49325$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $b4450e5745e49325$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($b4450e5745e49325$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $b4450e5745e49325$var$patchOuterDeco(this.dom, this.nodeDOM, $b4450e5745e49325$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $b4450e5745e49325$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.add("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.draggable = true;
        }
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $b4450e5745e49325$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $b4450e5745e49325$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $b4450e5745e49325$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $b4450e5745e49325$var$TextViewDesc extends $b4450e5745e49325$var$NodeViewDesc {
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY || this.dirty != $b4450e5745e49325$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $b4450e5745e49325$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $b4450e5745e49325$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $b4450e5745e49325$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $b4450e5745e49325$var$TrailingHackViewDesc extends $b4450e5745e49325$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $b4450e5745e49325$var$CustomNodeViewDesc extends $b4450e5745e49325$var$NodeViewDesc {
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $b4450e5745e49325$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $b4450e5745e49325$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $b4450e5745e49325$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $b4450e5745e49325$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $b4450e5745e49325$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $b4450e5745e49325$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$b4450e5745e49325$var$OuterDecoLevel.prototype = Object.create(null);
const $b4450e5745e49325$var$noDeco = [
    new $b4450e5745e49325$var$OuterDecoLevel
];
function $b4450e5745e49325$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $b4450e5745e49325$var$noDeco;
    let top = needsWrap ? $b4450e5745e49325$var$noDeco[0] : new $b4450e5745e49325$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $b4450e5745e49325$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $b4450e5745e49325$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $b4450e5745e49325$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $b4450e5745e49325$var$noDeco && curComputed == $b4450e5745e49325$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $b4450e5745e49325$var$noDeco[0];
                curDOM = parent;
            }
        }
        $b4450e5745e49325$var$patchAttributes(curDOM, prev || $b4450e5745e49325$var$noDeco[0], deco);
    }
    return curDOM;
}
function $b4450e5745e49325$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $b4450e5745e49325$var$applyOuterDeco(dom, deco, node) {
    return $b4450e5745e49325$var$patchOuterDeco(dom, dom, $b4450e5745e49325$var$noDeco, $b4450e5745e49325$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $b4450e5745e49325$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $b4450e5745e49325$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $b4450e5745e49325$var$ViewTreeUpdater {
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view, parentIndex) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $b4450e5745e49325$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1, scanTo = this.top.children.length;
            if (parentIndex < this.preMatch.index) scanTo = Math.min(this.index + 3, scanTo);
            for(let i = this.index; i < scanTo; i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $b4450e5745e49325$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $b4450e5745e49325$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $b4450e5745e49325$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $b4450e5745e49325$var$NODE_DIRTY && $b4450e5745e49325$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $b4450e5745e49325$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$b4450e5745e49325$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $b4450e5745e49325$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $b4450e5745e49325$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $b4450e5745e49325$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $b4450e5745e49325$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $b4450e5745e49325$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($b4450e5745e49325$var$safari || $b4450e5745e49325$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $b4450e5745e49325$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $b4450e5745e49325$var$preMatch(top.node.content, top);
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes.
function $b4450e5745e49325$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $b4450e5745e49325$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $b4450e5745e49325$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $b4450e5745e49325$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($b4450e5745e49325$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $b4450e5745e49325$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $b4450e5745e49325$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $b4450e5745e49325$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $b4450e5745e49325$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($b4450e5745e49325$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $ks2lK.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $b4450e5745e49325$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $ks2lK.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $b4450e5745e49325$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $b4450e5745e49325$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $b4450e5745e49325$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $b4450e5745e49325$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $b4450e5745e49325$var$syncNodeSelection(view, sel);
    if (!$b4450e5745e49325$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $b4450e5745e49325$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $b4450e5745e49325$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $b4450e5745e49325$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($b4450e5745e49325$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $ks2lK.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $b4450e5745e49325$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $b4450e5745e49325$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($b4450e5745e49325$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $b4450e5745e49325$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $b4450e5745e49325$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $b4450e5745e49325$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $b4450e5745e49325$var$brokenSelectBetweenUneditable = $b4450e5745e49325$var$safari || $b4450e5745e49325$var$chrome && $b4450e5745e49325$var$chrome_version < 63;
function $b4450e5745e49325$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($b4450e5745e49325$var$safari && after && after.contentEditable == "false") return $b4450e5745e49325$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $b4450e5745e49325$var$setEditable(after);
        else if (before) return $b4450e5745e49325$var$setEditable(before);
    }
}
function $b4450e5745e49325$var$setEditable(element) {
    element.contentEditable = "true";
    if ($b4450e5745e49325$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $b4450e5745e49325$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $b4450e5745e49325$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$b4450e5745e49325$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $b4450e5745e49325$var$selectCursorWrapper(view) {
    let domSel = view.domSelection();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) domSel.collapse(node.parentNode, $b4450e5745e49325$var$domIndex(node) + 1);
    else domSel.collapse(node, 0);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $b4450e5745e49325$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $ks2lK.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $b4450e5745e49325$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $b4450e5745e49325$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $b4450e5745e49325$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $b4450e5745e49325$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $ks2lK.TextSelection).between($anchor, $head, bias);
}
function $b4450e5745e49325$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $b4450e5745e49325$var$hasSelection(view);
}
function $b4450e5745e49325$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $b4450e5745e49325$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $b4450e5745e49325$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $b4450e5745e49325$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $ks2lK.Selection).findFrom($start, dir);
}
function $b4450e5745e49325$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $b4450e5745e49325$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $ks2lK.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $ks2lK.NodeSelection)) return $b4450e5745e49325$var$apply(view, next);
            return false;
        } else if (!($b4450e5745e49325$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $ks2lK.NodeSelection).isSelectable(node)) return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($b4450e5745e49325$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $ks2lK.NodeSelection) && sel.node.isInline) return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
        if (next) return $b4450e5745e49325$var$apply(view, next);
        return false;
    }
}
function $b4450e5745e49325$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b4450e5745e49325$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $b4450e5745e49325$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $b4450e5745e49325$var$skipIgnoredNodesBefore(view) : $b4450e5745e49325$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $b4450e5745e49325$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($b4450e5745e49325$var$gecko && node.nodeType == 1 && offset < $b4450e5745e49325$var$nodeLen(node) && $b4450e5745e49325$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($b4450e5745e49325$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($b4450e5745e49325$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $b4450e5745e49325$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $b4450e5745e49325$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $b4450e5745e49325$var$nodeLen(node);
            }
        }
    }
    if (force) $b4450e5745e49325$var$setSelFocus(view, node, offset);
    else if (moveNode) $b4450e5745e49325$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $b4450e5745e49325$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $b4450e5745e49325$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($b4450e5745e49325$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($b4450e5745e49325$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $b4450e5745e49325$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $b4450e5745e49325$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $b4450e5745e49325$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $b4450e5745e49325$var$setSelFocus(view, moveNode, moveOffset);
}
function $b4450e5745e49325$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $b4450e5745e49325$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$b4450e5745e49325$var$hasBlockDesc(node)){
        offset = $b4450e5745e49325$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $b4450e5745e49325$var$textNodeBefore(node, offset) {
    while(node && !offset && !$b4450e5745e49325$var$hasBlockDesc(node)){
        offset = $b4450e5745e49325$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $b4450e5745e49325$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $b4450e5745e49325$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $b4450e5745e49325$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($b4450e5745e49325$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $b4450e5745e49325$var$selectionToDOM(view);
    }, 50);
}
function $b4450e5745e49325$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($b4450e5745e49325$var$chrome || $b4450e5745e49325$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $b4450e5745e49325$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $ks2lK.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($b4450e5745e49325$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $ks2lK.NodeSelection)) return $b4450e5745e49325$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $ks2lK.AllSelection) ? (0, $ks2lK.Selection).near(side, dir) : (0, $ks2lK.Selection).findFrom(side, dir);
        return beyond ? $b4450e5745e49325$var$apply(view, beyond) : false;
    }
    return false;
}
function $b4450e5745e49325$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $ks2lK.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $b4450e5745e49325$var$safariDownArrowBug(view) {
    if (!$b4450e5745e49325$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $b4450e5745e49325$var$switchEditable(view, child, "true");
        setTimeout(()=>$b4450e5745e49325$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $b4450e5745e49325$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $b4450e5745e49325$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $b4450e5745e49325$var$getMods(event);
    if (code == 8 || $b4450e5745e49325$var$mac && code == 72 && mods == "c") return $b4450e5745e49325$var$stopNativeHorizontalDelete(view, -1) || $b4450e5745e49325$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $b4450e5745e49325$var$mac && code == 68 && mods == "c") return $b4450e5745e49325$var$stopNativeHorizontalDelete(view, 1) || $b4450e5745e49325$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $b4450e5745e49325$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $b4450e5745e49325$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $b4450e5745e49325$var$selectHorizontally(view, dir, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $b4450e5745e49325$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $b4450e5745e49325$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $b4450e5745e49325$var$selectHorizontally(view, dir, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $b4450e5745e49325$var$mac && code == 80 && mods == "c") return $b4450e5745e49325$var$selectVertically(view, -1, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $b4450e5745e49325$var$mac && code == 78 && mods == "c") return $b4450e5745e49325$var$safariDownArrowBug(view) || $b4450e5745e49325$var$selectVertically(view, 1, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, 1);
    else if (mods == ($b4450e5745e49325$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $b4450e5745e49325$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $5SAOw.DOMSerializer).fromSchema(view.state.schema);
    let doc = $b4450e5745e49325$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $b4450e5745e49325$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $b4450e5745e49325$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = !!text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) {
            slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0);
            view.someProp("transformPasted", (f)=>{
                slice = f(slice, view, true);
            });
            return slice;
        }
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $5SAOw.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $b4450e5745e49325$var$readHTML(html);
        if ($b4450e5745e49325$var$webkit) $b4450e5745e49325$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $5SAOw.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$b4450e5745e49325$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $b4450e5745e49325$var$addContext($b4450e5745e49325$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $5SAOw.Slice).maxOpen($b4450e5745e49325$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $b4450e5745e49325$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, asText);
    });
    return slice;
}
const $b4450e5745e49325$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $b4450e5745e49325$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $b4450e5745e49325$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $b4450e5745e49325$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $5SAOw.Fragment).from(result);
    }
    return fragment;
}
function $b4450e5745e49325$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $5SAOw.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $5SAOw.Fragment).from($b4450e5745e49325$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $b4450e5745e49325$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $b4450e5745e49325$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $5SAOw.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $b4450e5745e49325$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $b4450e5745e49325$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $5SAOw.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $b4450e5745e49325$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $5SAOw.Slice)($b4450e5745e49325$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $5SAOw.Slice)($b4450e5745e49325$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $b4450e5745e49325$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $b4450e5745e49325$var$_detachedDoc = null;
function $b4450e5745e49325$var$detachedDoc() {
    return $b4450e5745e49325$var$_detachedDoc || ($b4450e5745e49325$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $b4450e5745e49325$var$_policy = null;
function $b4450e5745e49325$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$b4450e5745e49325$var$_policy) $b4450e5745e49325$var$_policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $b4450e5745e49325$var$_policy.createHTML(html);
}
function $b4450e5745e49325$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $b4450e5745e49325$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $b4450e5745e49325$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $b4450e5745e49325$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $b4450e5745e49325$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($b4450e5745e49325$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $b4450e5745e49325$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $5SAOw.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $5SAOw.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $b4450e5745e49325$var$handlers = {};
const $b4450e5745e49325$var$editHandlers = {};
const $b4450e5745e49325$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $b4450e5745e49325$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: "",
            button: 0
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        this.badSafariComposition = false;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $b4450e5745e49325$var$initInput(view) {
    for(let event in $b4450e5745e49325$var$handlers){
        let handler = $b4450e5745e49325$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($b4450e5745e49325$var$eventBelongsToView(view, event) && !$b4450e5745e49325$var$runCustomHandler(view, event) && (view.editable || !(event.type in $b4450e5745e49325$var$editHandlers))) handler(view, event);
        }, $b4450e5745e49325$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($b4450e5745e49325$var$safari) view.dom.addEventListener("input", ()=>null);
    $b4450e5745e49325$var$ensureListeners(view);
}
function $b4450e5745e49325$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $b4450e5745e49325$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $b4450e5745e49325$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$b4450e5745e49325$var$runCustomHandler(view, event));
    });
}
function $b4450e5745e49325$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $b4450e5745e49325$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $b4450e5745e49325$var$dispatchEvent(view, event) {
    if (!$b4450e5745e49325$var$runCustomHandler(view, event) && $b4450e5745e49325$var$handlers[event.type] && (view.editable || !(event.type in $b4450e5745e49325$var$editHandlers))) $b4450e5745e49325$var$handlers[event.type](view, event);
}
$b4450e5745e49325$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($b4450e5745e49325$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($b4450e5745e49325$var$android && $b4450e5745e49325$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($b4450e5745e49325$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $b4450e5745e49325$var$captureKeyDown(view, event)) event.preventDefault();
    else $b4450e5745e49325$var$setSelectionOrigin(view, "key");
};
$b4450e5745e49325$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$b4450e5745e49325$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($b4450e5745e49325$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $b4450e5745e49325$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $ks2lK.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        let deflt = ()=>view.state.tr.insertText(text).scrollIntoView();
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text, deflt))) view.dispatch(deflt());
        event.preventDefault();
    }
};
function $b4450e5745e49325$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $b4450e5745e49325$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $b4450e5745e49325$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $b4450e5745e49325$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $b4450e5745e49325$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $ks2lK.NodeSelection).isSelectable(node)) {
        $b4450e5745e49325$var$updateSelection(view, new (0, $ks2lK.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $ks2lK.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $ks2lK.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $b4450e5745e49325$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $b4450e5745e49325$var$selectClickedNode(view, inside) : $b4450e5745e49325$var$selectClickedLeaf(view, inside));
}
function $b4450e5745e49325$var$handleDoubleClick(view, pos, inside, event) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $b4450e5745e49325$var$handleTripleClick(view, pos, inside, event) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $b4450e5745e49325$var$defaultTripleClick(view, inside, event);
}
function $b4450e5745e49325$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $ks2lK.NodeSelection).isSelectable(node)) $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $b4450e5745e49325$var$forceDOMFlush(view) {
    return $b4450e5745e49325$var$endComposition(view);
}
const $b4450e5745e49325$var$selectNodeModifier = $b4450e5745e49325$var$mac ? "metaKey" : "ctrlKey";
$b4450e5745e49325$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $b4450e5745e49325$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $b4450e5745e49325$var$isNear(event, view.input.lastClick) && !event[$b4450e5745e49325$var$selectNodeModifier] && view.input.lastClick.button == event.button) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type,
        button: event.button
    };
    let pos = view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $b4450e5745e49325$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $b4450e5745e49325$var$handleDoubleClick : $b4450e5745e49325$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
class $b4450e5745e49325$var$MouseDown {
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$b4450e5745e49325$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
        else if ($b4450e5745e49325$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $b4450e5745e49325$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $b4450e5745e49325$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $b4450e5745e49325$var$updateSelection(this.view, (0, $ks2lK.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$b4450e5745e49325$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.nodeDOM.nodeType == 1 ? targetDesc.nodeDOM : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $ks2lK.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $b4450e5745e49325$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
    }
}
$b4450e5745e49325$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $b4450e5745e49325$var$forceDOMFlush(view);
    $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
$b4450e5745e49325$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
$b4450e5745e49325$var$handlers.contextmenu = (view)=>$b4450e5745e49325$var$forceDOMFlush(view);
function $b4450e5745e49325$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($b4450e5745e49325$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $b4450e5745e49325$var$timeoutComposition = $b4450e5745e49325$var$android ? 5000 : -1;
$b4450e5745e49325$var$editHandlers.compositionstart = $b4450e5745e49325$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $ks2lK.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false) || $b4450e5745e49325$var$chrome && $b4450e5745e49325$var$windows && $b4450e5745e49325$var$selectionBeforeUneditable(view))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $b4450e5745e49325$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $b4450e5745e49325$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($b4450e5745e49325$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $b4450e5745e49325$var$scheduleComposeEnd(view, $b4450e5745e49325$var$timeoutComposition);
};
function $b4450e5745e49325$var$selectionBeforeUneditable(view) {
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (!focusNode || focusNode.nodeType != 1 || focusOffset >= focusNode.childNodes.length) return false;
    let next = focusNode.childNodes[focusOffset];
    return next.nodeType == 1 && next.contentEditable == "false";
}
$b4450e5745e49325$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.badSafariComposition) view.domObserver.forceFlush();
        else if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $b4450e5745e49325$var$scheduleComposeEnd(view, 20);
    }
};
function $b4450e5745e49325$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$b4450e5745e49325$var$endComposition(view), delay);
}
function $b4450e5745e49325$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $b4450e5745e49325$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $b4450e5745e49325$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $b4450e5745e49325$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $b4450e5745e49325$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $b4450e5745e49325$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $b4450e5745e49325$var$endComposition(view, restarting = false) {
    if ($b4450e5745e49325$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $b4450e5745e49325$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $b4450e5745e49325$var$selectionFromDOM(view), cur = view.state.selection;
        if (sel && !sel.eq(cur)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $b4450e5745e49325$var$brokenClipboardAPI = $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version < 15 || $b4450e5745e49325$var$ios && $b4450e5745e49325$var$webkit_version < 604;
$b4450e5745e49325$var$handlers.copy = $b4450e5745e49325$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $b4450e5745e49325$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $b4450e5745e49325$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $b4450e5745e49325$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $b4450e5745e49325$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $b4450e5745e49325$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $b4450e5745e49325$var$doPaste(view, target.value, null, plain, event);
        else $b4450e5745e49325$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $b4450e5745e49325$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $b4450e5745e49325$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $5SAOw.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $b4450e5745e49325$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $b4450e5745e49325$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$b4450e5745e49325$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$b4450e5745e49325$var$android) return;
    let data = $b4450e5745e49325$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $b4450e5745e49325$var$doPaste(view, $b4450e5745e49325$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $b4450e5745e49325$var$capturePaste(view, event);
};
class $b4450e5745e49325$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $b4450e5745e49325$var$dragCopyModifier = $b4450e5745e49325$var$mac ? "altKey" : "ctrlKey";
function $b4450e5745e49325$var$dragMoves(view, event) {
    let moves = view.someProp("dragCopies", (test)=>!test(event));
    return moves != null ? moves : !event[$b4450e5745e49325$var$dragCopyModifier];
}
$b4450e5745e49325$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $ks2lK.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $ks2lK.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $ks2lK.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $b4450e5745e49325$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$b4450e5745e49325$var$chrome || $b4450e5745e49325$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($b4450e5745e49325$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$b4450e5745e49325$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $b4450e5745e49325$var$Dragging(slice, $b4450e5745e49325$var$dragMoves(view, event), node);
};
$b4450e5745e49325$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$b4450e5745e49325$var$editHandlers.dragover = $b4450e5745e49325$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$b4450e5745e49325$var$editHandlers.drop = (view, event)=>{
    try {
        $b4450e5745e49325$var$handleDrop(view, event, view.dragging);
    } finally{
        view.dragging = null;
    }
};
function $b4450e5745e49325$var$handleDrop(view, event, dragging) {
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, false);
    });
    else slice = $b4450e5745e49325$var$parseFromClipboard(view, $b4450e5745e49325$var$getText(event.dataTransfer), $b4450e5745e49325$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && $b4450e5745e49325$var$dragMoves(view, event));
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $5SAOw.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $aXG5V.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $ks2lK.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $ks2lK.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($b4450e5745e49325$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
}
$b4450e5745e49325$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $b4450e5745e49325$var$selectionToDOM(view);
        }, 20);
    }
};
$b4450e5745e49325$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$b4450e5745e49325$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($b4450e5745e49325$var$chrome && $b4450e5745e49325$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $b4450e5745e49325$var$editHandlers)$b4450e5745e49325$var$handlers[prop] = $b4450e5745e49325$var$editHandlers[prop];
function $b4450e5745e49325$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $b4450e5745e49325$var$WidgetType {
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $b4450e5745e49325$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $b4450e5745e49325$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
        this.side = this.spec.side || 0;
    }
}
class $b4450e5745e49325$var$InlineType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $b4450e5745e49325$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$InlineType && $b4450e5745e49325$var$compareObjs(this.attrs, other.attrs) && $b4450e5745e49325$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $b4450e5745e49325$var$InlineType;
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
    }
}
class $b4450e5745e49325$var$NodeType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $b4450e5745e49325$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$NodeType && $b4450e5745e49325$var$compareObjs(this.attrs, other.attrs) && $b4450e5745e49325$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
    }
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $b4450e5745e49325$export$10e30b733df217ea {
    /**
    @internal
    */ copy(from, to) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(pos, pos, new $b4450e5745e49325$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, new $b4450e5745e49325$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, new $b4450e5745e49325$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $b4450e5745e49325$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $b4450e5745e49325$var$WidgetType;
    }
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
}
const $b4450e5745e49325$var$none = [], $b4450e5745e49325$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $b4450e5745e49325$export$93bf62eb445cec98 {
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $b4450e5745e49325$var$buildTree(decorations, doc, 0, $b4450e5745e49325$var$noSpec) : $b4450e5745e49325$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $b4450e5745e49325$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $b4450e5745e49325$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $b4450e5745e49325$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $b4450e5745e49325$export$93bf62eb445cec98(newLocal.sort($b4450e5745e49325$var$byPos), $b4450e5745e49325$var$none) : $b4450e5745e49325$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $b4450e5745e49325$var$empty) return $b4450e5745e49325$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $b4450e5745e49325$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $b4450e5745e49325$var$buildTree(found, childNode, baseOffset + 1, $b4450e5745e49325$var$noSpec));
            childIndex += 3;
        });
        let local = $b4450e5745e49325$var$moveSpans(childIndex ? $b4450e5745e49325$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $b4450e5745e49325$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($b4450e5745e49325$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $b4450e5745e49325$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $b4450e5745e49325$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $b4450e5745e49325$export$93bf62eb445cec98(local, children) : $b4450e5745e49325$var$empty;
    }
    forChild(offset, node) {
        if (this == $b4450e5745e49325$var$empty) return this;
        if (node.isLeaf) return $b4450e5745e49325$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $b4450e5745e49325$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $b4450e5745e49325$export$93bf62eb445cec98(local.sort($b4450e5745e49325$var$byPos), $b4450e5745e49325$var$none);
            return child ? new $b4450e5745e49325$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $b4450e5745e49325$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $b4450e5745e49325$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $b4450e5745e49325$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $b4450e5745e49325$var$empty) return $b4450e5745e49325$var$none;
        if (node.inlineContent || !this.local.some($b4450e5745e49325$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $b4450e5745e49325$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $b4450e5745e49325$var$none;
        this.children = children.length ? children : $b4450e5745e49325$var$none;
    }
}
/**
The empty set of decorations.
*/ $b4450e5745e49325$export$93bf62eb445cec98.empty = new $b4450e5745e49325$export$93bf62eb445cec98([], []);
/**
@internal
*/ $b4450e5745e49325$export$93bf62eb445cec98.removeOverlap = $b4450e5745e49325$var$removeOverlap;
const $b4450e5745e49325$var$empty = $b4450e5745e49325$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $b4450e5745e49325$var$DecorationGroup {
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $b4450e5745e49325$var$noSpec));
        return $b4450e5745e49325$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $b4450e5745e49325$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $b4450e5745e49325$var$empty) continue;
            if (result instanceof $b4450e5745e49325$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $b4450e5745e49325$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $b4450e5745e49325$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $b4450e5745e49325$var$removeOverlap(sorted ? result : result.sort($b4450e5745e49325$var$byPos)) : $b4450e5745e49325$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $b4450e5745e49325$var$empty;
            case 1:
                return members[0];
            default:
                return new $b4450e5745e49325$var$DecorationGroup(members.every((m)=>m instanceof $b4450e5745e49325$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $b4450e5745e49325$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
    constructor(members){
        this.members = members;
    }
}
function $b4450e5745e49325$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $b4450e5745e49325$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $b4450e5745e49325$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $b4450e5745e49325$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $b4450e5745e49325$export$93bf62eb445cec98(newLocal.sort($b4450e5745e49325$var$byPos), children);
}
function $b4450e5745e49325$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $b4450e5745e49325$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $b4450e5745e49325$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $b4450e5745e49325$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $b4450e5745e49325$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $b4450e5745e49325$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $b4450e5745e49325$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $b4450e5745e49325$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $b4450e5745e49325$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $b4450e5745e49325$var$moveSpans(hasNulls ? $b4450e5745e49325$var$withoutNulls(spans) : spans, -offset).sort($b4450e5745e49325$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $b4450e5745e49325$export$93bf62eb445cec98(locals, children) : $b4450e5745e49325$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $b4450e5745e49325$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $b4450e5745e49325$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $b4450e5745e49325$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $b4450e5745e49325$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $b4450e5745e49325$var$insertAhead(array, i, deco) {
    while(i < array.length && $b4450e5745e49325$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $b4450e5745e49325$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $b4450e5745e49325$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($b4450e5745e49325$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $b4450e5745e49325$var$DecorationGroup.from(found);
}
const $b4450e5745e49325$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $b4450e5745e49325$var$useCharData = $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11;
class $b4450e5745e49325$var$SelectionState {
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
}
class $b4450e5745e49325$var$DOMObserver {
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $b4450e5745e49325$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$b4450e5745e49325$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $b4450e5745e49325$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $b4450e5745e49325$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $b4450e5745e49325$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $b4450e5745e49325$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $b4450e5745e49325$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($b4450e5745e49325$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $b4450e5745e49325$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        } else if (($b4450e5745e49325$var$chrome || $b4450e5745e49325$var$safari) && added.some((n)=>n.nodeName == "BR") && (view.input.lastKeyCode == 8 || view.input.lastKeyCode == 46)) {
            // Chrome/Safari sometimes insert a bogus break node if you
            // backspace out the last bit of text before an inline-flex node (#1552)
            for (let node of added)if (node.nodeName == "BR" && node.parentNode) {
                let after = node.nextSibling;
                if (after && after.nodeType == 1 && after.contentEditable == "false") node.parentNode.removeChild(node);
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $b4450e5745e49325$var$selectionCollapsed(sel) && (readSel = $b4450e5745e49325$var$selectionFromDOM(view)) && readSel.eq((0, $ks2lK.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $b4450e5745e49325$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $b4450e5745e49325$var$checkCSS(view);
            }
            if (view.input.badSafariComposition) {
                view.input.badSafariComposition = false;
                $b4450e5745e49325$var$fixUpBadSafariComposition(view, added);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $b4450e5745e49325$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $b4450e5745e49325$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $b4450e5745e49325$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $b4450e5745e49325$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            this.flushSoon();
            else if ($b4450e5745e49325$var$safari && view.composing && mutations.some((m)=>m.type == "childList" && m.target.nodeName == "TR")) {
                // Safari does weird stuff when finishing a composition in a
                // table cell, which tends to involve inserting inappropriate
                // nodes in the table row.
                view.input.badSafariComposition = true;
                this.flushSoon();
            } else this.flush();
        });
        if ($b4450e5745e49325$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
}
let $b4450e5745e49325$var$cssChecked = new WeakMap();
let $b4450e5745e49325$var$cssCheckWarned = false;
function $b4450e5745e49325$var$checkCSS(view) {
    if ($b4450e5745e49325$var$cssChecked.has(view)) return;
    $b4450e5745e49325$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $b4450e5745e49325$var$gecko;
        if ($b4450e5745e49325$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $b4450e5745e49325$var$cssCheckWarned = true;
    }
}
function $b4450e5745e49325$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($b4450e5745e49325$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $b4450e5745e49325$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $b4450e5745e49325$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $b4450e5745e49325$var$rangeToSelectionRange(view, found) : null;
}
function $b4450e5745e49325$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Kludge for a Safari bug where, on ending a composition in an
// otherwise empty table cell, it randomly moves the composed text
// into the table row around that cell, greatly confusing everything
// (#188).
function $b4450e5745e49325$var$fixUpBadSafariComposition(view, addedNodes) {
    var _a;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    for (let node of addedNodes)if (((_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName) == "TR") {
        let nextCell = node.nextSibling;
        while(nextCell && nextCell.nodeName != "TD" && nextCell.nodeName != "TH")nextCell = nextCell.nextSibling;
        if (nextCell) {
            let parent = nextCell;
            for(;;){
                let first = parent.firstChild;
                if (!first || first.nodeType != 1 || first.contentEditable == "false" || /^(BR|IMG)$/.test(first.nodeName)) break;
                parent = first;
            }
            parent.insertBefore(node, parent.firstChild);
            if (focusNode == node) view.domSelection().collapse(node, focusOffset);
        } else node.parentNode.removeChild(node);
    }
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $b4450e5745e49325$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$b4450e5745e49325$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($b4450e5745e49325$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $5SAOw.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $b4450e5745e49325$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $b4450e5745e49325$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($b4450e5745e49325$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $b4450e5745e49325$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $b4450e5745e49325$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $b4450e5745e49325$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $b4450e5745e49325$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($b4450e5745e49325$var$chrome && $b4450e5745e49325$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $b4450e5745e49325$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $b4450e5745e49325$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($b4450e5745e49325$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $b4450e5745e49325$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$b4450e5745e49325$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $ks2lK.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $b4450e5745e49325$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $ks2lK.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($b4450e5745e49325$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && $from.pos < $to.pos && !/\S/.test(parse.doc.textBetween($from.pos, $to.pos, "", ""))) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $b4450e5745e49325$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(8, "Backspace")))) {
        if ($b4450e5745e49325$var$android && $b4450e5745e49325$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($b4450e5745e49325$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($b4450e5745e49325$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $b4450e5745e49325$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let mkTr = (base)=>{
        let tr = base || view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
        if (parse.sel) {
            let sel = $b4450e5745e49325$var$resolveSelection(view, tr.doc, parse.sel);
            // Chrome will sometimes, during composition, report the
            // selection in the wrong place. If it looks like that is
            // happening, don't update the selection.
            // Edge just doesn't move the cursor forward when you start typing
            // in an empty block or between br nodes.
            if (sel && !($b4450e5745e49325$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $b4450e5745e49325$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
        }
        if (compositionID) tr.setMeta("composition", compositionID);
        return tr.scrollIntoView();
    };
    let markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$b4450e5745e49325$var$selectionToDOM(view), 20);
            }
            let tr = mkTr(view.state.tr.delete(chFrom, chTo));
            let marks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
            if (marks) tr.ensureMarks(marks);
            view.dispatch(tr);
        } else if (change.endA == change.endB && (markChange = $b4450e5745e49325$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            let tr = mkTr(view.state.tr);
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
            view.dispatch(tr);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            let deflt = ()=>mkTr(view.state.tr.insertText(text, chFrom, chTo));
            if (!view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text, deflt))) view.dispatch(deflt());
        } else view.dispatch(mkTr());
    } else view.dispatch(mkTr());
}
function $b4450e5745e49325$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $b4450e5745e49325$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $b4450e5745e49325$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $5SAOw.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $b4450e5745e49325$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $b4450e5745e49325$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($b4450e5745e49325$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $b4450e5745e49325$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $b4450e5745e49325$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $b4450e5745e49325$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $b4450e5745e49325$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $b4450e5745e49325$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $b4450e5745e49325$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $b4450e5745e49325$export$5d42ca91c11c9e4d = $b4450e5745e49325$var$parseFromClipboard;
/**
@internal
*/ const $b4450e5745e49325$export$76b14d3c719c32fc = $b4450e5745e49325$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $b4450e5745e49325$export$eece2fccabbb77c5 {
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $b4450e5745e49325$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($b4450e5745e49325$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $b4450e5745e49325$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $b4450e5745e49325$var$buildNodeViews(this);
            if ($b4450e5745e49325$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $b4450e5745e49325$var$ensureListeners(this);
        this.editable = $b4450e5745e49325$var$getEditable(this);
        $b4450e5745e49325$var$updateCursorWrapper(this);
        let innerDeco = $b4450e5745e49325$var$viewDecorations(this), outerDeco = $b4450e5745e49325$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $b4450e5745e49325$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($b4450e5745e49325$var$ie || $b4450e5745e49325$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $b4450e5745e49325$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $b4450e5745e49325$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $b4450e5745e49325$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $b4450e5745e49325$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && (!this.trackWrites || !this.dom.contains(this.trackWrites))) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $b4450e5745e49325$var$anchorInRightPlace(this))) $b4450e5745e49325$var$selectionToDOM(this, forceSelUpdate);
            else {
                $b4450e5745e49325$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $b4450e5745e49325$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $ks2lK.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $b4450e5745e49325$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $b4450e5745e49325$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $b4450e5745e49325$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $ks2lK.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($b4450e5745e49325$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $b4450e5745e49325$var$focusPreventScroll(this.dom);
        $b4450e5745e49325$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $b4450e5745e49325$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $b4450e5745e49325$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $b4450e5745e49325$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $b4450e5745e49325$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $b4450e5745e49325$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */ serializeForClipboard(slice) {
        return $b4450e5745e49325$var$serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $b4450e5745e49325$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $b4450e5745e49325$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $b4450e5745e49325$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $b4450e5745e49325$var$dispatchEvent(this, event);
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $b4450e5745e49325$var$safari && this.root.nodeType === 11 && $b4450e5745e49325$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $b4450e5745e49325$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $b4450e5745e49325$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($b4450e5745e49325$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $b4450e5745e49325$var$getEditable(this);
        $b4450e5745e49325$var$updateCursorWrapper(this);
        this.nodeViews = $b4450e5745e49325$var$buildNodeViews(this);
        this.docView = $b4450e5745e49325$var$docViewDesc(this.state.doc, $b4450e5745e49325$var$computeDocDeco(this), $b4450e5745e49325$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $b4450e5745e49325$var$DOMObserver(this, (from, to, typeOver, added)=>$b4450e5745e49325$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $b4450e5745e49325$var$initInput(this);
        this.updatePluginViews();
    }
}
$b4450e5745e49325$export$eece2fccabbb77c5.prototype.dispatch = function(tr) {
    let dispatchTransaction = this._props.dispatchTransaction;
    if (dispatchTransaction) dispatchTransaction.call(this, tr);
    else this.updateState(this.state.apply(tr));
};
function $b4450e5745e49325$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $b4450e5745e49325$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $b4450e5745e49325$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $b4450e5745e49325$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $b4450e5745e49325$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $b4450e5745e49325$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $b4450e5745e49325$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $b4450e5745e49325$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $b4450e5745e49325$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}
module.exports["Decoration"] = $b4450e5745e49325$export$10e30b733df217ea;
module.exports["DecorationSet"] = $b4450e5745e49325$export$93bf62eb445cec98;
module.exports["EditorView"] = $b4450e5745e49325$export$eece2fccabbb77c5;

});

parcelRegister("dSVmA", function(module, exports) {
class $9e998316eee14f1b$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}
module.exports["ErrorReporter"] = $9e998316eee14f1b$export$88da0ac32d9c271e;

});

parcelRegister("jy7VG", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");
parcelRequire("cO9ey");


const $ac637565ff8c8557$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $ac637565ff8c8557$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $ac637565ff8c8557$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($ac637565ff8c8557$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $ac637565ff8c8557$var$createUndoEvent(analyticsEvent) {
    return {
        ...analyticsEvent,
        payload: {
            action: "undid",
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: analyticsEvent.payload.attributes?.inputMethod || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $ac637565ff8c8557$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === "undid" ? "redid" : "undid"
        }
    });
function $ac637565ff8c8557$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === "undid" || event.payload.action === "redid";
}
class $ac637565ff8c8557$export$cc33374693c7fb23 extends (0, $aXG5V.Step) {
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($ac637565ff8c8557$var$isHistoryAnalyticsEvent(analyticsEvent)) return $ac637565ff8c8557$var$toggleEventAction(analyticsEvent);
            else return $ac637565ff8c8557$var$createUndoEvent(analyticsEvent);
        });
        return new $ac637565ff8c8557$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $ac637565ff8c8557$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $aXG5V.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $aXG5V.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $ac637565ff8c8557$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $ac637565ff8c8557$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $ac637565ff8c8557$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        this.analyticsEvents = [];
        this.pos = void 0;
        this.actionsToIgnore = [];
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $aXG5V.Step).jsonID($ac637565ff8c8557$export$9126078e8b0f76e4, $ac637565ff8c8557$export$cc33374693c7fb23);
module.exports["AnalyticsStep"] = $ac637565ff8c8557$export$cc33374693c7fb23;

});

parcelRegister("cO9ey", function(module, exports) {
$parcel$export(module.exports, "Step", () => (parcelRequire("aXG5V")).Step);

var $aXG5V = parcelRequire("aXG5V");

// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $8d16e4fcc5d7c76f$var$originalFromJSON = (0, $aXG5V.Step).fromJSON;
(0, $aXG5V.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $8d16e4fcc5d7c76f$var$originalFromJSON(schema, jsonStep);
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});

parcelRegister("h3X17", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ 
var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $8z9j5 = parcelRequire("8z9j5");

var $f0c66da303fc9af9$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $f0c66da303fc9af9$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $f0c66da303fc9af9$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $f0c66da303fc9af9$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $f0c66da303fc9af9$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $f0c66da303fc9af9$export$15875d5e8ce4fd42 = 'telepointer-pulse-during-tr';
const $f0c66da303fc9af9$export$cea3f62f94f5fdf0 = 7500; // Keeping it longer so it'll be easier to spot during transactions
const $f0c66da303fc9af9$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $f0c66da303fc9af9$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $9K4OG.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}10%{transform:scaleX(1.4);opacity:1;}15%,85%{transform:scaleX(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}@keyframes pulseInDuringTr{0%,95%{transform:scaleX(1);opacity:1;}100%{transform:scaleX(0);opacity:0;}}@keyframes pulseOutDuringTr{100%{transform:scaleX(1);opacity:1;}0%,90%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $aFUXX.participantColors).map((participantColor, index)=>$f0c66da303fc9af9$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $f0c66da303fc9af9$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2.5s ease-in-out;}.telepointer-fullname{animation:pulseIn 2.5s ease-in-out;}}&.", $f0c66da303fc9af9$export$15875d5e8ce4fd42, "{.telepointer-initial{animation:pulseOutDuringTr ", $f0c66da303fc9af9$export$cea3f62f94f5fdf0, "ms ease-in-out;}.telepointer-fullname{animation:pulseInDuringTr ", $f0c66da303fc9af9$export$cea3f62f94f5fdf0, "ms ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $f0c66da303fc9af9$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $f0c66da303fc9af9$var$tintKey = 'collab:isDirtyTransaction';
const $f0c66da303fc9af9$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($f0c66da303fc9af9$var$tintKey));
};
const $f0c66da303fc9af9$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($f0c66da303fc9af9$var$tintKey, true);
};
module.exports["PROVIDER_ERROR_CODE"] = $f0c66da303fc9af9$export$54cb529986e2487b;
module.exports["DisconnectReason"] = $f0c66da303fc9af9$export$258d16488300d83f;
module.exports["TELEPOINTER_DIM_CLASS"] = $f0c66da303fc9af9$export$75f1e2b0ae2c8197;
module.exports["TELEPOINTER_PULSE_CLASS"] = $f0c66da303fc9af9$export$44ee82a2b1106d13;
module.exports["TELEPOINTER_PULSE_DURING_TR_CLASS"] = $f0c66da303fc9af9$export$15875d5e8ce4fd42;
module.exports["TELEPOINTER_PULSE_DURING_TR_DURATION_MS"] = $f0c66da303fc9af9$export$cea3f62f94f5fdf0;
module.exports["TELEPOINTER_DATA_SESSION_ID_ATTR"] = $f0c66da303fc9af9$export$74788e2dc4d9be50;
module.exports["isDirtyTransaction"] = $f0c66da303fc9af9$export$c500b1bc696a0abc;
module.exports["tintDirtyTransaction"] = $f0c66da303fc9af9$export$f25182515d14d793;

});

parcelRegister("adhil", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $1gpr6 = parcelRequire("1gpr6");

var $51f4ad1a1d4c86a3$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd = 'gapcursor';
class $51f4ad1a1d4c86a3$export$7d98c58ca1423246 extends (0, $ks2lK.Selection) {
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $1gpr6.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $1gpr6.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, this.side) : (0, $ks2lK.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $51f4ad1a1d4c86a3$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $5SAOw.Slice).empty;
    }
    getBookmark() {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
    /**
   * Construct a GapCursorSelection
   * @param {ResolvedPos} $pos resolved position
   * @param {Side} side side where the gap cursor is drawn
   */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side;
        this.visible = false;
    }
}
(0, $ks2lK.Selection).jsonID($51f4ad1a1d4c86a3$export$d9f9f34e18094ffd, $51f4ad1a1d4c86a3$export$7d98c58ca1423246);
class $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos) : (0, $ks2lK.Selection).near($pos);
    }
    constructor(pos){
        this.pos = pos;
    }
}
module.exports["Side"] = $51f4ad1a1d4c86a3$export$80a00690bda7f17e;
module.exports["JSON_ID"] = $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd;
module.exports["GapCursorSelection"] = $51f4ad1a1d4c86a3$export$7d98c58ca1423246;

});

parcelRegister("1gpr6", function(module, exports) {

var $4Wd8f = parcelRequire("4Wd8f");

const $27b8041df1cc92a4$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $4Wd8f.isIgnored)(node);
};
module.exports["isValidTargetNode"] = $27b8041df1cc92a4$export$b485b49b5e1715ef;

});

parcelRegister("4Wd8f", function(module, exports) {
// we don't show gap cursor for those nodes
const $f3b25ae2912922b3$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $f3b25ae2912922b3$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $f3b25ae2912922b3$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};
module.exports["isIgnored"] = $f3b25ae2912922b3$export$ac3f691269cd6d9b;

});

parcelRegister("gAARK", function(module, exports) {
const $42341a766fe51017$export$5937600f4cc784f0 = 24;
const $42341a766fe51017$export$71d660e8ca5b8f73 = 320;
const $42341a766fe51017$export$cd11d7d46412c89b = 3;
const $42341a766fe51017$export$71482734bb54ac3 = 10;
const $42341a766fe51017$export$fd2b09475ada41cc = 12;
const $42341a766fe51017$export$8c5ac0b0c62a3d21 = 8;
const $42341a766fe51017$export$68d0abe4f03863fb = $42341a766fe51017$export$fd2b09475ada41cc * 2;
const $42341a766fe51017$export$d722b7527b1834a8 = 250;
const $42341a766fe51017$export$da894f7669b4e67c = 200;
const $42341a766fe51017$export$e13825c38da2ce1 = 100;
var $42341a766fe51017$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $42341a766fe51017$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $42341a766fe51017$export$4d41d008e9cd4f34 = 0.5;
const $42341a766fe51017$export$b4b560efd3c61856 = 'caption-placeholder';
module.exports["MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH"] = $42341a766fe51017$export$5937600f4cc784f0;
module.exports["MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH"] = $42341a766fe51017$export$71d660e8ca5b8f73;
module.exports["MEDIA_SINGLE_SNAP_GAP"] = $42341a766fe51017$export$cd11d7d46412c89b;
module.exports["MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN"] = $42341a766fe51017$export$8c5ac0b0c62a3d21;
module.exports["MEDIA_SINGLE_GUTTER_SIZE"] = $42341a766fe51017$export$68d0abe4f03863fb;
module.exports["DEFAULT_IMAGE_WIDTH"] = $42341a766fe51017$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $42341a766fe51017$export$da894f7669b4e67c;
module.exports["MEDIA_SINGLE_RESIZE_THROTTLE_TIME"] = $42341a766fe51017$export$e13825c38da2ce1;
module.exports["wrappedLayouts"] = $42341a766fe51017$export$405baca3d8bc263d;
module.exports["DEFAULT_ROUNDING_INTERVAL"] = $42341a766fe51017$export$4d41d008e9cd4f34;
module.exports["CAPTION_PLACEHOLDER_ID"] = $42341a766fe51017$export$b4b560efd3c61856;

});

parcelRegister("fDGbV", function(module, exports) {
const $fdb0bbe11c94f00f$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};
module.exports["getDimensionsWithDefault"] = $fdb0bbe11c94f00f$export$36acad525b1fb57b;

});

parcelRegister("8jrlU", function(module, exports) {
const $dba4e4fdcb4b1deb$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';
module.exports["newFileExperienceClassName"] = $dba4e4fdcb4b1deb$export$c5ba918dbb0b00f3;

});

parcelRegister("8hoW2", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $e7ebf0f9c8a3aecb$var$ToolbarUIContext = /*#__PURE__*/ (0, $42omo.createContext)({
    onDropdownOpenChanged: ()=>{},
    preventDefaultOnMouseDown: false,
    isDisabled: false,
    popupsMountPoint: undefined,
    fireAnalyticsEvent: undefined,
    keyboardNavigation: undefined
});
const $e7ebf0f9c8a3aecb$export$e7063f2520f6adf8 = ()=>{
    const context = (0, $42omo.useContext)($e7ebf0f9c8a3aecb$var$ToolbarUIContext);
    if (!context) throw new Error('useToolbarUI must be used within ToolbarUIContext');
    return context;
};
const $e7ebf0f9c8a3aecb$export$ae8c3f290017c42a = ({ children: children, onDropdownOpenChanged: onDropdownOpenChanged, preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($e7ebf0f9c8a3aecb$var$ToolbarUIContext.Provider, {
        // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            preventDefaultOnMouseDown: preventDefaultOnMouseDown,
            isDisabled: isDisabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            keyboardNavigation: keyboardNavigation
        },
        children: children
    });
};
module.exports["useToolbarUI"] = $e7ebf0f9c8a3aecb$export$e7063f2520f6adf8;
module.exports["ToolbarUIProvider"] = $e7ebf0f9c8a3aecb$export$ae8c3f290017c42a;

});

parcelRegister("kDB94", function(module, exports) {
/* ToolbarButtonGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $434d40eb1243ca8a$var$styles = {
    container: "_1e0c1txw",
    containerNew: "_zulpv77o _1e0c1txw _14jy1dpa",
    firstChild: "_fb2512x7 _t1diidpf _u6eridpf",
    lastChild: "_fb2512x7 _xk07idpf _1jiyidpf",
    firstChildNew: "_19pe12x7 _1qq0idpf _3nesidpf",
    lastChildNew: "_19pe12x7 _15rdidpf _i84vidpf"
};
const $434d40eb1243ca8a$export$89cfa2b8585c6d03 = ({ children: children })=>{
    const items = (0, $42omo.Children).toArray(children); //  The .at() method is a relatively newer JavaScript API (ES2022) that isn't supported in older browsers
    //  Using items[i] is more compatible with older browsers.
    const FirstChild = (0, $dh538.fg)('platform_editor_fix_t_at_is_not_a_function') ? items[0] : items.at(0);
    const LastChild = (0, $dh538.fg)('platform_editor_fix_t_at_is_not_a_function') ? items[items.length - 1] : items.at(-1);
    const middleChildren = items.slice(1, -1);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1oCLl.expValEquals)('platform_editor_toolbar_split_button_ui', 'isEnabled', true) ? $434d40eb1243ca8a$var$styles.containerNew : $434d40eb1243ca8a$var$styles.container,
        "data-toolbar-component": "button-group",
        children: items.length <= 1 ? children : /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $434d40eb1243ca8a$var$styles.firstChildNew
                    ]),
                    children: FirstChild
                }),
                middleChildren,
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $434d40eb1243ca8a$var$styles.lastChildNew
                    ]),
                    children: LastChild
                })
            ]
        })
    });
};
module.exports["ToolbarButtonGroup"] = $434d40eb1243ca8a$export$89cfa2b8585c6d03;

});

parcelRegister("6UWPx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ahaN7 = parcelRequire("ahaN7");

const $d5fbcc29f1830e26$export$3e60ddf10b9269e3 = ({ children: children, hasSeparator: hasSeparator, title: title, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
        hasSeparator: hasSeparator,
        title: title,
        "data-toolbar-component": "menu-section",
        testId: testId,
        children: children
    });
};
module.exports["ToolbarDropdownItemSection"] = $d5fbcc29f1830e26$export$3e60ddf10b9269e3;

});

parcelRegister("48SU7", function(module, exports) {
/* ToolbarSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $fe6774c5ada59ba1$export$90683802e28416b5 = /*#__PURE__*/ function(SeparatorPosition) {
    SeparatorPosition["START"] = "start";
    SeparatorPosition["END"] = "end";
    return SeparatorPosition;
}({});
const $fe6774c5ada59ba1$var$styles = {
    container: "_zulp1b66 _1e0c1txw _4cvr1h6o"
};
const $fe6774c5ada59ba1$var$separator = null;
const $fe6774c5ada59ba1$var$marginInlineOverridden = null;
const $fe6774c5ada59ba1$var$ToolbarSeparator = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-toolbar-component": "separator",
        role: "separator",
        "aria-orientation": "vertical",
        className: (0, $gMc0m.default)([
            "_195gu2gc _4t3igktf _1bsbt94y _bfhk1l7x",
            "_1p9bv77o"
        ])
    });
};
const $fe6774c5ada59ba1$export$b978f6a1bb31af67 = ({ children: children, testId: testId, hasSeparator: hasSeparator })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($fe6774c5ada59ba1$var$styles.container),
        testId: testId,
        "data-toolbar-component": "section",
        children: [
            hasSeparator === "start" && /*#__PURE__*/ (0, $l998X.jsx)($fe6774c5ada59ba1$var$ToolbarSeparator, {}),
            children,
            hasSeparator === "end" && /*#__PURE__*/ (0, $l998X.jsx)($fe6774c5ada59ba1$var$ToolbarSeparator, {})
        ]
    });
};
module.exports["SeparatorPosition"] = $fe6774c5ada59ba1$export$90683802e28416b5;
module.exports["ToolbarSection"] = $fe6774c5ada59ba1$export$b978f6a1bb31af67;

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});

parcelRegister("8Yr6I", function(module, exports) {
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $jDv0c = parcelRequire("jDv0c");


var $fhsiz = parcelRequire("fhsiz");


var $40rXS = parcelRequire("40rXS");


var $aGYoD = parcelRequire("aGYoD");


var $2s0fd = parcelRequire("2s0fd");

/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $eEA8O = parcelRequire("eEA8O");


var $7yDmn = parcelRequire("7yDmn");





var $8hpYf = parcelRequire("8hpYf");


var $gdv5Z = parcelRequire("gdv5Z");

const $15bff58016f1db5c$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $15bff58016f1db5c$var$deleteButton = null; /**
                            * Test id for wrapper Emoji delete button
                            */ 
const $15bff58016f1db5c$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $15bff58016f1db5c$var$DeleteButton = (props)=>/*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $8hpYf.emojiDeleteButton)
        ]),
        "data-testid": $15bff58016f1db5c$export$28fc7374cf1206d4
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        iconBefore: /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $15bff58016f1db5c$var$styles.boxWrapperStyle
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
            label: (0, $fhsiz.deleteEmojiLabel),
            color: "var(--ds-text-subtle, #505258)",
            size: "small"
        })),
        onClick: props.onClick,
        appearance: "subtle-link",
        spacing: "none",
        testId: "emoji-delete-button",
        tabIndex: -1
    }));
var $15bff58016f1db5c$export$2e2bcd8739ae039 = $15bff58016f1db5c$var$DeleteButton;






var $7ZWaV = parcelRequire("7ZWaV");

var $li2rw = parcelRequire("li2rw");

const $84c1b8f7f63755a9$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $84c1b8f7f63755a9$var$result.mac = /Mac/.test(navigator.platform);
    $84c1b8f7f63755a9$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $84c1b8f7f63755a9$export$2e2bcd8739ae039 = $84c1b8f7f63755a9$var$result;



var $iHQDd = parcelRequire("iHQDd");


const $4afe8d0fbb54ce53$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $iHQDd.useInView)(options);
    if (!(0, $84c1b8f7f63755a9$export$2e2bcd8739ae039).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};









var $aXWIB = parcelRequire("aXWIB");


var $8Tx5v = parcelRequire("8Tx5v");

/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
const $e0f713ebdd24b6b6$export$1ea584ca7009bcc1 = $e0f713ebdd24b6b6$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $e0f713ebdd24b6b6$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $e0f713ebdd24b6b6$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $e0f713ebdd24b6b6$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $e0f713ebdd24b6b6$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $e0f713ebdd24b6b6$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $84c1b8f7f63755a9$export$2e2bcd8739ae039).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $e0f713ebdd24b6b6$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $84c1b8f7f63755a9$export$2e2bcd8739ae039).mac ? '' : '+');
}


const $eebf84ec71e736ed$var$tooltipShortcutStyle = null;
const $eebf84ec71e736ed$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $e0f713ebdd24b6b6$export$384a290f8c265cc5)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_2rkofajl _bfhk1vck _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
        ])
    }, shortcut)) : null;
});




var $6F6hl = parcelRequire("6F6hl");

const $c17b194a67025173$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eebf84ec71e736ed$export$c7308f5f9ed494ac), {
        description: formatMessage((0, $8Tx5v.messages).deleteEmojiTooltip),
        keymap: (0, $e0f713ebdd24b6b6$export$1ea584ca7009bcc1)
    });
};
const $c17b194a67025173$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        id: `screenreader-emoji-${emoji.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $8Tx5v.messages).deleteEmojiTooltipForScreenreader,
        values: {
            shortName: emoji.shortName
        }
    }));
};



var $1oCLl = parcelRequire("1oCLl");


var $dh538 = parcelRequire("dh538");




const $fef7a087c7f9d9ab$var$emojiSpriteContainer = null;
const $fef7a087c7f9d9ab$var$emojiImageContainer = null;
const $fef7a087c7f9d9ab$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $fhsiz.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $2s0fd.leftClick)(event)) onSelected((0, $40rXS.toEmojiId)(emoji), emoji, event);
};
const $fef7a087c7f9d9ab$var$handleKeyDown = (props, event)=>{
    if (!(0, $fhsiz.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $fhsiz.KeyboardKeys).Enter || event.key === (0, $fhsiz.KeyboardKeys).Space)) onSelected((0, $40rXS.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $fhsiz.KeyboardKeys).Backspace) $fef7a087c7f9d9ab$var$handleDelete(props, event);
};
const $fef7a087c7f9d9ab$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $40rXS.toEmojiId)(emoji), emoji, event);
};
const $fef7a087c7f9d9ab$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $40rXS.toEmojiId)(emoji), emoji, event);
};
const $fef7a087c7f9d9ab$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $40rXS.toEmojiId)(emoji), emoji, event);
};
const $fef7a087c7f9d9ab$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props; // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $40rXS.toEmojiId)(emoji), emoji, event);
}; // Pure functional components are used in favour of class based components, due to the performance!
const $fef7a087c7f9d9ab$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $8hpYf.emojiNodeStyles)} ${selected ? (0, $8hpYf.commonSelectedStyles) : ''} ${selectOnHover ? (0, $8hpYf.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) {
        if ((0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) sizing = {
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        else sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
    }
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fef7a087c7f9d9ab$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $8hpYf.emojiSprite),
        style: style
    })));
}; // Keep as pure functional component, see renderAsSprite.
const $fef7a087c7f9d9ab$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $4afe8d0fbb54ce53$export$2f62ee6831462844)({
        triggerOnce: true
    });
    const ufoExp = (0, $42omo.useMemo)(()=>(0, $7ZWaV.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $8hpYf.emojiMainStyle)} ${(0, $8hpYf.emojiNodeStyles)} ${selected ? (0, $8hpYf.commonSelectedStyles) : ''} ${selectOnHover ? (0, $8hpYf.selectOnHoverStyles) : ''} ${(0, $8hpYf.emojiImage)} ${className ? className : ''} ${showDelete ? (0, $8hpYf.deletableEmoji) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $jDv0c.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $40rXS.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $40rXS.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width; // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onError = (0, $42omo.useCallback)((event)=>{
        $fef7a087c7f9d9ab$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onLoad = (0, $42omo.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $aGYoD.UfoEmojiTimings).MOUNTED_END); // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $7ZWaV.hasUfoMarked)(ufoExp, (0, $aGYoD.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $aGYoD.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $aGYoD.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
         // onload_start
        if (!(0, $7ZWaV.hasUfoMarked)(ufoExp, (0, $aGYoD.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $aGYoD.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $84c1b8f7f63755a9$export$2e2bcd8739ae039).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $42omo.useCallback)(()=>{
        if (!(0, $7ZWaV.hasUfoMarked)(ufoExp, (0, $aGYoD.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $aGYoD.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $42omo.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []); // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $42omo.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img" //@ts-ignore
    , {
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        key: src,
        alt: emoji.name || emoji.shortName || '',
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        className: "emoji",
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }); // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c17b194a67025173$export$4727956877b6f612), null),
        position: "right-start",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fef7a087c7f9d9ab$export$ce5eef59d8e46687, {
        ...props,
        "aria-labelledby": `screenreader-emoji-${emoji.id}`,
        type: "image",
        className: classes,
        ref: ref,
        showTooltip: false,
        onMouseOver: onMouseOver
    }, emojiNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $15bff58016f1db5c$export$2e2bcd8739ae039), {
        onClick: (event)=>$fef7a087c7f9d9ab$var$handleDelete(props, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c17b194a67025173$export$d151e4941072147c), {
        emoji: emoji
    })));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fef7a087c7f9d9ab$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref
    }, emojiNode));
};
const $fef7a087c7f9d9ab$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    const ariaLabel = (0, $dh538.fg)('platform_change_emoji_button_label') ? (0, $8Tx5v.messages).changeEmojiButtonLabel.defaultMessage : editorEmoji ? undefined : emoji.shortName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        role: editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation',
        "aria-label": ariaLabel,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        className: (0, $gMc0m.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50g2xd _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j1dpa _3naf1dpa _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc" : "_2rkofajl _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk1j28 _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j1dpa _3naf1dpa _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc",
            className
        ]),
        onKeyDown: (event)=>$fef7a087c7f9d9ab$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $fef7a087c7f9d9ab$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $fef7a087c7f9d9ab$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $fef7a087c7f9d9ab$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other
    }, children);
});
const $fef7a087c7f9d9ab$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props; // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $li2rw.useSampledUFOComponentExperience)((0, $7ZWaV.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $fhsiz.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $42omo.useEffect)(()=>{
        const ufoExp = (0, $7ZWaV.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $7ZWaV.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $7ZWaV.hasUfoMarked)(ufoExp, (0, $aGYoD.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $aGYoD.UfoEmojiTimings).MOUNTED_END);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $40rXS.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fef7a087c7f9d9ab$export$ef49ddbb198ce334, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fef7a087c7f9d9ab$export$99dfeb9d71c11788, props);
};
var $fef7a087c7f9d9ab$export$2e2bcd8739ae039 = $fef7a087c7f9d9ab$export$56cc48506ff790a;
module.exports["EmojiNodeWrapper"] = $fef7a087c7f9d9ab$export$ce5eef59d8e46687;
module.exports["default"] = $fef7a087c7f9d9ab$export$2e2bcd8739ae039;

});

parcelRegister("iHQDd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");

function $d9e511b0ba075bd4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d9e511b0ba075bd4$var$_extends() {
    $d9e511b0ba075bd4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9e511b0ba075bd4$var$_extends.apply(this, arguments);
}
function $d9e511b0ba075bd4$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $d9e511b0ba075bd4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d9e511b0ba075bd4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $d9e511b0ba075bd4$var$INSTANCE_MAP = new Map();
var $d9e511b0ba075bd4$var$OBSERVER_MAP = new Map();
var $d9e511b0ba075bd4$var$ROOT_IDS = new Map();
var $d9e511b0ba075bd4$var$consecutiveRootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $d9e511b0ba075bd4$var$getRootId(root) {
    if (!root) return '';
    if ($d9e511b0ba075bd4$var$ROOT_IDS.has(root)) return $d9e511b0ba075bd4$var$ROOT_IDS.get(root);
    $d9e511b0ba075bd4$var$consecutiveRootId += 1;
    $d9e511b0ba075bd4$var$ROOT_IDS.set(root, $d9e511b0ba075bd4$var$consecutiveRootId.toString());
    return $d9e511b0ba075bd4$var$ROOT_IDS.get(root) + '_';
}
/**
 * Monitor element, and trigger callback when element becomes inView
 * @param element {HTMLElement}
 * @param callback {Function} Called with inView
 * @param options {Object} InterSection observer options
 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be inView before triggering
 * @param options.root {HTMLElement}
 * @param options.rootMargin {String} The CSS margin to apply to the root element.
 */ function $d9e511b0ba075bd4$var$observe(element, callback, options) {
    if (options === void 0) options = {};
    // IntersectionObserver needs a threshold to trigger, so set it to 0 if it's not defined.
    // Modify the options object, since it's used in the onChange handler.
    if (!options.threshold) options.threshold = 0;
    var _options = options, root = _options.root, rootMargin = _options.rootMargin, threshold = _options.threshold; // Validate that the element is not being used in another <Observer />
    !!$d9e511b0ba075bd4$var$INSTANCE_MAP.has(element) && (0, $dRnqM.default)(false);
    /* istanbul ignore if */ if (!element) return; // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    // An observer with the same options can be reused, so lets use this fact
    var observerId = $d9e511b0ba075bd4$var$getRootId(root) + (rootMargin ? threshold.toString() + "_" + rootMargin : threshold.toString());
    var observerInstance = $d9e511b0ba075bd4$var$OBSERVER_MAP.get(observerId);
    if (!observerInstance) {
        observerInstance = new IntersectionObserver($d9e511b0ba075bd4$var$onChange, options);
        /* istanbul ignore else  */ if (observerId) $d9e511b0ba075bd4$var$OBSERVER_MAP.set(observerId, observerInstance);
    }
    var instance = {
        callback: callback,
        element: element,
        inView: false,
        observerId: observerId,
        observer: observerInstance,
        // Make sure we have the thresholds value. It's undefined on a browser like Chrome 51.
        thresholds: observerInstance.thresholds || (Array.isArray(threshold) ? threshold : [
            threshold
        ])
    };
    $d9e511b0ba075bd4$var$INSTANCE_MAP.set(element, instance);
    observerInstance.observe(element);
    return instance;
}
/**
 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
 * make sure to call this method.
 * @param element {Element}
 */ function $d9e511b0ba075bd4$var$unobserve(element) {
    if (!element) return;
    var instance = $d9e511b0ba075bd4$var$INSTANCE_MAP.get(element);
    if (instance) {
        var observerId = instance.observerId, observer = instance.observer;
        var root = observer.root;
        observer.unobserve(element); // Check if we are still observing any elements with the same threshold.
        var itemsLeft = false; // Check if we still have observers configured with the same root.
        var rootObserved = false;
        /* istanbul ignore else  */ if (observerId) $d9e511b0ba075bd4$var$INSTANCE_MAP.forEach(function(item, key) {
            if (key !== element) {
                if (item.observerId === observerId) {
                    itemsLeft = true;
                    rootObserved = true;
                }
                if (item.observer.root === root) rootObserved = true;
            }
        });
        if (!rootObserved && root) $d9e511b0ba075bd4$var$ROOT_IDS["delete"](root);
        if (observer && !itemsLeft) // No more elements to observe for threshold, disconnect observer
        observer.disconnect();
         // Remove reference to element
        $d9e511b0ba075bd4$var$INSTANCE_MAP["delete"](element);
    }
}
function $d9e511b0ba075bd4$var$onChange(changes) {
    changes.forEach(function(intersection) {
        var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio, target = intersection.target;
        var instance = $d9e511b0ba075bd4$var$INSTANCE_MAP.get(target); // Firefox can report a negative intersectionRatio when scrolling.
        /* istanbul ignore else */ if (instance && intersectionRatio >= 0) {
            // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
            var inView = instance.thresholds.some(function(threshold) {
                return instance.inView ? intersectionRatio > threshold : intersectionRatio >= threshold;
            });
            if (isIntersecting !== undefined) // If isIntersecting is defined, ensure that the element is actually intersecting.
            // Otherwise it reports a threshold of 0
            inView = inView && isIntersecting;
            instance.inView = inView;
            instance.callback(inView, intersection);
        }
    });
}
function $d9e511b0ba075bd4$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 * Monitors scroll, and triggers the children function with updated props
 *
 <InView>
 {({inView, ref}) => (
   <h1 ref={ref}>{`${inView}`}</h1>
 )}
 </InView>
 */ var $d9e511b0ba075bd4$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $d9e511b0ba075bd4$var$_inheritsLoose(InView, _React$Component);
    function InView() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        $d9e511b0ba075bd4$var$_defineProperty($d9e511b0ba075bd4$var$_assertThisInitialized(_this), "state", {
            inView: false,
            entry: undefined
        });
        $d9e511b0ba075bd4$var$_defineProperty($d9e511b0ba075bd4$var$_assertThisInitialized(_this), "node", null);
        $d9e511b0ba075bd4$var$_defineProperty($d9e511b0ba075bd4$var$_assertThisInitialized(_this), "handleNode", function(node) {
            if (_this.node) {
                $d9e511b0ba075bd4$var$unobserve(_this.node);
                if (!node && !_this.props.triggerOnce) _this.setState({
                    inView: false,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        });
        $d9e511b0ba075bd4$var$_defineProperty($d9e511b0ba075bd4$var$_assertThisInitialized(_this), "handleChange", function(inView, entry) {
            // Only trigger a state update if inView has changed.
            // This prevents an unnecessary extra state update during mount, when the element stats outside the viewport
            if (inView !== _this.state.inView || inView) _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        });
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidMount = function componentDidMount() {
        !this.node && (0, $dRnqM.default)(false);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
            $d9e511b0ba075bd4$var$unobserve(this.node);
            this.observeNode();
        }
        if (prevState.inView !== this.state.inView) {
            if (this.state.inView && this.props.triggerOnce) {
                $d9e511b0ba075bd4$var$unobserve(this.node);
                this.node = null;
            }
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.node) {
            $d9e511b0ba075bd4$var$unobserve(this.node);
            this.node = null;
        }
    };
    _proto.observeNode = function observeNode() {
        if (!this.node) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin;
        $d9e511b0ba075bd4$var$observe(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
    };
    _proto.render = function render() {
        var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
        if (!$d9e511b0ba075bd4$var$isPlainChildren(this.props)) return this.props.children({
            inView: inView,
            entry: entry,
            ref: this.handleNode
        });
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, tag = _this$props2.tag, triggerOnce = _this$props2.triggerOnce, threshold = _this$props2.threshold, root = _this$props2.root, rootMargin = _this$props2.rootMargin, onChange = _this$props2.onChange, props = $d9e511b0ba075bd4$var$_objectWithoutPropertiesLoose(_this$props2, [
            "children",
            "as",
            "tag",
            "triggerOnce",
            "threshold",
            "root",
            "rootMargin",
            "onChange"
        ]);
        return (0, $42omo.createElement)(as || tag || 'div', $d9e511b0ba075bd4$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}((0, $42omo.Component));
$d9e511b0ba075bd4$var$_defineProperty($d9e511b0ba075bd4$export$a62107ca74432f44, "displayName", 'InView');
$d9e511b0ba075bd4$var$_defineProperty($d9e511b0ba075bd4$export$a62107ca74432f44, "defaultProps", {
    threshold: 0,
    triggerOnce: false
});
/* eslint-disable react-hooks/exhaustive-deps */ var $d9e511b0ba075bd4$var$initialState = {
    inView: false,
    entry: undefined
};
function $d9e511b0ba075bd4$export$2f62ee6831462844(options) {
    if (options === void 0) options = {};
    var ref = (0, $42omo.useRef)();
    var _React$useState = (0, $42omo.useState)($d9e511b0ba075bd4$var$initialState), state = _React$useState[0], setState = _React$useState[1];
    var setRef = (0, $42omo.useCallback)(function(node) {
        if (ref.current) $d9e511b0ba075bd4$var$unobserve(ref.current);
        if (node) $d9e511b0ba075bd4$var$observe(node, function(inView, intersection) {
            setState({
                inView: inView,
                entry: intersection
            });
            if (inView && options.triggerOnce) // If it should only trigger once, unobserve the element after it's inView
            $d9e511b0ba075bd4$var$unobserve(node);
        }, options);
         // Store a reference to the node, so we can unobserve it later
        ref.current = node;
    }, [
        options.threshold,
        options.root,
        options.rootMargin,
        options.triggerOnce
    ]);
    (0, $42omo.useEffect)(function() {
        if (!ref.current && state !== $d9e511b0ba075bd4$var$initialState && !options.triggerOnce) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState($d9e511b0ba075bd4$var$initialState);
    });
    return [
        setRef,
        state.inView,
        state.entry
    ];
}
var $d9e511b0ba075bd4$export$2e2bcd8739ae039 = $d9e511b0ba075bd4$export$a62107ca74432f44;
module.exports["useInView"] = $d9e511b0ba075bd4$export$2f62ee6831462844;

});

parcelRegister("etuMO", function(module, exports) {

var $42omo = parcelRequire("42omo");

/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $fhsiz = parcelRequire("fhsiz");


var $40rXS = parcelRequire("40rXS");


var $aGYoD = parcelRequire("aGYoD");


var $8Yr6I = parcelRequire("8Yr6I");


var $eTjjM = parcelRequire("eTjjM");


var $7ZWaV = parcelRequire("7ZWaV");


var $jYWS5 = parcelRequire("jYWS5");





var $dh538 = parcelRequire("dh538");

var $e08913aabd7ab33b$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($e08913aabd7ab33b$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $e08913aabd7ab33b$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $fhsiz.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, pageTitleEmoji: pageTitleEmoji = false, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $42omo.useState)();
    const [loaded, setLoaded] = (0, $42omo.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $42omo.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $42omo.useState)();
    const fetchOrGetEmoji = (0, $42omo.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).mark((0, $aGYoD.UfoEmojiTimings).METADATA_START);
        if ((0, $40rXS.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason); // emoji is undefined
                    (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).mark((0, $aGYoD.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).mark((0, $aGYoD.UfoEmojiTimings).METADATA_END);
        }
    }, [
        onEmojiLoadFail
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $7ZWaV.hasUfoMarked)((0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId), (0, $aGYoD.UfoEmojiTimings).FMP_END)) (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $42omo.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $42omo.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $42omo.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $42omo.useMemo)(()=>{
        // reduce blast radius by targeting page title
        if (pageTitleEmoji && optimisticImageURL && (0, $dh538.fg)('platform_emoji_prevent_img_src_changing')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $fhsiz.defaultEmojiHeight),
                width: fitToHeight || (0, $fhsiz.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        // extend prevention to all surfaces
        if (optimisticImageURL && (0, $dh538.fg)('platform_emoji_prevent_img_src_changing_all')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $fhsiz.defaultEmojiHeight),
                width: fitToHeight || (0, $fhsiz.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        if (optimisticImageURL) {
            if (emoji && ((0, $40rXS.isImageRepresentation)(emoji.representation) || (0, $40rXS.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $fhsiz.defaultEmojiHeight),
                    width: fitToHeight || (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName,
        pageTitleEmoji
    ]);
    const handleOnLoadError = (0, $42omo.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $42omo.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]); // use width: auto when fitToHeight is defined
    const autoWidth = !!fitToHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jYWS5.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        "data-ssr-placeholder": `emoji-${id ?? shortName}`,
        "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`
    }, emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), {
        shortName: shortName,
        showTooltip: showTooltip,
        size: fitToHeight || (0, $fhsiz.defaultEmojiHeight),
        loading: true,
        xcss: placeholderXcss
    }), emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, customFallback || fallback || shortName), emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Yr6I.default), {
        emoji: optimisticEmojiDescription,
        onLoadError: handleOnLoadError,
        onLoadSuccess: handleOnLoadSuccess,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        autoWidth: autoWidth,
        editorEmoji: editorEmoji
    })));
};
var $e08913aabd7ab33b$export$2e2bcd8739ae039 = $e08913aabd7ab33b$export$7bfde52eceb3e2f6;



var $jPINf = parcelRequire("jPINf");







const $3191496aa9276843$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $42omo.useEffect)(()=>{
        if (!emojiId) return;
        (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $fhsiz.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $7ZWaV.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $7ZWaV.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jPINf.UfoErrorBoundary), {
        experiences: [
            (0, $7ZWaV.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e08913aabd7ab33b$export$7bfde52eceb3e2f6), props));
};
var $3191496aa9276843$export$2e2bcd8739ae039 = $3191496aa9276843$var$ResourcedEmoji;
module.exports["default"] = $3191496aa9276843$export$2e2bcd8739ae039;

});

parcelRegister("eTjjM", function(module, exports) {
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1oCLl = parcelRequire("1oCLl");


var $fhsiz = parcelRequire("fhsiz");


var $8hpYf = parcelRequire("8hpYf");

const $769780e1f87de417$var$placeholderContainer = null;
const $769780e1f87de417$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $769780e1f87de417$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $fhsiz.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
        fill: 'f7f7f7',
        minWidth: `${0, $fhsiz.defaultDenseEmojiHeight}px`,
        minHeight: `${0, $fhsiz.defaultDenseEmojiHeight}px`
    } : {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": $769780e1f87de417$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        className: (0, $gMc0m.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkofajl _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhk1l7x _s7n4nkob _o5721q9c _y3gn1h6o",
            [
                (0, $8hpYf.placeholder),
                xcss
            ].join(' ')
        ]),
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $769780e1f87de417$export$2e2bcd8739ae039 = $769780e1f87de417$var$EmojiPlaceholder;
module.exports["default"] = $769780e1f87de417$export$2e2bcd8739ae039;

});

parcelRegister("jYWS5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $03yfx = parcelRequire("03yfx");

const $6f07a6a3cde8efad$export$1120e666998e21b5 = (props)=>{
    const emojiContextValue = (0, $42omo.useMemo)(()=>props.emojiProvider ? {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        } : undefined, [
        props.emojiProvider
    ]);
    if (!!emojiContextValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $03yfx.EmojiContextProvider), {
        emojiContextValue: emojiContextValue
    }, props.children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
};
module.exports["EmojiCommonProvider"] = $6f07a6a3cde8efad$export$1120e666998e21b5;

});

parcelRegister("aRZzN", function(module, exports) {

var $iyDxB = parcelRequire("iyDxB");


var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $42JDa = parcelRequire("42JDa");

function $54a839e4270a9473$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens// eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                .map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $54a839e4270a9473$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $54a839e4270a9473$var$createRule());
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70b3fb435fbd97a9$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $70b3fb435fbd97a9$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $70b3fb435fbd97a9$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $70b3fb435fbd97a9$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
    html: false
});
$70b3fb435fbd97a9$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $70b3fb435fbd97a9$export$267fd7ead7cc4561 {
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
    constructor(schema = (0, $iyDxB.defaultSchema), tokenizer = $70b3fb435fbd97a9$var$md){
        this.markdownParser = void 0;
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $70b3fb435fbd97a9$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($70b3fb435fbd97a9$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $csam1.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $54a839e4270a9473$export$c8dcbd316b71f8cf));
        this.markdownParser = new (0, $42JDa.MarkdownParser)(schema, tokenizer, $70b3fb435fbd97a9$var$filterMdToPmSchemaMapping(schema, $70b3fb435fbd97a9$var$mdToPmMapping));
    }
}
module.exports["MarkdownTransformer"] = $70b3fb435fbd97a9$export$267fd7ead7cc4561;

});

parcelRegister("2Yzoe", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dHtQv"));

});

parcelRegister("dHtQv", function(module, exports) {
// Main parser class
'use strict';

var $hslaz = parcelRequire("hslaz");

var $99cd002251279291$exports = {};
$parcel$export($99cd002251279291$exports, "parseLinkLabel", () => $99cd002251279291$export$2a2c8612930e58d0, (v) => $99cd002251279291$export$2a2c8612930e58d0 = v);
$parcel$export($99cd002251279291$exports, "parseLinkDestination", () => $99cd002251279291$export$22bd24080f95f2b3, (v) => $99cd002251279291$export$22bd24080f95f2b3 = v);
$parcel$export($99cd002251279291$exports, "parseLinkTitle", () => $99cd002251279291$export$89650c5477a69db9, (v) => $99cd002251279291$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $99cd002251279291$export$2a2c8612930e58d0;
var $99cd002251279291$export$22bd24080f95f2b3;
var $99cd002251279291$export$89650c5477a69db9;
'use strict';

$99cd002251279291$export$2a2c8612930e58d0 = (parcelRequire("3jcVo"));

$99cd002251279291$export$22bd24080f95f2b3 = (parcelRequire("bwZH2"));

$99cd002251279291$export$89650c5477a69db9 = (parcelRequire("jcH1A"));


var $18c610ba39de573b$exports = {};
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';



var $18c610ba39de573b$require$assign = $hslaz.assign;



var $18c610ba39de573b$require$unescapeAll = $hslaz.unescapeAll;



var $18c610ba39de573b$require$escapeHtml = $hslaz.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $18c610ba39de573b$var$default_rules = {};
$18c610ba39de573b$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $18c610ba39de573b$require$escapeHtml(token.content) + '</code>';
};
$18c610ba39de573b$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $18c610ba39de573b$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$18c610ba39de573b$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $18c610ba39de573b$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $18c610ba39de573b$require$escapeHtml(token.content);
    else highlighted = $18c610ba39de573b$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$18c610ba39de573b$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$18c610ba39de573b$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$18c610ba39de573b$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$18c610ba39de573b$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $18c610ba39de573b$require$escapeHtml(tokens[idx].content);
};
$18c610ba39de573b$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$18c610ba39de573b$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $18c610ba39de573b$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $18c610ba39de573b$require$assign({}, $18c610ba39de573b$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $18c610ba39de573b$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $18c610ba39de573b$require$escapeHtml(token.attrs[i][0]) + '="' + $18c610ba39de573b$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $18c610ba39de573b$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $18c610ba39de573b$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $18c610ba39de573b$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $18c610ba39de573b$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
$18c610ba39de573b$exports = $18c610ba39de573b$var$Renderer;


var $eb2feabf2fa54b7e$exports = {};
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';
var $78e5a879766d03a8$exports = {};
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $78e5a879766d03a8$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$78e5a879766d03a8$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$78e5a879766d03a8$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $78e5a879766d03a8$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $78e5a879766d03a8$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $78e5a879766d03a8$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $78e5a879766d03a8$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $78e5a879766d03a8$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
$78e5a879766d03a8$exports = $78e5a879766d03a8$var$Ruler;









var $eb2feabf2fa54b7e$var$_rules = [
    [
        'normalize',
        (parcelRequire("6oHAz"))
    ],
    [
        'block',
        (parcelRequire("1whli"))
    ],
    [
        'inline',
        (parcelRequire("da9wI"))
    ],
    [
        'linkify',
        (parcelRequire("aNcTG"))
    ],
    [
        'replacements',
        (parcelRequire("h6nFy"))
    ],
    [
        'smartquotes',
        (parcelRequire("eNEJu"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("3CceH"))
    ]
];
/**
 * new Core()
 **/ function $eb2feabf2fa54b7e$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $78e5a879766d03a8$exports();
    for(var i = 0; i < $eb2feabf2fa54b7e$var$_rules.length; i++)this.ruler.push($eb2feabf2fa54b7e$var$_rules[i][0], $eb2feabf2fa54b7e$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $eb2feabf2fa54b7e$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$eb2feabf2fa54b7e$var$Core.prototype.State = (parcelRequire("hnyQ8"));
$eb2feabf2fa54b7e$exports = $eb2feabf2fa54b7e$var$Core;


var $cae99bdef980d477$exports = {};
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';












var $cae99bdef980d477$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("i2Iv8")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("hnPBV"))
    ],
    [
        'fence',
        (parcelRequire("3GuRa")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("79tnV")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("keEbn")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("9Flpb")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("dabWb"))
    ],
    [
        'html_block',
        (parcelRequire("55Egx")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("9Dg2w")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("JBg9j"))
    ],
    [
        'paragraph',
        (parcelRequire("15GMD"))
    ]
];
/**
 * new ParserBlock()
 **/ function $cae99bdef980d477$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $78e5a879766d03a8$exports();
    for(var i = 0; i < $cae99bdef980d477$var$_rules.length; i++)this.ruler.push($cae99bdef980d477$var$_rules[i][0], $cae99bdef980d477$var$_rules[i][1], {
        alt: ($cae99bdef980d477$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$cae99bdef980d477$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $cae99bdef980d477$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$cae99bdef980d477$var$ParserBlock.prototype.State = (parcelRequire("6eyHE"));
$cae99bdef980d477$exports = $cae99bdef980d477$var$ParserBlock;


var $d17fba15107d07ca$exports = {};
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';













////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $d17fba15107d07ca$var$_rules = [
    [
        'text',
        (parcelRequire("1U2TG"))
    ],
    [
        'linkify',
        (parcelRequire("lqNlw"))
    ],
    [
        'newline',
        (parcelRequire("iek5k"))
    ],
    [
        'escape',
        (parcelRequire("8Nqk1"))
    ],
    [
        'backticks',
        (parcelRequire("dPP48"))
    ],
    [
        'strikethrough',
        (parcelRequire("45axw")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("dPUa6")).tokenize
    ],
    [
        'link',
        (parcelRequire("hpf7X"))
    ],
    [
        'image',
        (parcelRequire("gTmYV"))
    ],
    [
        'autolink',
        (parcelRequire("cog6S"))
    ],
    [
        'html_inline',
        (parcelRequire("jaoOi"))
    ],
    [
        'entity',
        (parcelRequire("fdC2o"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $d17fba15107d07ca$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("ddn2p"))
    ],
    [
        'strikethrough',
        (parcelRequire("45axw")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("dPUa6")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("eXNML"))
    ]
];
/**
 * new ParserInline()
 **/ function $d17fba15107d07ca$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $78e5a879766d03a8$exports();
    for(i = 0; i < $d17fba15107d07ca$var$_rules.length; i++)this.ruler.push($d17fba15107d07ca$var$_rules[i][0], $d17fba15107d07ca$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $78e5a879766d03a8$exports();
    for(i = 0; i < $d17fba15107d07ca$var$_rules2.length; i++)this.ruler2.push($d17fba15107d07ca$var$_rules2[i][0], $d17fba15107d07ca$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$d17fba15107d07ca$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$d17fba15107d07ca$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $d17fba15107d07ca$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$d17fba15107d07ca$var$ParserInline.prototype.State = (parcelRequire("ib9ax"));
$d17fba15107d07ca$exports = $d17fba15107d07ca$var$ParserInline;


var $d87414f9b6cb2182$exports = {};
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d87414f9b6cb2182$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d87414f9b6cb2182$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d87414f9b6cb2182$var$isString(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object String]';
}
function $d87414f9b6cb2182$var$isObject(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object Object]';
}
function $d87414f9b6cb2182$var$isRegExp(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object RegExp]';
}
function $d87414f9b6cb2182$var$isFunction(obj) {
    return $d87414f9b6cb2182$var$_class(obj) === '[object Function]';
}
function $d87414f9b6cb2182$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d87414f9b6cb2182$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d87414f9b6cb2182$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d87414f9b6cb2182$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d87414f9b6cb2182$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d87414f9b6cb2182$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d87414f9b6cb2182$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d87414f9b6cb2182$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d87414f9b6cb2182$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d87414f9b6cb2182$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d87414f9b6cb2182$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("aA4uz"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d87414f9b6cb2182$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d87414f9b6cb2182$var$isObject(val)) {
            if ($d87414f9b6cb2182$var$isRegExp(val.validate)) compiled.validate = $d87414f9b6cb2182$var$createValidator(val.validate);
            else if ($d87414f9b6cb2182$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d87414f9b6cb2182$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d87414f9b6cb2182$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d87414f9b6cb2182$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d87414f9b6cb2182$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d87414f9b6cb2182$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $d87414f9b6cb2182$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d87414f9b6cb2182$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d87414f9b6cb2182$var$createMatch(self, shift) {
    var match = new $d87414f9b6cb2182$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d87414f9b6cb2182$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d87414f9b6cb2182$var$LinkifyIt)) return new $d87414f9b6cb2182$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d87414f9b6cb2182$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d87414f9b6cb2182$var$assign({}, $d87414f9b6cb2182$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d87414f9b6cb2182$var$assign({}, $d87414f9b6cb2182$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d87414f9b6cb2182$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d87414f9b6cb2182$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d87414f9b6cb2182$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d87414f9b6cb2182$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d87414f9b6cb2182$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d87414f9b6cb2182$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $d87414f9b6cb2182$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d87414f9b6cb2182$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d87414f9b6cb2182$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d87414f9b6cb2182$var$LinkifyIt.prototype.onCompile = function onCompile() {};
$d87414f9b6cb2182$exports = $d87414f9b6cb2182$var$LinkifyIt;



var $kYaO1 = parcelRequire("kYaO1");

var $fed2ac37d7e96805$exports = {};
'use strict';
/** Highest positive signed 32-bit float value */ const $fed2ac37d7e96805$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $fed2ac37d7e96805$var$base = 36;
const $fed2ac37d7e96805$var$tMin = 1;
const $fed2ac37d7e96805$var$tMax = 26;
const $fed2ac37d7e96805$var$skew = 38;
const $fed2ac37d7e96805$var$damp = 700;
const $fed2ac37d7e96805$var$initialBias = 72;
const $fed2ac37d7e96805$var$initialN = 128; // 0x80
const $fed2ac37d7e96805$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $fed2ac37d7e96805$var$regexPunycode = /^xn--/;
const $fed2ac37d7e96805$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $fed2ac37d7e96805$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $fed2ac37d7e96805$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $fed2ac37d7e96805$var$baseMinusTMin = $fed2ac37d7e96805$var$base - $fed2ac37d7e96805$var$tMin;
const $fed2ac37d7e96805$var$floor = Math.floor;
const $fed2ac37d7e96805$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $fed2ac37d7e96805$var$error(type) {
    throw new RangeError($fed2ac37d7e96805$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $fed2ac37d7e96805$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $fed2ac37d7e96805$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($fed2ac37d7e96805$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $fed2ac37d7e96805$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $fed2ac37d7e96805$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $fed2ac37d7e96805$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $fed2ac37d7e96805$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $fed2ac37d7e96805$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $fed2ac37d7e96805$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $fed2ac37d7e96805$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $fed2ac37d7e96805$var$floor(delta / $fed2ac37d7e96805$var$damp) : delta >> 1;
    delta += $fed2ac37d7e96805$var$floor(delta / numPoints);
    for(; delta > $fed2ac37d7e96805$var$baseMinusTMin * $fed2ac37d7e96805$var$tMax >> 1; k += $fed2ac37d7e96805$var$base)delta = $fed2ac37d7e96805$var$floor(delta / $fed2ac37d7e96805$var$baseMinusTMin);
    return $fed2ac37d7e96805$var$floor(k + ($fed2ac37d7e96805$var$baseMinusTMin + 1) * delta / (delta + $fed2ac37d7e96805$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $fed2ac37d7e96805$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $fed2ac37d7e96805$var$initialN;
    let bias = $fed2ac37d7e96805$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($fed2ac37d7e96805$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $fed2ac37d7e96805$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $fed2ac37d7e96805$var$base;; k += $fed2ac37d7e96805$var$base){
            if (index >= inputLength) $fed2ac37d7e96805$var$error('invalid-input');
            const digit = $fed2ac37d7e96805$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $fed2ac37d7e96805$var$base) $fed2ac37d7e96805$var$error('invalid-input');
            if (digit > $fed2ac37d7e96805$var$floor(($fed2ac37d7e96805$var$maxInt - i) / w)) $fed2ac37d7e96805$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $fed2ac37d7e96805$var$tMin : k >= bias + $fed2ac37d7e96805$var$tMax ? $fed2ac37d7e96805$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $fed2ac37d7e96805$var$base - t;
            if (w > $fed2ac37d7e96805$var$floor($fed2ac37d7e96805$var$maxInt / baseMinusT)) $fed2ac37d7e96805$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $fed2ac37d7e96805$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($fed2ac37d7e96805$var$floor(i / out) > $fed2ac37d7e96805$var$maxInt - n) $fed2ac37d7e96805$var$error('overflow');
        n += $fed2ac37d7e96805$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $fed2ac37d7e96805$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $fed2ac37d7e96805$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $fed2ac37d7e96805$var$initialN;
    let delta = 0;
    let bias = $fed2ac37d7e96805$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($fed2ac37d7e96805$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($fed2ac37d7e96805$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $fed2ac37d7e96805$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $fed2ac37d7e96805$var$floor(($fed2ac37d7e96805$var$maxInt - delta) / handledCPCountPlusOne)) $fed2ac37d7e96805$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $fed2ac37d7e96805$var$maxInt) $fed2ac37d7e96805$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $fed2ac37d7e96805$var$base;; k += $fed2ac37d7e96805$var$base){
                    const t = k <= bias ? $fed2ac37d7e96805$var$tMin : k >= bias + $fed2ac37d7e96805$var$tMax ? $fed2ac37d7e96805$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $fed2ac37d7e96805$var$base - t;
                    output.push($fed2ac37d7e96805$var$stringFromCharCode($fed2ac37d7e96805$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $fed2ac37d7e96805$var$floor(qMinusT / baseMinusT);
                }
                output.push($fed2ac37d7e96805$var$stringFromCharCode($fed2ac37d7e96805$var$digitToBasic(q, 0)));
                bias = $fed2ac37d7e96805$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $fed2ac37d7e96805$var$toUnicode = function(input) {
    return $fed2ac37d7e96805$var$mapDomain(input, function(string) {
        return $fed2ac37d7e96805$var$regexPunycode.test(string) ? $fed2ac37d7e96805$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $fed2ac37d7e96805$var$toASCII = function(input) {
    return $fed2ac37d7e96805$var$mapDomain(input, function(string) {
        return $fed2ac37d7e96805$var$regexNonASCII.test(string) ? 'xn--' + $fed2ac37d7e96805$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $fed2ac37d7e96805$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $fed2ac37d7e96805$var$ucs2decode,
        'encode': $fed2ac37d7e96805$var$ucs2encode
    },
    'decode': $fed2ac37d7e96805$var$decode,
    'encode': $fed2ac37d7e96805$var$encode,
    'toASCII': $fed2ac37d7e96805$var$toASCII,
    'toUnicode': $fed2ac37d7e96805$var$toUnicode
};
$fed2ac37d7e96805$exports = $fed2ac37d7e96805$var$punycode;





var $9f967144311cb96c$var$config = {
    default: (parcelRequire("j7DYH")),
    zero: (parcelRequire("ad45r")),
    commonmark: (parcelRequire("4teFe"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $9f967144311cb96c$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $9f967144311cb96c$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $9f967144311cb96c$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $9f967144311cb96c$var$BAD_PROTO_RE.test(str) ? $9f967144311cb96c$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $9f967144311cb96c$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $9f967144311cb96c$var$normalizeLink(url) {
    var parsed = $kYaO1.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $9f967144311cb96c$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $fed2ac37d7e96805$exports.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $kYaO1.encode($kYaO1.format(parsed));
}
function $9f967144311cb96c$var$normalizeLinkText(url) {
    var parsed = $kYaO1.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $9f967144311cb96c$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $fed2ac37d7e96805$exports.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $kYaO1.decode($kYaO1.format(parsed), $kYaO1.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $9f967144311cb96c$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $9f967144311cb96c$var$MarkdownIt)) return new $9f967144311cb96c$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$hslaz.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $d17fba15107d07ca$exports();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $cae99bdef980d477$exports();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $eb2feabf2fa54b7e$exports();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $18c610ba39de573b$exports();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $d87414f9b6cb2182$exports();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $9f967144311cb96c$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $9f967144311cb96c$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $9f967144311cb96c$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $hslaz;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $hslaz.assign({}, $99cd002251279291$exports);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.set = function(options) {
    $hslaz.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($hslaz.isString(presets)) {
        presetName = presets;
        presets = $9f967144311cb96c$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $9f967144311cb96c$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $9f967144311cb96c$var$MarkdownIt;

});

parcelRegister("hxrg0", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});

parcelRegister("kYaO1", function(module, exports) {
$parcel$export(module.exports, "encode", () => $f441cb06ef4295f8$export$c564cdbbe6da493, (v) => $f441cb06ef4295f8$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $f441cb06ef4295f8$export$2f872c0f2117be69, (v) => $f441cb06ef4295f8$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $f441cb06ef4295f8$export$d9468344d3651243, (v) => $f441cb06ef4295f8$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $f441cb06ef4295f8$export$98e6a39c04603d36, (v) => $f441cb06ef4295f8$export$98e6a39c04603d36 = v);
var $f441cb06ef4295f8$export$c564cdbbe6da493;
var $f441cb06ef4295f8$export$2f872c0f2117be69;
var $f441cb06ef4295f8$export$d9468344d3651243;
var $f441cb06ef4295f8$export$98e6a39c04603d36;
'use strict';

$f441cb06ef4295f8$export$c564cdbbe6da493 = (parcelRequire("g8pux"));

$f441cb06ef4295f8$export$2f872c0f2117be69 = (parcelRequire("5UTI8"));

$f441cb06ef4295f8$export$d9468344d3651243 = (parcelRequire("aouNV"));

$f441cb06ef4295f8$export$98e6a39c04603d36 = (parcelRequire("23Ep7"));

});

parcelRegister("g8pux", function(module, exports) {
'use strict';
var $030804d1b3b5c167$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $030804d1b3b5c167$var$getEncodeCache(exclude) {
    var i, ch, cache = $030804d1b3b5c167$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $030804d1b3b5c167$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $030804d1b3b5c167$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $030804d1b3b5c167$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $030804d1b3b5c167$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$030804d1b3b5c167$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$030804d1b3b5c167$var$encode.componentChars = "-_.!~*'()";
module.exports = $030804d1b3b5c167$var$encode;

});

parcelRegister("5UTI8", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $44ed65b596ebc5d8$var$decodeCache = {};
function $44ed65b596ebc5d8$var$getDecodeCache(exclude) {
    var i, ch, cache = $44ed65b596ebc5d8$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $44ed65b596ebc5d8$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $44ed65b596ebc5d8$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $44ed65b596ebc5d8$var$decode.defaultChars;
    cache = $44ed65b596ebc5d8$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$44ed65b596ebc5d8$var$decode.defaultChars = ';/?:@&=+$,#';
$44ed65b596ebc5d8$var$decode.componentChars = '';
module.exports = $44ed65b596ebc5d8$var$decode;

});

parcelRegister("aouNV", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("23Ep7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $17fb3400fe673da8$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $17fb3400fe673da8$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $17fb3400fe673da8$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$17fb3400fe673da8$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$17fb3400fe673da8$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$17fb3400fe673da8$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($17fb3400fe673da8$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$17fb3400fe673da8$var$autoEscape = [
    '\''
].concat($17fb3400fe673da8$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$17fb3400fe673da8$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($17fb3400fe673da8$var$autoEscape), $17fb3400fe673da8$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $17fb3400fe673da8$var$hostnameMaxLen = 255, $17fb3400fe673da8$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $17fb3400fe673da8$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$17fb3400fe673da8$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$17fb3400fe673da8$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $17fb3400fe673da8$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $17fb3400fe673da8$var$Url) return url;
    var u = new $17fb3400fe673da8$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$17fb3400fe673da8$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $17fb3400fe673da8$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $17fb3400fe673da8$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $17fb3400fe673da8$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$17fb3400fe673da8$var$hostlessProtocol[proto] && (slashes || proto && !$17fb3400fe673da8$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $17fb3400fe673da8$var$hostEndingChars.length; i++){
            hec = rest.indexOf($17fb3400fe673da8$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $17fb3400fe673da8$var$nonHostChars.length; i++){
            hec = rest.indexOf($17fb3400fe673da8$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($17fb3400fe673da8$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($17fb3400fe673da8$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($17fb3400fe673da8$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $17fb3400fe673da8$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($17fb3400fe673da8$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$17fb3400fe673da8$var$Url.prototype.parseHost = function(host) {
    var port = $17fb3400fe673da8$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $17fb3400fe673da8$var$urlParse;

});

parcelRegister("bx7Sb", function(module, exports) {
$parcel$export(module.exports, "Any", () => $8658e22d9bf36744$export$b24b633b1364b94b, (v) => $8658e22d9bf36744$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $8658e22d9bf36744$export$15dafbac7aec8a57, (v) => $8658e22d9bf36744$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $8658e22d9bf36744$export$239cff0cce87eb56, (v) => $8658e22d9bf36744$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $8658e22d9bf36744$export$56c0d5a1e737357d, (v) => $8658e22d9bf36744$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $8658e22d9bf36744$export$dc98b0b04f4c7758, (v) => $8658e22d9bf36744$export$dc98b0b04f4c7758 = v);
var $8658e22d9bf36744$export$b24b633b1364b94b;
var $8658e22d9bf36744$export$15dafbac7aec8a57;
var $8658e22d9bf36744$export$239cff0cce87eb56;
var $8658e22d9bf36744$export$56c0d5a1e737357d;
var $8658e22d9bf36744$export$dc98b0b04f4c7758;
'use strict';

$8658e22d9bf36744$export$b24b633b1364b94b = (parcelRequire("6gKKW"));

$8658e22d9bf36744$export$15dafbac7aec8a57 = (parcelRequire("7wkNx"));

$8658e22d9bf36744$export$239cff0cce87eb56 = (parcelRequire("9UqiH"));

$8658e22d9bf36744$export$56c0d5a1e737357d = (parcelRequire("eSMp5"));

$8658e22d9bf36744$export$dc98b0b04f4c7758 = (parcelRequire("4QTDX"));

});

parcelRegister("9UqiH", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("3jcVo", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("bwZH2", function(module, exports) {
// Parse link destination
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $865289d78f708787$require$unescapeAll = $hslaz.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $865289d78f708787$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $865289d78f708787$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("jcH1A", function(module, exports) {
// Parse link title
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $dfb083184215ac18$require$unescapeAll = $hslaz.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $dfb083184215ac18$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});

parcelRegister("6oHAz", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $4a86cbd41bb5092e$var$NEWLINES_RE = /\r\n?|\n/g;
var $4a86cbd41bb5092e$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($4a86cbd41bb5092e$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($4a86cbd41bb5092e$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("1whli", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("da9wI", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("aNcTG", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $7db87c12fec24755$require$arrayReplaceAt = $hslaz.arrayReplaceAt;
function $7db87c12fec24755$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $7db87c12fec24755$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($7db87c12fec24755$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($7db87c12fec24755$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $7db87c12fec24755$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("h6nFy", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $c7355b6702b9362e$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $c7355b6702b9362e$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $c7355b6702b9362e$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $c7355b6702b9362e$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $c7355b6702b9362e$var$replaceFn(match, name) {
    return $c7355b6702b9362e$var$SCOPED_ABBR[name.toLowerCase()];
}
function $c7355b6702b9362e$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($c7355b6702b9362e$var$SCOPED_ABBR_RE, $c7355b6702b9362e$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $c7355b6702b9362e$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($c7355b6702b9362e$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($c7355b6702b9362e$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $c7355b6702b9362e$var$replace_scoped(state.tokens[blkIdx].children);
        if ($c7355b6702b9362e$var$RARE_RE.test(state.tokens[blkIdx].content)) $c7355b6702b9362e$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("eNEJu", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $hslaz = parcelRequire("hslaz");

var $ac653cf8fad0a277$require$isWhiteSpace = $hslaz.isWhiteSpace;



var $ac653cf8fad0a277$require$isPunctChar = $hslaz.isPunctChar;



var $ac653cf8fad0a277$require$isMdAsciiPunct = $hslaz.isMdAsciiPunct;
var $ac653cf8fad0a277$var$QUOTE_TEST_RE = /['"]/;
var $ac653cf8fad0a277$var$QUOTE_RE = /['"]/g;
var $ac653cf8fad0a277$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $ac653cf8fad0a277$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $ac653cf8fad0a277$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $ac653cf8fad0a277$var$QUOTE_RE.lastIndex = pos;
            t = $ac653cf8fad0a277$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $ac653cf8fad0a277$require$isMdAsciiPunct(lastChar) || $ac653cf8fad0a277$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $ac653cf8fad0a277$require$isMdAsciiPunct(nextChar) || $ac653cf8fad0a277$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $ac653cf8fad0a277$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $ac653cf8fad0a277$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $ac653cf8fad0a277$var$replaceAt(token.content, t.index, $ac653cf8fad0a277$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $ac653cf8fad0a277$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $ac653cf8fad0a277$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $ac653cf8fad0a277$var$replaceAt(token.content, t.index, $ac653cf8fad0a277$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$ac653cf8fad0a277$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $ac653cf8fad0a277$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("3CceH", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("hnyQ8", function(module, exports) {
// Core state object
//
'use strict';

var $flZnN = parcelRequire("flZnN");

function $ca6f9c20f90c9f4e$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$ca6f9c20f90c9f4e$var$StateCore.prototype.Token = $flZnN;
module.exports = $ca6f9c20f90c9f4e$var$StateCore;

});

parcelRegister("i2Iv8", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $hslaz = parcelRequire("hslaz");

var $d22aeee7779518c4$require$isSpace = $hslaz.isSpace;
function $d22aeee7779518c4$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $d22aeee7779518c4$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$d22aeee7779518c4$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $d22aeee7779518c4$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$d22aeee7779518c4$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $d22aeee7779518c4$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $d22aeee7779518c4$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $d22aeee7779518c4$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $d22aeee7779518c4$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $d22aeee7779518c4$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("hnPBV", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("3GuRa", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("79tnV", function(module, exports) {
// Block quotes
'use strict';

var $hslaz = parcelRequire("hslaz");

var $53502ae8d81188c9$require$isSpace = $hslaz.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($53502ae8d81188c9$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("keEbn", function(module, exports) {
// Horizontal rule
'use strict';

var $hslaz = parcelRequire("hslaz");

var $ebb448de11020ca1$require$isSpace = $hslaz.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$ebb448de11020ca1$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("9Flpb", function(module, exports) {
// Lists
'use strict';

var $hslaz = parcelRequire("hslaz");

var $70988c00697c25f3$require$isSpace = $hslaz.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $70988c00697c25f3$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$70988c00697c25f3$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $70988c00697c25f3$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$70988c00697c25f3$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $70988c00697c25f3$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $70988c00697c25f3$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $70988c00697c25f3$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $70988c00697c25f3$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $70988c00697c25f3$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $70988c00697c25f3$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("dabWb", function(module, exports) {
'use strict';

var $hslaz = parcelRequire("hslaz");

var $9955780ed064193a$require$normalizeReference = $hslaz.normalizeReference;



var $9955780ed064193a$require$isSpace = $hslaz.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($9955780ed064193a$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($9955780ed064193a$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$9955780ed064193a$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$9955780ed064193a$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $9955780ed064193a$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("55Egx", function(module, exports) {
// HTML block
'use strict';
var $d4267c6d729a0e24$exports = {};
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
$d4267c6d729a0e24$exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];



var $dgyOV = parcelRequire("dgyOV");

var $3b4ca754d15deb34$require$HTML_OPEN_CLOSE_TAG_RE = $dgyOV.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $3b4ca754d15deb34$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $d4267c6d729a0e24$exports.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($3b4ca754d15deb34$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $3b4ca754d15deb34$var$HTML_SEQUENCES.length; i++){
        if ($3b4ca754d15deb34$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $3b4ca754d15deb34$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $3b4ca754d15deb34$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$3b4ca754d15deb34$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($3b4ca754d15deb34$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});

parcelRegister("9Dg2w", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $hslaz = parcelRequire("hslaz");

var $703432bd8385f5a8$require$isSpace = $hslaz.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$703432bd8385f5a8$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $703432bd8385f5a8$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("JBg9j", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("15GMD", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("6eyHE", function(module, exports) {
// Parser state class
'use strict';

var $flZnN = parcelRequire("flZnN");


var $hslaz = parcelRequire("hslaz");

var $489ef82a8db12637$require$isSpace = $hslaz.isSpace;
function $489ef82a8db12637$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($489ef82a8db12637$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$489ef82a8db12637$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $flZnN(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$489ef82a8db12637$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$489ef82a8db12637$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$489ef82a8db12637$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$489ef82a8db12637$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$489ef82a8db12637$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$489ef82a8db12637$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$489ef82a8db12637$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$489ef82a8db12637$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$489ef82a8db12637$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($489ef82a8db12637$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$489ef82a8db12637$var$StateBlock.prototype.Token = $flZnN;
module.exports = $489ef82a8db12637$var$StateBlock;

});

parcelRegister("1U2TG", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $162d44bcf2210f80$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$162d44bcf2210f80$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("lqNlw", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $f9a24dc6ed71c1cf$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($f9a24dc6ed71c1cf$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("iek5k", function(module, exports) {
// Proceess '\n'
'use strict';

var $hslaz = parcelRequire("hslaz");

var $d4591d407ff4291e$require$isSpace = $hslaz.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $d4591d407ff4291e$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("8Nqk1", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $hslaz = parcelRequire("hslaz");

var $667751518864ee40$require$isSpace = $hslaz.isSpace;
var $667751518864ee40$var$ESCAPED = [];
for(var $667751518864ee40$var$i = 0; $667751518864ee40$var$i < 256; $667751518864ee40$var$i++)$667751518864ee40$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $667751518864ee40$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$667751518864ee40$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $667751518864ee40$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("dPP48", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("45axw", function(module, exports) {
$parcel$export(module.exports, "tokenize", () => $2f8fce09eee1cd09$export$660b2ee2d4fb4eff, (v) => $2f8fce09eee1cd09$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $2f8fce09eee1cd09$export$7b804a0e0ce836d9, (v) => $2f8fce09eee1cd09$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $2f8fce09eee1cd09$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $2f8fce09eee1cd09$export$7b804a0e0ce836d9;
'use strict';
$2f8fce09eee1cd09$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $2f8fce09eee1cd09$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$2f8fce09eee1cd09$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $2f8fce09eee1cd09$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2f8fce09eee1cd09$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("dPUa6", function(module, exports) {
$parcel$export(module.exports, "tokenize", () => $a12b9a62937f3652$export$660b2ee2d4fb4eff, (v) => $a12b9a62937f3652$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $a12b9a62937f3652$export$7b804a0e0ce836d9, (v) => $a12b9a62937f3652$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $a12b9a62937f3652$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $a12b9a62937f3652$export$7b804a0e0ce836d9;
'use strict';
$a12b9a62937f3652$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $a12b9a62937f3652$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$a12b9a62937f3652$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a12b9a62937f3652$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a12b9a62937f3652$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("hpf7X", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $hslaz = parcelRequire("hslaz");

var $cac0816fb5efefbd$require$normalizeReference = $hslaz.normalizeReference;



var $cac0816fb5efefbd$require$isSpace = $hslaz.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$cac0816fb5efefbd$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$cac0816fb5efefbd$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$cac0816fb5efefbd$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$cac0816fb5efefbd$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("gTmYV", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $hslaz = parcelRequire("hslaz");

var $c4c39c1a0853eb44$require$normalizeReference = $hslaz.normalizeReference;



var $c4c39c1a0853eb44$require$isSpace = $hslaz.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$c4c39c1a0853eb44$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$c4c39c1a0853eb44$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$c4c39c1a0853eb44$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$c4c39c1a0853eb44$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("cog6S", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $90543901d9b0dca4$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $90543901d9b0dca4$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($90543901d9b0dca4$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($90543901d9b0dca4$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("jaoOi", function(module, exports) {
// Process html tags
'use strict';

var $dgyOV = parcelRequire("dgyOV");

var $0399d78560af78c7$require$HTML_TAG_RE = $dgyOV.HTML_TAG_RE;
function $0399d78560af78c7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $0399d78560af78c7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $0399d78560af78c7$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$0399d78560af78c7$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($0399d78560af78c7$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($0399d78560af78c7$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($0399d78560af78c7$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("fdC2o", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $7j3pV = parcelRequire("7j3pV");


var $hslaz = parcelRequire("hslaz");

var $b14593671b7e14fd$require$has = $hslaz.has;



var $b14593671b7e14fd$require$isValidEntityCode = $hslaz.isValidEntityCode;



var $b14593671b7e14fd$require$fromCodePoint = $hslaz.fromCodePoint;
var $b14593671b7e14fd$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $b14593671b7e14fd$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($b14593671b7e14fd$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $b14593671b7e14fd$require$isValidEntityCode(code) ? $b14593671b7e14fd$require$fromCodePoint(code) : $b14593671b7e14fd$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($b14593671b7e14fd$var$NAMED_RE);
        if (match) {
            if ($b14593671b7e14fd$require$has($7j3pV, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $7j3pV[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("ddn2p", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $99ee5c1e43454010$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $99ee5c1e43454010$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $99ee5c1e43454010$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("eXNML", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("ib9ax", function(module, exports) {
// Inline parser state
'use strict';

var $flZnN = parcelRequire("flZnN");


var $hslaz = parcelRequire("hslaz");

var $d3c05dd90ff363ac$require$isWhiteSpace = $hslaz.isWhiteSpace;



var $d3c05dd90ff363ac$require$isPunctChar = $hslaz.isPunctChar;



var $d3c05dd90ff363ac$require$isMdAsciiPunct = $hslaz.isMdAsciiPunct;
function $d3c05dd90ff363ac$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$d3c05dd90ff363ac$var$StateInline.prototype.pushPending = function() {
    var token = new $flZnN('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$d3c05dd90ff363ac$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $flZnN(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$d3c05dd90ff363ac$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $d3c05dd90ff363ac$require$isMdAsciiPunct(lastChar) || $d3c05dd90ff363ac$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $d3c05dd90ff363ac$require$isMdAsciiPunct(nextChar) || $d3c05dd90ff363ac$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $d3c05dd90ff363ac$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $d3c05dd90ff363ac$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$d3c05dd90ff363ac$var$StateInline.prototype.Token = $flZnN;
module.exports = $d3c05dd90ff363ac$var$StateInline;

});

parcelRegister("aA4uz", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("6gKKW")).source;
    re.src_Cc = (parcelRequire("7wkNx")).source;
    re.src_Z = (parcelRequire("4QTDX")).source;
    re.src_P = (parcelRequire("eSMp5")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});

parcelRegister("j7DYH", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("ad45r", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("4teFe", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("csam1", function(module, exports) {
var $8f615118f6fafb3b$exports = {};
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $8f615118f6fafb3b$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $8f615118f6fafb3b$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $8f615118f6fafb3b$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
$8f615118f6fafb3b$exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$8f615118f6fafb3b$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $8f615118f6fafb3b$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $8f615118f6fafb3b$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $8f615118f6fafb3b$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $8f615118f6fafb3b$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $8f615118f6fafb3b$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};


var $911021aadcbe4f7e$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($8f615118f6fafb3b$exports))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};
module.exports["markdownItTable"] = $911021aadcbe4f7e$export$26a6b72a65821214;

});

parcelRegister("42JDa", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $2Yzoe = parcelRequire("2Yzoe");

/**
Document schema for the data model used by CommonMark.
*/ const $2f1abea25e652257$export$4902baddc787debb = new (0, $5SAOw.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            code: true,
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $2f1abea25e652257$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $5SAOw.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $2f1abea25e652257$var$MarkdownParseState {
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $2f1abea25e652257$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $5SAOw.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $5SAOw.Mark).none
            }
        ];
    }
}
function $2f1abea25e652257$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $2f1abea25e652257$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $2f1abea25e652257$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $2f1abea25e652257$var$noOp() {}
function $2f1abea25e652257$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($2f1abea25e652257$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $2f1abea25e652257$var$attrs(spec, tok, tokens, i));
                state.addText($2f1abea25e652257$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $2f1abea25e652257$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $2f1abea25e652257$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($2f1abea25e652257$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($2f1abea25e652257$var$attrs(spec, tok, tokens, i)));
                state.addText($2f1abea25e652257$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($2f1abea25e652257$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($2f1abea25e652257$var$noCloseToken(spec, type)) handlers[type] = $2f1abea25e652257$var$noOp;
            else {
                handlers[type + "_open"] = $2f1abea25e652257$var$noOp;
                handlers[type + "_close"] = $2f1abea25e652257$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $2f1abea25e652257$export$a64f782182dea128 {
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $2f1abea25e652257$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $2f1abea25e652257$var$tokenHandlers(schema, tokens);
    }
}
function $2f1abea25e652257$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $2f1abea25e652257$export$7517583227ad0cb8 = new $2f1abea25e652257$export$a64f782182dea128($2f1abea25e652257$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $2f1abea25e652257$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $2f1abea25e652257$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $2f1abea25e652257$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $2f1abea25e652257$export$ae9f6f04acb6c60c {
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $2f1abea25e652257$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $2f1abea25e652257$export$f996452ca6e9a0ae = new $2f1abea25e652257$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $2f1abea25e652257$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $2f1abea25e652257$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $2f1abea25e652257$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $2f1abea25e652257$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $2f1abea25e652257$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $2f1abea25e652257$export$61055fa707e69319 {
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $2f1abea25e652257$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
}
module.exports["MarkdownParser"] = $2f1abea25e652257$export$a64f782182dea128;
module.exports["MarkdownSerializerState"] = $2f1abea25e652257$export$61055fa707e69319;

});

parcelRegister("b0F8r", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $81OAa = parcelRequire("81OAa");


var $d925B = parcelRequire("d925B");


var $azNN5 = parcelRequire("azNN5");


var $3Ter7 = parcelRequire("3Ter7");

const $c470950df2a38b5d$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c470950df2a38b5d$export$dabcc234035f6703 = /^(\$|\{)/;
class $c470950df2a38b5d$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c470950df2a38b5d$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $81OAa.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c470950df2a38b5d$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $81OAa.isSafeUrl)(url)) return url;
    return (0, $81OAa.normalizeUrl)(url);
}
function $c470950df2a38b5d$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $3Ter7.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c470950df2a38b5d$var$findLinkMatches(text).filter((0, $azNN5.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c470950df2a38b5d$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c470950df2a38b5d$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c470950df2a38b5d$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c470950df2a38b5d$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c470950df2a38b5d$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c470950df2a38b5d$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c470950df2a38b5d$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $81OAa.linkify).match(text) || [];
}
const $c470950df2a38b5d$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp -- Ignored via go/ees005
    const localRegExp = new RegExp($c470950df2a38b5d$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c470950df2a38b5d$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c470950df2a38b5d$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c470950df2a38b5d$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c470950df2a38b5d$export$238a6141b3685c21(url)
        }
    };
}
const $c470950df2a38b5d$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard;
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };
module.exports["LinkMatcher"] = $c470950df2a38b5d$export$4490385c12bf3d4;
module.exports["normalizeUrl"] = $c470950df2a38b5d$export$6535eb414fa2c8b6;
module.exports["linkifyContent"] = $c470950df2a38b5d$export$5a511fa58fab15e6;
module.exports["findFilepaths"] = $c470950df2a38b5d$export$d37783fe63e2f0fe;
module.exports["isLinkInMatches"] = $c470950df2a38b5d$export$5e652e74655163e5;
module.exports["getLinkDomain"] = $c470950df2a38b5d$export$238a6141b3685c21;
module.exports["isFromCurrentDomain"] = $c470950df2a38b5d$export$336c6a47b1dfa1bc;
module.exports["getLinkCreationAnalyticsEvent"] = $c470950df2a38b5d$export$56039faad4eda709;
module.exports["canLinkBeCreatedInRange"] = $c470950df2a38b5d$export$b7392a423e62dc8c;

});

parcelRegister("azNN5", function(module, exports) {
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $3c2499649d330fb3$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $3c2499649d330fb3$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$3c2499649d330fb3$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $3c2499649d330fb3$export$e19a09e301eaa6bb(match) {
    return $3c2499649d330fb3$export$977fe75b90bdd614(match.raw);
}
module.exports["shouldAutoLinkifyMatch"] = $3c2499649d330fb3$export$e19a09e301eaa6bb;

});

parcelRegister("3Ter7", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

function $e6152570db050532$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $e6152570db050532$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($e6152570db050532$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $5SAOw.Fragment)) children.push(...$e6152570db050532$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $5SAOw.Fragment).fromArray(children);
}
function $e6152570db050532$export$d8264570c5933bbf(slice, callback) {
    const fragment = $e6152570db050532$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $5SAOw.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $e6152570db050532$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $5SAOw.Fragment).fromArray(fragmentContent);
}
function $e6152570db050532$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $5SAOw.Fragment) ? node : node.content));
    return array;
}
const $e6152570db050532$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $e6152570db050532$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$e6152570db050532$var$findNode(predicate)(slice);
    };
module.exports["getFragmentBackingArray"] = $e6152570db050532$export$7b8536c35e9eb7d2;
module.exports["mapFragment"] = $e6152570db050532$export$81fe6b3b714fd0bf;
module.exports["mapSlice"] = $e6152570db050532$export$d8264570c5933bbf;
module.exports["flatmap"] = $e6152570db050532$export$c575791007f9dbd1;
module.exports["mapChildren"] = $e6152570db050532$export$e0baa27f47733a4a;
module.exports["hasNode"] = $e6152570db050532$export$b6ae752d7894ad08;

});

parcelRegister("9hDHZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c2480da09d16f89$export$2e2bcd8739ae039);
function $6c2480da09d16f89$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("c3Z6w", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c8529e15839e3e9$export$2e2bcd8739ae039);

var $2h3f7 = parcelRequire("2h3f7");


var $bIrEX = parcelRequire("bIrEX");


var $7HtfM = parcelRequire("7HtfM");


var $eDMGY = parcelRequire("eDMGY");


var $g3Gzi = parcelRequire("g3Gzi");


var $egXhZ = parcelRequire("egXhZ");


var $hG32I = parcelRequire("hG32I");


var $9hDHZ = parcelRequire("9hDHZ");


var $qc9ak = parcelRequire("qc9ak");


var $b5utg = parcelRequire("b5utg");

var $8c8529e15839e3e9$var$MINUTES_IN_DAY = 1440;
var $8c8529e15839e3e9$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $8c8529e15839e3e9$var$MINUTES_IN_MONTH = 43200;
var $8c8529e15839e3e9$var$MINUTES_IN_TWO_MONTHS = 86400;
function $8c8529e15839e3e9$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $b5utg.default)(2, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $g3Gzi.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $bIrEX.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $9hDHZ.default)((0, $hG32I.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $egXhZ.default)(dirtyBaseDate);
        dateRight = (0, $egXhZ.default)(dirtyDate);
    } else {
        dateLeft = (0, $egXhZ.default)(dirtyDate);
        dateRight = (0, $egXhZ.default)(dirtyBaseDate);
    }
    var seconds = (0, $eDMGY.default)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $qc9ak.default)(dateRight) - (0, $qc9ak.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $7HtfM.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}

});

parcelRegister("bIrEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8879425dbfc491c0$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $8879425dbfc491c0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("7HtfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $59b33dafbf54dd0b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $2U6f2 = parcelRequire("2U6f2");


var $bIrEX = parcelRequire("bIrEX");


var $b5utg = parcelRequire("b5utg");


var $7aUsh = parcelRequire("7aUsh");

function $59b33dafbf54dd0b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var sign = (0, $bIrEX.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $2U6f2.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $bIrEX.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $7aUsh.default)((0, $egXhZ.default)(dirtyDateLeft)) && difference === 1 && (0, $bIrEX.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("2U6f2", function(module, exports) {
$parcel$export(module.exports, "default", () => $21d5a727b9d6b5f1$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $21d5a727b9d6b5f1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("7aUsh", function(module, exports) {
$parcel$export(module.exports, "default", () => $5395425e245a8a7a$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $52s3i = parcelRequire("52s3i");


var $jBv2F = parcelRequire("jBv2F");


var $b5utg = parcelRequire("b5utg");

function $5395425e245a8a7a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    return (0, $52s3i.default)(date).getTime() === (0, $jBv2F.default)(date).getTime();
}

});

parcelRegister("52s3i", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ab2e6405264a6ac$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $3ab2e6405264a6ac$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("jBv2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4598d57c80bb5c7$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $e4598d57c80bb5c7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("eDMGY", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa8a7a6d6e092fc8$export$2e2bcd8739ae039);

var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $aa8a7a6d6e092fc8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / 1000;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hG32I", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde8b8224908a12d$export$2e2bcd8739ae039);

var $9hDHZ = parcelRequire("9hDHZ");

function $cde8b8224908a12d$export$2e2bcd8739ae039(object) {
    return (0, $9hDHZ.default)({}, object);
}

});

parcelRegister("dIxHZ", function(module, exports) {

var $2Hy4R = parcelRequire("2Hy4R");


var $dlSEv = parcelRequire("dlSEv");


var $1oCLl = parcelRequire("1oCLl");

var $73c40f69a74688ac$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($73c40f69a74688ac$var$FORMATS || {});
const $73c40f69a74688ac$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $73c40f69a74688ac$export$6297728405c48562 = (timeZone)=>{
    const today = new Date(Date.now());
    if (timeZone && (0, $1oCLl.expValEquals)('confluence_frontend_fix_date_hydration_error', 'isEnabled', true)) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).formatToParts(today);
        const year = Number(parts.find((p)=>p.type === 'year')?.value);
        const month = Number(parts.find((p)=>p.type === 'month')?.value) - 1;
        const day = Number(parts.find((p)=>p.type === 'day')?.value);
        return Date.UTC(year, month, day).toString();
    }
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $73c40f69a74688ac$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $73c40f69a74688ac$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $73c40f69a74688ac$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $73c40f69a74688ac$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $73c40f69a74688ac$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$73c40f69a74688ac$var$addLeadingZero(date.getUTCMonth() + 1)}-${$73c40f69a74688ac$var$addLeadingZero(date.getUTCDate())}`;
};
const $73c40f69a74688ac$export$e6cc7bfc6e0e363e = (timestamp, timeZone)=>{
    return (0, $dlSEv.default)(new Date(Number(timestamp)), new Date(Number($73c40f69a74688ac$export$6297728405c48562(timeZone))));
};
const $73c40f69a74688ac$export$fbc04a9e57b04a80 = (timestamp, intl, timeZone)=>{
    const curDate = new Date(Number($73c40f69a74688ac$export$6297728405c48562(timeZone)));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $2Hy4R.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $73c40f69a74688ac$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $73c40f69a74688ac$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};
module.exports["timestampToUTCDate"] = $73c40f69a74688ac$export$56c3660a4ee2196a;
module.exports["todayTimestampInUTC"] = $73c40f69a74688ac$export$6297728405c48562;
module.exports["timestampToString"] = $73c40f69a74688ac$export$48755a044ef883a0;
module.exports["timestampToIsoFormat"] = $73c40f69a74688ac$export$70a1b7b6fffe4dd1;
module.exports["isPastDate"] = $73c40f69a74688ac$export$e6cc7bfc6e0e363e;
module.exports["timestampToTaskContext"] = $73c40f69a74688ac$export$fbc04a9e57b04a80;

});

parcelRegister("1R4Hk", function(module, exports) {

var $cOrQJ = parcelRequire("cOrQJ");

const $c6444b27b54a07b6$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};
module.exports["useIconThemed"] = $c6444b27b54a07b6$export$a38bb9a8c9e5bc30;

});

parcelRegister("lqWNh", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $3UbBx = parcelRequire("3UbBx");

const $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $3UbBx.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $f9e9293fb4fd549c$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $f9e9293fb4fd549c$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $f9e9293fb4fd549c$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn, bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn,
        bodiedSyncBlock
    ]);
    return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $f9e9293fb4fd549c$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $f9e9293fb4fd549c$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $f9e9293fb4fd549c$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $3UbBx.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $3UbBx.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $f9e9293fb4fd549c$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $3UbBx.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $3UbBx.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $aFUXX.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}
module.exports["shouldAddDefaultWrappedWidth"] = $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e;
module.exports["nonWrappedLayouts"] = $f9e9293fb4fd549c$export$607795ead6e50626;
module.exports["floatingLayouts"] = $f9e9293fb4fd549c$export$7c0073a4d21b222d;
module.exports["isRichMediaInsideOfBlockNode"] = $f9e9293fb4fd549c$export$55fb9d6810f2e04b;
module.exports["alignAttributes"] = $f9e9293fb4fd549c$export$b2258912a400ba32;
module.exports["calculateSnapPoints"] = $f9e9293fb4fd549c$export$de65085e667b4bf1;

});

parcelRegister("3UbBx", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $gAARK = parcelRequire("gAARK");

const $7bd202241742fd44$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $7bd202241742fd44$export$adfc02948d64a4f2 = (layout)=>$7bd202241742fd44$var$validWidthModes.indexOf(layout) > -1;
function $7bd202241742fd44$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7bd202241742fd44$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $7bd202241742fd44$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7bd202241742fd44$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $7bd202241742fd44$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $7bd202241742fd44$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($7bd202241742fd44$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $7bd202241742fd44$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $7bd202241742fd44$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $7bd202241742fd44$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $aFUXX.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $aFUXX.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($7bd202241742fd44$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return calculatedPctWidth;
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $7bd202241742fd44$export$405baca3d8bc263d.indexOf(layout) !== -1) // when layout is wrap-left, wrap-right, align-start, align-end
    // but no pctWidth is defined
    return Math.min($7bd202241742fd44$export$e70e278a1f662f8d(0.5, lineLength || width), origWidth);
    return origWidth;
};
const $7bd202241742fd44$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $7bd202241742fd44$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($7bd202241742fd44$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $7bd202241742fd44$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};
module.exports["calcPxFromColumns"] = $7bd202241742fd44$export$1e3701608f0cee80;
module.exports["calcColumnsFromPx"] = $7bd202241742fd44$export$10912f14d8d54640;
module.exports["calcPctFromPx"] = $7bd202241742fd44$export$55ddb36b3404ec6d;
module.exports["wrappedLayouts"] = $7bd202241742fd44$export$405baca3d8bc263d;
module.exports["calcMediaPxWidth"] = $7bd202241742fd44$export$5e51fc02b9ada5af;

});

parcelRegister("bEi27", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $259677dc07a6f27a$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $259677dc07a6f27a$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dyM9V")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $259677dc07a6f27a$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($259677dc07a6f27a$var$LazyAssetsConfigModal, props));
};
var $259677dc07a6f27a$export$2e2bcd8739ae039 = $259677dc07a6f27a$var$AssetsConfigModalWithWrappers;
module.exports["ASSETS_LIST_OF_LINKS_DATASOURCE_ID"] = $259677dc07a6f27a$export$34a6fbdd67f09ff6;
module.exports["default"] = $259677dc07a6f27a$export$2e2bcd8739ae039;

});

parcelRegister("dyM9V", function(module, exports) {

let $9df3ceb73ee41d48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9df3ceb73ee41d48$var$load("lTK3c"),
    $9df3ceb73ee41d48$var$load("1WXdc"),
    $9df3ceb73ee41d48$var$load("gYr8z"),
    $9df3ceb73ee41d48$var$load("1WCMN"),
    $9df3ceb73ee41d48$var$load("5pvpJ"),
    $9df3ceb73ee41d48$var$load("eXGjr"),
    $9df3ceb73ee41d48$var$load("iNa18"),
    $9df3ceb73ee41d48$var$load("8makw"),
    $9df3ceb73ee41d48$var$load("b7Mr5"),
    $9df3ceb73ee41d48$var$load("89ROx"),
    $9df3ceb73ee41d48$var$load("wicoc"),
    $9df3ceb73ee41d48$var$load("a6sUl"),
    $9df3ceb73ee41d48$var$load("gFEtJ"),
    $9df3ceb73ee41d48$var$load("gT8XU"),
    $9df3ceb73ee41d48$var$load("28arV"),
    $9df3ceb73ee41d48$var$load("hv4mn"),
    $9df3ceb73ee41d48$var$load("iivLa"),
    $9df3ceb73ee41d48$var$load("6wr18"),
    $9df3ceb73ee41d48$var$load("ffEVr"),
    $9df3ceb73ee41d48$var$load("dek7I"),
    $9df3ceb73ee41d48$var$load("kHOMt"),
    $9df3ceb73ee41d48$var$load("hhss7"),
    $9df3ceb73ee41d48$var$load("2BARG"),
    $9df3ceb73ee41d48$var$load("gepVN"),
    $9df3ceb73ee41d48$var$load("2QTNW"),
    $9df3ceb73ee41d48$var$load("7EorR"),
    $9df3ceb73ee41d48$var$load("Wowvf"),
    $9df3ceb73ee41d48$var$load("etEYy"),
    $9df3ceb73ee41d48$var$load("eSDS8")
]).then(()=>parcelRequire('75SNN'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("16GCc", function(module, exports) {

var $bEi27 = parcelRequire("bEi27");

var $jPEjP = parcelRequire("jPEjP");

var $iB8ko = parcelRequire("iB8ko");


var $dh538 = parcelRequire("dh538");

const $4d17943085b99665$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $iB8ko.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $4d17943085b99665$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $4d17943085b99665$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $dh538.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};
module.exports["getDatasourceType"] = $4d17943085b99665$export$19af9860957ca153;
module.exports["canRenderDatasource"] = $4d17943085b99665$export$1974047c293dd52e;

});

parcelRegister("jPEjP", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $eb530dc3f36406bb$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $eb530dc3f36406bb$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bqKoI")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $eb530dc3f36406bb$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eb530dc3f36406bb$var$LazyConfluenceSearchConfigModal, props));
};
var $eb530dc3f36406bb$export$2e2bcd8739ae039 = $eb530dc3f36406bb$var$ConfluenceSearchConfigModalWithWrappers;
module.exports["CONFLUENCE_SEARCH_DATASOURCE_ID"] = $eb530dc3f36406bb$export$d9788d6cf1867282;
module.exports["default"] = $eb530dc3f36406bb$export$2e2bcd8739ae039;

});

parcelRegister("bqKoI", function(module, exports) {

let $85261d015d4d2bec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $85261d015d4d2bec$var$load("lTK3c"),
    $85261d015d4d2bec$var$load("1WXdc"),
    $85261d015d4d2bec$var$load("gYr8z"),
    $85261d015d4d2bec$var$load("1WCMN"),
    $85261d015d4d2bec$var$load("5YOHm"),
    $85261d015d4d2bec$var$load("5pvpJ"),
    $85261d015d4d2bec$var$load("eXGjr"),
    $85261d015d4d2bec$var$load("knC1t"),
    $85261d015d4d2bec$var$load("iNa18"),
    $85261d015d4d2bec$var$load("8makw"),
    $85261d015d4d2bec$var$load("b7Mr5"),
    $85261d015d4d2bec$var$load("89ROx"),
    $85261d015d4d2bec$var$load("wicoc"),
    $85261d015d4d2bec$var$load("a6sUl"),
    $85261d015d4d2bec$var$load("gFEtJ"),
    $85261d015d4d2bec$var$load("gT8XU"),
    $85261d015d4d2bec$var$load("28arV"),
    $85261d015d4d2bec$var$load("hv4mn"),
    $85261d015d4d2bec$var$load("iivLa"),
    $85261d015d4d2bec$var$load("6wr18"),
    $85261d015d4d2bec$var$load("ffEVr"),
    $85261d015d4d2bec$var$load("dek7I"),
    $85261d015d4d2bec$var$load("kHOMt"),
    $85261d015d4d2bec$var$load("hhss7"),
    $85261d015d4d2bec$var$load("2BARG"),
    $85261d015d4d2bec$var$load("gepVN"),
    $85261d015d4d2bec$var$load("2QTNW"),
    $85261d015d4d2bec$var$load("7EorR"),
    $85261d015d4d2bec$var$load("Wowvf"),
    $85261d015d4d2bec$var$load("etEYy"),
    $85261d015d4d2bec$var$load("40QiO")
]).then(()=>parcelRequire('4dMJk'));

});

parcelRegister("iB8ko", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0a545d08f6a56386$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $0a545d08f6a56386$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cY3vT")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $0a545d08f6a56386$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a545d08f6a56386$var$LazyJiraIssuesConfigModal, props));
};
var $0a545d08f6a56386$export$2e2bcd8739ae039 = $0a545d08f6a56386$var$JiraIssuesConfigModalWithWrappers;
module.exports["JIRA_LIST_OF_LINKS_DATASOURCE_ID"] = $0a545d08f6a56386$export$8ce19958117ece5c;
module.exports["default"] = $0a545d08f6a56386$export$2e2bcd8739ae039;

});

parcelRegister("cY3vT", function(module, exports) {

let $970dd0531a630b0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $970dd0531a630b0d$var$load("lTK3c"),
    $970dd0531a630b0d$var$load("1WXdc"),
    $970dd0531a630b0d$var$load("gYr8z"),
    $970dd0531a630b0d$var$load("1WCMN"),
    $970dd0531a630b0d$var$load("3ufWD"),
    $970dd0531a630b0d$var$load("7Bi4V"),
    $970dd0531a630b0d$var$load("9ijrN"),
    $970dd0531a630b0d$var$load("iFEfD"),
    $970dd0531a630b0d$var$load("4xzkC"),
    $970dd0531a630b0d$var$load("1oAGT"),
    $970dd0531a630b0d$var$load("b0mVb"),
    $970dd0531a630b0d$var$load("1Qgo1"),
    $970dd0531a630b0d$var$load("e4wOQ"),
    $970dd0531a630b0d$var$load("gnDXu"),
    $970dd0531a630b0d$var$load("5YOHm"),
    $970dd0531a630b0d$var$load("5pvpJ"),
    $970dd0531a630b0d$var$load("eXGjr"),
    $970dd0531a630b0d$var$load("jtcRz"),
    $970dd0531a630b0d$var$load("1Pok1"),
    $970dd0531a630b0d$var$load("l8LQp"),
    $970dd0531a630b0d$var$load("iNa18"),
    $970dd0531a630b0d$var$load("8makw"),
    $970dd0531a630b0d$var$load("b7Mr5"),
    $970dd0531a630b0d$var$load("89ROx"),
    $970dd0531a630b0d$var$load("wicoc"),
    $970dd0531a630b0d$var$load("a6sUl"),
    $970dd0531a630b0d$var$load("gFEtJ"),
    $970dd0531a630b0d$var$load("gT8XU"),
    $970dd0531a630b0d$var$load("28arV"),
    $970dd0531a630b0d$var$load("hv4mn"),
    $970dd0531a630b0d$var$load("iivLa"),
    $970dd0531a630b0d$var$load("6wr18"),
    $970dd0531a630b0d$var$load("ffEVr"),
    $970dd0531a630b0d$var$load("dek7I"),
    $970dd0531a630b0d$var$load("kHOMt"),
    $970dd0531a630b0d$var$load("hhss7"),
    $970dd0531a630b0d$var$load("2BARG"),
    $970dd0531a630b0d$var$load("gepVN"),
    $970dd0531a630b0d$var$load("2QTNW"),
    $970dd0531a630b0d$var$load("7EorR"),
    $970dd0531a630b0d$var$load("Wowvf"),
    $970dd0531a630b0d$var$load("etEYy"),
    $970dd0531a630b0d$var$load("2Aekd")
]).then(()=>parcelRequire('ksmD9'));

});

parcelRegister("astHL", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");

/**
Delete the selection, if there is one.
*/ const $79d38fafc7d67c3d$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $79d38fafc7d67c3d$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $aXG5V.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($79d38fafc7d67c3d$var$textblockAt(before, "end") || (0, $ks2lK.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $aXG5V.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $5SAOw.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($79d38fafc7d67c3d$var$textblockAt(before, "end") ? (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $ks2lK.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $79d38fafc7d67c3d$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutBefore($cursor);
    return $cut ? $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $79d38fafc7d67c3d$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutAfter($cursor);
    return $cut ? $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $aXG5V.replaceStep)(state.doc, beforePos, afterPos, (0, $5SAOw.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $aXG5V.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $79d38fafc7d67c3d$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $79d38fafc7d67c3d$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $79d38fafc7d67c3d$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $ks2lK.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $79d38fafc7d67c3d$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $79d38fafc7d67c3d$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($79d38fafc7d67c3d$var$textblockAt(after, "start") || (0, $ks2lK.NodeSelection).isSelectable(after))) {
        let delStep = (0, $aXG5V.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $5SAOw.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($79d38fafc7d67c3d$var$textblockAt(after, "start") ? (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $79d38fafc7d67c3d$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $79d38fafc7d67c3d$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $ks2lK.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $79d38fafc7d67c3d$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $ks2lK.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $aXG5V.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $aXG5V.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $79d38fafc7d67c3d$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $ks2lK.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $aXG5V.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $aXG5V.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $79d38fafc7d67c3d$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $aXG5V.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $79d38fafc7d67c3d$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $79d38fafc7d67c3d$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $79d38fafc7d67c3d$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $79d38fafc7d67c3d$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $ks2lK.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $79d38fafc7d67c3d$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $79d38fafc7d67c3d$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $aXG5V.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $aXG5V.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $79d38fafc7d67c3d$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $aXG5V.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $79d38fafc7d67c3d$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $ks2lK.TextSelection) || state.selection instanceof (0, $ks2lK.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $aXG5V.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $aXG5V.canSplit)(tr.doc, splitPos, types.length, types);
        }
        if (!can) return false;
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $79d38fafc7d67c3d$export$e99155638ff4dff0 = $79d38fafc7d67c3d$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $79d38fafc7d67c3d$export$eeb429476568b72b = (state, dispatch)=>{
    return $79d38fafc7d67c3d$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $79d38fafc7d67c3d$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $79d38fafc7d67c3d$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $ks2lK.AllSelection)(state.doc)));
    return true;
};
function $79d38fafc7d67c3d$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $aXG5V.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $79d38fafc7d67c3d$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $5SAOw.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $5SAOw.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $5SAOw.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $5SAOw.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $aXG5V.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $ks2lK.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $aXG5V.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $79d38fafc7d67c3d$var$textblockAt(after, "start", true) && $79d38fafc7d67c3d$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $5SAOw.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $5SAOw.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $5SAOw.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $79d38fafc7d67c3d$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $79d38fafc7d67c3d$export$c3a64f3c9604a1b1 = $79d38fafc7d67c3d$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $79d38fafc7d67c3d$export$a66c1876556415e5 = $79d38fafc7d67c3d$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $79d38fafc7d67c3d$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $aXG5V.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $79d38fafc7d67c3d$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $79d38fafc7d67c3d$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $79d38fafc7d67c3d$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $ks2lK.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $ks2lK.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $79d38fafc7d67c3d$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    let dropSpace = !(options && options.includeWhitespace);
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$79d38fafc7d67c3d$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $79d38fafc7d67c3d$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = dropSpace && start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = dropSpace && end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $79d38fafc7d67c3d$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $aXG5V.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $79d38fafc7d67c3d$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $79d38fafc7d67c3d$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $79d38fafc7d67c3d$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $79d38fafc7d67c3d$var$backspace = $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$e9a518a637d1e641, $79d38fafc7d67c3d$export$979097b097459299, $79d38fafc7d67c3d$export$52b8a4af68d19794);
let $79d38fafc7d67c3d$var$del = $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$e9a518a637d1e641, $79d38fafc7d67c3d$export$bf432e340007f9ef, $79d38fafc7d67c3d$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $79d38fafc7d67c3d$export$eb36e8971b04df36 = {
    "Enter": $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$a5d02b4b65e94f91, $79d38fafc7d67c3d$export$d0f80ac1b4510888, $79d38fafc7d67c3d$export$a3574cc681852c08, $79d38fafc7d67c3d$export$e99155638ff4dff0),
    "Mod-Enter": $79d38fafc7d67c3d$export$634b78845598ff5b,
    "Backspace": $79d38fafc7d67c3d$var$backspace,
    "Mod-Backspace": $79d38fafc7d67c3d$var$backspace,
    "Shift-Backspace": $79d38fafc7d67c3d$var$backspace,
    "Delete": $79d38fafc7d67c3d$var$del,
    "Mod-Delete": $79d38fafc7d67c3d$var$del,
    "Mod-a": $79d38fafc7d67c3d$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $79d38fafc7d67c3d$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $79d38fafc7d67c3d$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $79d38fafc7d67c3d$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $79d38fafc7d67c3d$export$c3a64f3c9604a1b1,
    "Ctrl-e": $79d38fafc7d67c3d$export$a66c1876556415e5
};
for(let key in $79d38fafc7d67c3d$export$eb36e8971b04df36)$79d38fafc7d67c3d$export$f292ad8dbd5063c8[key] = $79d38fafc7d67c3d$export$eb36e8971b04df36[key];
const $79d38fafc7d67c3d$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $79d38fafc7d67c3d$export$4a0c2b85b1f0a889 = $79d38fafc7d67c3d$var$mac ? $79d38fafc7d67c3d$export$f292ad8dbd5063c8 : $79d38fafc7d67c3d$export$eb36e8971b04df36;
module.exports["deleteSelection"] = $79d38fafc7d67c3d$export$e9a518a637d1e641;
module.exports["selectNodeBackward"] = $79d38fafc7d67c3d$export$52b8a4af68d19794;
module.exports["exitCode"] = $79d38fafc7d67c3d$export$634b78845598ff5b;
module.exports["createParagraphNear"] = $79d38fafc7d67c3d$export$d0f80ac1b4510888;
module.exports["splitBlock"] = $79d38fafc7d67c3d$export$e99155638ff4dff0;
module.exports["selectAll"] = $79d38fafc7d67c3d$export$90aca4adda6ff0f5;
module.exports["toggleMark"] = $79d38fafc7d67c3d$export$797ad2667b8015a8;
module.exports["autoJoin"] = $79d38fafc7d67c3d$export$29903073afddcd8b;
module.exports["chainCommands"] = $79d38fafc7d67c3d$export$146a774cdef7663a;
module.exports["baseKeymap"] = $79d38fafc7d67c3d$export$4a0c2b85b1f0a889;

});

parcelRegister("dus6D", function(module, exports) {

var $kbdB6 = parcelRequire("kbdB6");


var $ks2lK = parcelRequire("ks2lK");

const $9d23e0fec4dbb6f3$var$mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
const $9d23e0fec4dbb6f3$var$windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function $9d23e0fec4dbb6f3$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($9d23e0fec4dbb6f3$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $9d23e0fec4dbb6f3$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$9d23e0fec4dbb6f3$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $9d23e0fec4dbb6f3$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $9d23e0fec4dbb6f3$export$5043418e2ef368d5(bindings) {
    return new (0, $ks2lK.Plugin)({
        props: {
            handleKeyDown: $9d23e0fec4dbb6f3$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $9d23e0fec4dbb6f3$export$53f558754f8b9fd1(bindings) {
    let map = $9d23e0fec4dbb6f3$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $kbdB6.keyName)(event), baseName, direct = map[$9d23e0fec4dbb6f3$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$9d23e0fec4dbb6f3$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
            !($9d23e0fec4dbb6f3$var$windows && event.ctrlKey && event.altKey) && (baseName = (0, $kbdB6.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060, #1529.
                let fromCode = map[$9d23e0fec4dbb6f3$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}
module.exports["keymap"] = $9d23e0fec4dbb6f3$export$5043418e2ef368d5;
module.exports["keydownHandler"] = $9d23e0fec4dbb6f3$export$53f558754f8b9fd1;

});

parcelRegister("kbdB6", function(module, exports) {
var $eb0f61e1b4303330$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $eb0f61e1b4303330$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $eb0f61e1b4303330$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $eb0f61e1b4303330$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $eb0f61e1b4303330$var$i = 0; $eb0f61e1b4303330$var$i < 10; $eb0f61e1b4303330$var$i++)$eb0f61e1b4303330$export$e2253033e6e1df16[48 + $eb0f61e1b4303330$var$i] = $eb0f61e1b4303330$export$e2253033e6e1df16[96 + $eb0f61e1b4303330$var$i] = String($eb0f61e1b4303330$var$i);
// The function keys
for(var $eb0f61e1b4303330$var$i = 1; $eb0f61e1b4303330$var$i <= 24; $eb0f61e1b4303330$var$i++)$eb0f61e1b4303330$export$e2253033e6e1df16[$eb0f61e1b4303330$var$i + 111] = "F" + $eb0f61e1b4303330$var$i;
// And the alphabetic keys
for(var $eb0f61e1b4303330$var$i = 65; $eb0f61e1b4303330$var$i <= 90; $eb0f61e1b4303330$var$i++){
    $eb0f61e1b4303330$export$e2253033e6e1df16[$eb0f61e1b4303330$var$i] = String.fromCharCode($eb0f61e1b4303330$var$i + 32);
    $eb0f61e1b4303330$export$fba63a578e423eb[$eb0f61e1b4303330$var$i] = String.fromCharCode($eb0f61e1b4303330$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $eb0f61e1b4303330$var$code in $eb0f61e1b4303330$export$e2253033e6e1df16)if (!$eb0f61e1b4303330$export$fba63a578e423eb.hasOwnProperty($eb0f61e1b4303330$var$code)) $eb0f61e1b4303330$export$fba63a578e423eb[$eb0f61e1b4303330$var$code] = $eb0f61e1b4303330$export$e2253033e6e1df16[$eb0f61e1b4303330$var$code];
function $eb0f61e1b4303330$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $eb0f61e1b4303330$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $eb0f61e1b4303330$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $eb0f61e1b4303330$export$fba63a578e423eb : $eb0f61e1b4303330$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}
module.exports["base"] = $eb0f61e1b4303330$export$e2253033e6e1df16;
module.exports["shift"] = $eb0f61e1b4303330$export$fba63a578e423eb;
module.exports["keyName"] = $eb0f61e1b4303330$export$fb33aafd75404f4c;

});

parcelRegister("ke2AI", function(module, exports) {
var $b7997750bf90f21f$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $b7997750bf90f21f$var$RopeSequence = function RopeSequence() {};
$b7997750bf90f21f$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $b7997750bf90f21f$var$RopeSequence.from(other);
    return !this.length && other || other.length < $b7997750bf90f21f$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $b7997750bf90f21f$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$b7997750bf90f21f$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $b7997750bf90f21f$var$RopeSequence.from(other).append(this);
};
$b7997750bf90f21f$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $b7997750bf90f21f$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$b7997750bf90f21f$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $b7997750bf90f21f$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$b7997750bf90f21f$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$b7997750bf90f21f$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$b7997750bf90f21f$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$b7997750bf90f21f$var$RopeSequence.from = function from(values) {
    if (values instanceof $b7997750bf90f21f$var$RopeSequence) return values;
    return values && values.length ? new $b7997750bf90f21f$var$Leaf(values) : $b7997750bf90f21f$var$RopeSequence.empty;
};
var $b7997750bf90f21f$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $b7997750bf90f21f$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $b7997750bf90f21f$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($b7997750bf90f21f$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$b7997750bf90f21f$var$RopeSequence.empty = new $b7997750bf90f21f$var$Leaf([]);
var $b7997750bf90f21f$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($b7997750bf90f21f$var$RopeSequence);
var $b7997750bf90f21f$export$2e2bcd8739ae039 = $b7997750bf90f21f$var$RopeSequence;



var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");




class $59f7b5b301f829df$export$ebdc1f934f4dd665 {
    constructor(step, inverted){
        this.step = step;
        this.inverted = inverted;
    }
}
function $59f7b5b301f829df$export$6137dcc98f08e76(steps, finalDoc) {
    for (const step of steps.slice().reverse())try {
        const result = step.inverted.apply(finalDoc);
        if (result.failed === null && result.doc) finalDoc = result.doc;
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    let tr = new (0, $aXG5V.Transform)(finalDoc);
    for (const step of steps)try {
        tr = tr.step(step.step);
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    return tr;
}
function $59f7b5b301f829df$export$3cddda3829daa1af(steps, tr) {
    if (steps === undefined) return undefined;
    return steps.map((step)=>{
        const newStep = step.step.map(tr.mapping);
        const newInvertedStep = step.inverted.map(tr.mapping);
        if (newStep && newInvertedStep) return new $59f7b5b301f829df$export$ebdc1f934f4dd665(newStep, newInvertedStep);
        return undefined;
    }).filter((s)=>!!s);
}


var $763dcf87625ae905$var$_Branch;
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $763dcf87625ae905$var$max_empty_items = 500;
class $763dcf87625ae905$var$Branch {
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            const next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        const transform = state.tr;
        let selection, remaining;
        const addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $763dcf87625ae905$var$Item(item.map));
                const step = item.step.map(remap.slice(mapFrom));
                let map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $763dcf87625ae905$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $763dcf87625ae905$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        const newItems = [];
        let eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            const step = transform.steps[i].invert(transform.docs[i]);
            let item = new $763dcf87625ae905$var$Item(transform.mapping.maps[i], step, selection), merged;
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line no-cond-assign
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        const overflow = eventCount - histOptions.depth;
        if (overflow > $763dcf87625ae905$var$DEPTH_OVERFLOW) {
            oldItems = $763dcf87625ae905$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $763dcf87625ae905$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        const maps = new (0, $aXG5V.Mapping)();
        this.items.forEach((item, i)=>{
            const mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return this;
        return new $763dcf87625ae905$var$Branch(this.items.append(array.map((map)=>new $763dcf87625ae905$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        const rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        const mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            const pos = mapping.getMirror(--iRebased);
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line eqeqeq
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            const map = mapping.maps[pos];
            if (item.step) {
                const step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                const selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $763dcf87625ae905$var$Item(map, step, selection));
            } else rebasedItems.push(new $763dcf87625ae905$var$Item(map));
        }, start);
        const newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $763dcf87625ae905$var$Item(mapping.maps[i]));
        const items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $763dcf87625ae905$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $763dcf87625ae905$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        const remap = this.remapping(0, upto);
        let mapFrom = remap.maps.length;
        const items = [];
        let events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                const step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    const selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const newItem = new $763dcf87625ae905$var$Item(map.invert(), step, selection);
                    let merged;
                    const last = items.length - 1;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line no-cond-assign
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $763dcf87625ae905$var$Branch((0, $b7997750bf90f21f$export$2e2bcd8739ae039).from(items.reverse()), events);
    }
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
}
$763dcf87625ae905$var$_Branch = $763dcf87625ae905$var$Branch;
$763dcf87625ae905$var$Branch.empty = new $763dcf87625ae905$var$_Branch((0, $b7997750bf90f21f$export$2e2bcd8739ae039).empty, 0);
function $763dcf87625ae905$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return items.slice(cutPoint);
}
class $763dcf87625ae905$var$Item {
    merge(other) {
        if (this.step && other.step && !other.selection) {
            const step = other.step.merge(this.step);
            if (step) return new $763dcf87625ae905$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $763dcf87625ae905$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition, /**
   * ===
   * FORK ADDITION START
   * Allow for "history slicing" which groups together changes regardless of time / position adjacency
   */ historySliceActive, trackedSteps, selectionBookmark){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
        this.historySliceActive = historySliceActive;
        this.trackedSteps = trackedSteps;
        this.selectionBookmark = selectionBookmark;
    }
}
const $763dcf87625ae905$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $763dcf87625ae905$var$applyTransaction(history, state, tr, options) {
    const historyTr = tr.getMeta($763dcf87625ae905$var$historyKey);
    let rebased;
    if (historyTr) return historyTr.historyState;
    /**
   * ===
   * FORK ADDITION START
   * If history slicing is active, we want to continue the current slice
   */ if ((tr.getMeta('startHistorySlice') === true || history?.historySliceActive) && tr.getMeta('endHistorySlice') !== true) {
        const shouldIgnoreChange = tr.getMeta('isRemote');
        if (shouldIgnoreChange) {
            // For addToHistory=false transactions during a slice, we need to:
            // 1. Update the mapping for done/undone branches
            // 2. Map the existing steps
            // 3. Update the document to rebaseline
            const mappedRanges = history.prevRanges ? $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new $763dcf87625ae905$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition, true, (0, $59f7b5b301f829df$export$3cddda3829daa1af)(history.trackedSteps, tr), history.selectionBookmark);
        }
        const startHistorySlice = tr.getMeta('startHistorySlice') === true;
        const newTrackedSteps = [
            ...history.trackedSteps || [],
            ...tr.steps.map((s, idx)=>new (0, $59f7b5b301f829df$export$ebdc1f934f4dd665)(s, s.invert(tr.docs[idx])))
        ];
        const mappedRanges = history.prevRanges ? $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new $763dcf87625ae905$var$HistoryState(history.done, startHistorySlice ? $763dcf87625ae905$var$Branch.empty : history.undone, mappedRanges, history.prevTime, history.prevComposition, true, newTrackedSteps, startHistorySlice ? state.selection.getBookmark() : history.selectionBookmark);
    } else if (tr.getMeta('endHistorySlice') === true && history.historySliceActive) {
        const trackedSteps = history.historySliceActive ? history.trackedSteps || [] : [];
        // Create transform that represents the changes made during the slice
        // Use the original slice document as the base
        const transform = (0, $59f7b5b301f829df$export$6137dcc98f08e76)(trackedSteps, tr.doc);
        const mappedRanges = history.prevRanges ? $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new $763dcf87625ae905$var$HistoryState(history.done.addMaps(tr.mapping.maps).addTransform(transform, history.selectionBookmark, options, $763dcf87625ae905$var$mustPreserveItems(state)), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition);
    }
    /**
   * FORK ADDITION END
   * ===
   */ if (tr.getMeta($763dcf87625ae905$var$closeHistoryKey)) history = new $763dcf87625ae905$var$HistoryState(history.done, history.undone, null, 0, -1);
    const appended = tr.getMeta('appendedTransaction');
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($763dcf87625ae905$var$historyKey)) {
        if (appended.getMeta($763dcf87625ae905$var$historyKey).redo) return new $763dcf87625ae905$var$HistoryState(history.done.addTransform(tr, undefined, options, $763dcf87625ae905$var$mustPreserveItems(state)), history.undone, $763dcf87625ae905$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $763dcf87625ae905$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $763dcf87625ae905$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta('addToHistory') !== false && !(appended && appended.getMeta('addToHistory') === false)) {
        // Group transforms that occur in quick succession into one event.
        const composition = tr.getMeta('composition');
        const newGroup = // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevTime == 0 || !appended && // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !$763dcf87625ae905$var$isAdjacentTo(tr, history.prevRanges));
        const prevRanges = appended ? // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : $763dcf87625ae905$var$rangesFor(tr.mapping.maps);
        return new $763dcf87625ae905$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $763dcf87625ae905$var$mustPreserveItems(state)), $763dcf87625ae905$var$Branch.empty, prevRanges, tr.time, // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        composition == null ? history.prevComposition : composition);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line no-cond-assign
    } else if (rebased = tr.getMeta('rebased')) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $763dcf87625ae905$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $763dcf87625ae905$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $763dcf87625ae905$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $763dcf87625ae905$var$rangesFor(maps) {
    const result = [];
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $763dcf87625ae905$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    const result = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $763dcf87625ae905$var$histTransaction(history, state, redo) {
    const preserveItems = $763dcf87625ae905$var$mustPreserveItems(state);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
    const histOptions = $763dcf87625ae905$var$historyKey.get(state).spec.config;
    const pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const selection = pop.selection.resolve(pop.transform.doc);
    const added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    /**
   * ===
   * FORK ADDITION START
   * If history slicing is active when we undo/redo, when we perform an undo/redo we want to
   * map and keep the relevant steps in the new history state
   */ const newHist = history.historySliceActive ? new $763dcf87625ae905$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1, history.historySliceActive, (0, $59f7b5b301f829df$export$3cddda3829daa1af)(history.trackedSteps, pop.transform), history.selectionBookmark?.map(pop.transform.mapping)) : new $763dcf87625ae905$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    /**
   * FORK ADDITION END
   * ===
   */ return pop.transform.setSelection(selection).setMeta($763dcf87625ae905$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $763dcf87625ae905$var$cachedPreserveItems = false, $763dcf87625ae905$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $763dcf87625ae905$var$mustPreserveItems(state) {
    const plugins = state.plugins;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if ($763dcf87625ae905$var$cachedPreserveItemsPlugins != plugins) {
        $763dcf87625ae905$var$cachedPreserveItems = false;
        $763dcf87625ae905$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)// To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (plugins[i].spec.historyPreserveItems) {
            $763dcf87625ae905$var$cachedPreserveItems = true;
            break;
        }
    }
    return $763dcf87625ae905$var$cachedPreserveItems;
}
function $763dcf87625ae905$export$181a649d919c589e(tr) {
    return tr.setMeta($763dcf87625ae905$var$closeHistoryKey, true);
}
const $763dcf87625ae905$var$historyKey = new (0, $ks2lK.PluginKey)('history');
const $763dcf87625ae905$var$closeHistoryKey = new (0, $ks2lK.PluginKey)('closeHistory');
function $763dcf87625ae905$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $ks2lK.Plugin)({
        key: $763dcf87625ae905$var$historyKey,
        state: {
            init () {
                return new $763dcf87625ae905$var$HistoryState($763dcf87625ae905$var$Branch.empty, $763dcf87625ae905$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $763dcf87625ae905$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    const inputType = e.inputType;
                    const command = // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line eqeqeq
                    inputType == 'historyUndo' ? $763dcf87625ae905$export$21f930c44940fd98 : inputType == 'historyRedo' ? $763dcf87625ae905$export$1688e416fee0a49e : null;
                    if (!command || !view.editable) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $763dcf87625ae905$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        const hist = $763dcf87625ae905$var$historyKey.getState(state);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            const tr = $763dcf87625ae905$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
const $763dcf87625ae905$export$21f930c44940fd98 = $763dcf87625ae905$var$buildCommand(false, true);
const $763dcf87625ae905$export$1688e416fee0a49e = $763dcf87625ae905$var$buildCommand(true, true);
const $763dcf87625ae905$export$24b5d280435f3a3f = $763dcf87625ae905$var$buildCommand(false, false);
const $763dcf87625ae905$export$3774e54bae7be19b = $763dcf87625ae905$var$buildCommand(true, false);
function $763dcf87625ae905$export$f8a176c2b9a10bdb(state) {
    const hist = $763dcf87625ae905$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
function $763dcf87625ae905$export$3ffe6b288e7d941b(state) {
    const hist = $763dcf87625ae905$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}
module.exports["closeHistory"] = $763dcf87625ae905$export$181a649d919c589e;
module.exports["history"] = $763dcf87625ae905$export$55abd4691b317664;
module.exports["undo"] = $763dcf87625ae905$export$21f930c44940fd98;
module.exports["redo"] = $763dcf87625ae905$export$1688e416fee0a49e;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");

// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);


const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $3a61632aaf261ebb$export$2d23ed2854ac1650);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("Girkv", function(module, exports) {
const $89e375f5fe352748$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $89e375f5fe352748$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$89e375f5fe352748$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $89e375f5fe352748$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $89e375f5fe352748$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $89e375f5fe352748$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    const clientId = params.get('clientId');
    // check if we have the required params (clientId is optional for backwards compatibility)
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        clientId: clientId || undefined,
        collection: $89e375f5fe352748$var$getStringFromParams(params, 'collection'),
        alt: $89e375f5fe352748$var$getStringFromParams(params, 'alt'),
        height: $89e375f5fe352748$var$getNumberFromParams(params, 'height'),
        width: $89e375f5fe352748$var$getNumberFromParams(params, 'width'),
        size: $89e375f5fe352748$var$getNumberFromParams(params, 'size'),
        name: $89e375f5fe352748$var$getStringFromParams(params, 'name'),
        mimeType: $89e375f5fe352748$var$getStringFromParams(params, 'mimeType')
    };
};
const $89e375f5fe352748$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $89e375f5fe352748$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$89e375f5fe352748$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $89e375f5fe352748$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};
module.exports["isMediaBlobUrl"] = $89e375f5fe352748$export$e1e8ad57ada2d90;
module.exports["getAttrsFromUrl"] = $89e375f5fe352748$export$b91a9e94ff0cbb29;
module.exports["addFileAttrsToUrl"] = $89e375f5fe352748$export$e51a8146182600b8;

});

parcelRegister("8Doca", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f6eec6bbba6041ad$export$9b0f795b2e33f057 = (Wrapped)=>{
    class WithImageLoader extends (0, $42omo.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                imageStatus: 'loading'
            };
            this.img = void 0;
            this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            };
            this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    }
    return WithImageLoader;
};
module.exports["withImageLoader"] = $f6eec6bbba6041ad$export$9b0f795b2e33f057;

});

parcelRegister("lGf1F", function(module, exports) {
/* EmojiPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");


var $7ZWaV = parcelRequire("7ZWaV");




class $f155ff5984cedc51$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
    constructor(props, _state){
        super(props);
        this.isUnmounted = false;
        this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = _state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
}



var $5Qd4j = parcelRequire("5Qd4j");


var $jPINf = parcelRequire("jPINf");


var $fhsiz = parcelRequire("fhsiz");


var $jYWS5 = parcelRequire("jYWS5");

function $a0e4bfec9f73428e$var$_defineProperty(e, r, t) {
    return (r = $a0e4bfec9f73428e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a0e4bfec9f73428e$var$_toPropertyKey(t) {
    var i = $a0e4bfec9f73428e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a0e4bfec9f73428e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $a0e4bfec9f73428e$var$emojiPicker = null;

const $a0e4bfec9f73428e$var$emojiPickerModuleLoader = ()=>(parcelRequire("kVubj"));
const $a0e4bfec9f73428e$var$emojiPickerLoader = ()=>$a0e4bfec9f73428e$var$emojiPickerModuleLoader().then((module)=>module.default);
const $a0e4bfec9f73428e$export$6b47bb4986b03271 = ()=>{
    $a0e4bfec9f73428e$var$emojiPickerLoader().then((component)=>{
        $a0e4bfec9f73428e$export$bcf219a275f21b24.AsyncLoadedComponent = component;
    });
};
class $a0e4bfec9f73428e$export$bcf219a275f21b24 extends (0, $f155ff5984cedc51$export$2e2bcd8739ae039) {
    asyncLoadComponent() {
        $a0e4bfec9f73428e$var$emojiPickerLoader().then((component)=>{
            $a0e4bfec9f73428e$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $5Qd4j.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $7ZWaV.ufoExperiences)['emoji-picker-opened'].markFMP();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: handlePickerRef,
            className: (0, $gMc0m.default)([
                "_19itahnd _2rkofajl _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs130s _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ])
        }, item.renderItem());
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jPINf.UfoErrorBoundary), {
            experiences: [
                (0, $7ZWaV.ufoExperiences)['emoji-picker-opened']
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jYWS5.EmojiCommonProvider), {
            emojiProvider: loadedEmojiProvider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EmojiPickerComponent, otherProps)));
    }
    constructor(props){
        super(props, {});
        $a0e4bfec9f73428e$var$_defineProperty(this, "state", {
            asyncLoadedComponent: $a0e4bfec9f73428e$export$bcf219a275f21b24.AsyncLoadedComponent
        });
        (0, $7ZWaV.ufoExperiences)['emoji-picker-opened'].start();
    }
}
// state initialised with static component to prevent
// rerender when the module has already been loaded
$a0e4bfec9f73428e$var$_defineProperty($a0e4bfec9f73428e$export$bcf219a275f21b24, "AsyncLoadedComponent", void 0);
$a0e4bfec9f73428e$var$_defineProperty($a0e4bfec9f73428e$export$bcf219a275f21b24, "defaultProps", {
    size: (0, $fhsiz.defaultEmojiPickerSize)
});
const $a0e4bfec9f73428e$var$EmojiPicker = (0, $1DWH0.default)()($a0e4bfec9f73428e$export$bcf219a275f21b24);
var $a0e4bfec9f73428e$export$2e2bcd8739ae039 = $a0e4bfec9f73428e$var$EmojiPicker;
module.exports["preloadEmojiPicker"] = $a0e4bfec9f73428e$export$6b47bb4986b03271;
module.exports["default"] = $a0e4bfec9f73428e$export$2e2bcd8739ae039;

});

parcelRegister("5Qd4j", function(module, exports) {
/* EmojiPickerVirtualItems.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

/* EmojiPickerCategoryHeading.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $aXWIB = parcelRequire("aXWIB");


var $40rXS = parcelRequire("40rXS");


var $8Tx5v = parcelRequire("8Tx5v");

const $97b14313fbe0c12a$var$emojiCategoryTitle = null; /**
                                  * Test id for wrapper Emoji Picker List div
                                  */ 
const $97b14313fbe0c12a$export$354d69a9ad71a0a0 = 'render-emoji-picker-categorty-heading';
const $97b14313fbe0c12a$var$EmojiPickerCategoryHeading = ({ id: id, title: title, className: className })=>/*#__PURE__*/ $42omo.createElement("div", {
        id: id,
        "data-category-id": id,
        className: className,
        "data-testid": $97b14313fbe0c12a$export$354d69a9ad71a0a0,
        role: "rowheader"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _vchhusvi _syazi7uo _ca0q12x7 _n3td12x7 _19bvu2gc _u5f3u2gc _1p1d1qyh _299mangw"
        ])
    }, (0, $40rXS.isMessagesKey)(title) ? /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $8Tx5v.messages)[title]) : title));
var $97b14313fbe0c12a$export$2e2bcd8739ae039 = $97b14313fbe0c12a$var$EmojiPickerCategoryHeading;


/* EmojiPickerEmojiRow.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $dcj1K = parcelRequire("dcj1K");


var $jVQt9 = parcelRequire("jVQt9");




const $b3738bed0fa6b48e$var$emojiItem = null;
const $b3738bed0fa6b48e$var$emojiPickerRow = null;
const $b3738bed0fa6b48e$var$EmojiPickerEmojiRow = ({ emojis: emojis, onSelected: onSelected, onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, onFocus: onFocus, title: title, showDelete: showDelete, onDelete: onDelete, virtualItemContext: virtualItemContext })=>{
    const { currentEmojisFocus: currentEmojisFocus, setEmojisFocus: setEmojisFocus } = (0, $jVQt9.useEmojiPickerListContext)();
    const rowIndex = virtualItemContext?.index || 0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleFocus = (index)=>(emojiId, emoji, event)=>{
            setEmojisFocus({
                rowIndex: rowIndex,
                columnIndex: index
            });
            onFocus && onFocus(emojiId, emoji, event);
        };
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_18u0u2gc"
        ])
    }, emojis.map((emoji, index)=>{
        const { shortName: shortName, id: id } = emoji;
        const key = id ? `${id}-${title}` : `${shortName}-${title}`;
        const focus = currentEmojisFocus.rowIndex === rowIndex && currentEmojisFocus.columnIndex === index;
        return /*#__PURE__*/ $42omo.createElement("span", {
            key: key,
            role: "gridcell",
            "aria-colindex": index + 1,
            onMouseLeave: onMouseLeave,
            onBlur: onMouseLeave,
            tabIndex: 0,
            className: (0, $gMc0m.default)([
                "_1e0c1o8l _y3gn1h6o _1bsb1ylp _1wcg1qi0 _1678tlke _7b50u2gc _1rf4u2gc _b4kiu2gc _bm9mu2gc _1lvc1tcg _1cf71tcg _8vlfze3t _1909ze3t _1tcfze3t _n7xcze3t _4ubfu2gc _18x3u2gc _fw9su2gc _29jju2gc _qpkw1tcg _elsp1tcg _vtzrze3t _w2q0ze3t _o5kcze3t _1mc3ze3t _115ch2mm _yrst1ssb _85ft1ssb _5mfndbra _1k8z1tcg _17dz1tcg _zdyf1ule _1mn81tcg _u5ah1tcg"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $dcj1K.default), {
            emoji: emoji,
            selectOnHover: true,
            onSelected: onSelected,
            onMouseMove: onMouseMove,
            onFocus: handleFocus(index),
            showDelete: showDelete,
            onDelete: onDelete,
            placeholderSize: 24,
            "data-focus-index": `${rowIndex}-${index}`,
            tabIndex: focus ? 0 : -1,
            "aria-roledescription": formatMessage((0, $8Tx5v.messages).emojiButtonRoleDescription),
            shouldBeInteractive: true
        }));
    }));
};
const $b3738bed0fa6b48e$var$_default_1 = /*#__PURE__*/ (0, $42omo.memo)($b3738bed0fa6b48e$var$EmojiPickerEmojiRow);
var $b3738bed0fa6b48e$export$2e2bcd8739ae039 = $b3738bed0fa6b48e$var$_default_1;



var $4U4Dj = parcelRequire("4U4Dj");

function $9124fb719acd29a7$var$_defineProperty(e, r, t) {
    return (r = $9124fb719acd29a7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9124fb719acd29a7$var$_toPropertyKey(t) {
    var i = $9124fb719acd29a7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9124fb719acd29a7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $9124fb719acd29a7$var$emojiPickerSpinner = null;
class $9124fb719acd29a7$export$8faa7b3aa4960e00 {
    constructor(props, height){
        $9124fb719acd29a7$var$_defineProperty(this, "height", void 0);
        $9124fb719acd29a7$var$_defineProperty(this, "props", void 0);
        $9124fb719acd29a7$var$_defineProperty(this, "renderItem", void 0);
        this.props = props;
        this.height = height;
    }
}
class $9124fb719acd29a7$export$99598b6ddae6b40f extends $9124fb719acd29a7$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $4U4Dj.sizes).emojiRowHeight);
        $9124fb719acd29a7$var$_defineProperty(this, "renderItem", (context)=>/*#__PURE__*/ $42omo.createElement((0, $b3738bed0fa6b48e$export$2e2bcd8739ae039), {
                ...this.props,
                virtualItemContext: context
            }));
    }
}
class $9124fb719acd29a7$export$a16bfd7fb92e211d extends $9124fb719acd29a7$export$8faa7b3aa4960e00 {
    constructor(){
        super({}, (0, $4U4Dj.sizes).loadingRowHeight);
        $9124fb719acd29a7$var$_defineProperty(this, "renderItem", ()=>/*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bsb1osq _4t3i1w81 _1bah1h6o _4cvr1h6o _nphsidpf _t1edidpf _1t3b1wug"
                ])
            }, /*#__PURE__*/ $42omo.createElement("div", null, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
                size: "medium"
            }))));
    }
}
class $9124fb719acd29a7$export$7fb68de373aba588 extends $9124fb719acd29a7$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $4U4Dj.sizes).categoryHeadingHeight);
        $9124fb719acd29a7$var$_defineProperty(this, "renderItem", ()=>/*#__PURE__*/ $42omo.createElement((0, $97b14313fbe0c12a$export$2e2bcd8739ae039), this.props));
    }
}
const $9124fb719acd29a7$export$1786779f88a71e20 = (rows, context)=>{
    const { index: index, key: key } = context;
    const row = rows[index];
    return /*#__PURE__*/ $42omo.createElement("div", {
        key: key
    }, row && row.renderItem(context));
};
module.exports["EmojisRowItem"] = $9124fb719acd29a7$export$99598b6ddae6b40f;
module.exports["LoadingItem"] = $9124fb719acd29a7$export$a16bfd7fb92e211d;
module.exports["CategoryHeadingItem"] = $9124fb719acd29a7$export$7fb68de373aba588;
module.exports["virtualItemRenderer"] = $9124fb719acd29a7$export$1786779f88a71e20;

});

parcelRegister("dcj1K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $40rXS = parcelRequire("40rXS");


var $aGYoD = parcelRequire("aGYoD");


var $fB3RY = parcelRequire("fB3RY");


var $8Yr6I = parcelRequire("8Yr6I");


var $eTjjM = parcelRequire("eTjjM");

/* EmojiFallback.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");








var $8hpYf = parcelRequire("8hpYf");

const $194c2e38998cfb9e$var$emojiFallbackStyles = null;
const $194c2e38998cfb9e$export$e3a226c1c0d61870 = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const { fallback: fallback, shortName: shortName } = emoji;
    const classes = `${(0, $8hpYf.emojiNodeStyles)} ${selected ? (0, $8hpYf.commonSelectedStyles) : ''} ${selectOnHover ? (0, $8hpYf.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Yr6I.EmojiNodeWrapper), {
        type: "image",
        ...props,
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _1bah1h6o _4cvr1h6o"
        ])
    }, fallback || shortName)));
};
var $194c2e38998cfb9e$export$2e2bcd8739ae039 = $194c2e38998cfb9e$export$e3a226c1c0d61870;



var $jPINf = parcelRequire("jPINf");


var $7ZWaV = parcelRequire("7ZWaV");

var $li2rw = parcelRequire("li2rw");


var $fhsiz = parcelRequire("fhsiz");





var $MdjHG = parcelRequire("MdjHG");


var $injKz = parcelRequire("injKz");

const $419f008bf493366d$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $li2rw.useSampledUFOComponentExperience)((0, $7ZWaV.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $fhsiz.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $42omo.useEffect)(()=>{
        if (!(0, $7ZWaV.hasUfoMarked)((0, $7ZWaV.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $7ZWaV.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $40rXS.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($419f008bf493366d$export$aa961da7639f7a98, {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($419f008bf493366d$var$StandardEmoji, {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jPINf.UfoErrorBoundary), {
        experiences: [
            (0, $7ZWaV.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ]
    }, emojiNode());
};
const $419f008bf493366d$var$StandardEmoji = (props)=>{
    const { emoji: emoji, ...restProps } = props;
    const [imageLoadError, setImageLoadError] = (0, $42omo.useState)(false);
    const handleLoadError = (_emojiId)=>{
        setImageLoadError(true);
    };
    if (imageLoadError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $194c2e38998cfb9e$export$2e2bcd8739ae039), {
        emoji: emoji,
        ...restProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Yr6I.default), {
        emoji: emoji,
        onLoadError: handleLoadError,
        ...restProps
    });
};
const $419f008bf493366d$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $42omo.useState)();
    const [inValidImage, setInvalidImage] = (0, $42omo.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $MdjHG.useEmoji)();
    const loadEmoji = (0, $42omo.useCallback)((emojiProvider)=>{
        (0, $fB3RY.default)('Loading image via media cache', emoji.shortName);
        (0, $7ZWaV.sampledUfoRenderedEmoji)(emoji).mark((0, $aGYoD.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $7ZWaV.sampledUfoRenderedEmoji)(emoji).mark((0, $aGYoD.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $7ZWaV.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $injKz.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $42omo.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $7ZWaV.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Yr6I.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: representation
    });
};
const $419f008bf493366d$var$_default_1 = /*#__PURE__*/ (0, $42omo.memo)($419f008bf493366d$export$e81207f376d36133);
var $419f008bf493366d$export$2e2bcd8739ae039 = $419f008bf493366d$var$_default_1;
module.exports["default"] = $419f008bf493366d$export$2e2bcd8739ae039;

});

parcelRegister("MdjHG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fXFeB = parcelRequire("fXFeB");

const $289a425263f81aa9$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $289a425263f81aa9$export$482903c4ce3f5633 = ()=>{
    const context = (0, $42omo.useContext)((0, $fXFeB.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $42omo.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $42omo.useEffect)(()=>{
        if ($289a425263f81aa9$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                    return true;
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};
module.exports["useEmoji"] = $289a425263f81aa9$export$482903c4ce3f5633;

});

parcelRegister("injKz", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $eWRwJ = parcelRequire("eWRwJ");


var $aGYoD = parcelRequire("aGYoD");

const $96b555d07bba5a98$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $96b555d07bba5a98$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes
        }
    });
const $96b555d07bba5a98$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
        return $96b555d07bba5a98$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $96b555d07bba5a98$export$4e713a2b020a4dca = (source)=>{
    return $96b555d07bba5a98$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $96b555d07bba5a98$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
        return $96b555d07bba5a98$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $96b555d07bba5a98$export$5bd025a43378005c = (source)=>{
    return $96b555d07bba5a98$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $96b555d07bba5a98$var$emojiPickerEvent = (action, attributes = {}, actionSubjectId)=>$96b555d07bba5a98$var$createEvent('ui', action, 'emojiPicker', actionSubjectId, attributes);
const $96b555d07bba5a98$export$956acef77052d363 = ()=>$96b555d07bba5a98$var$emojiPickerEvent('opened');
const $96b555d07bba5a98$export$151c59c3f6a1ff5f = (attributes)=>$96b555d07bba5a98$var$emojiPickerEvent('closed', attributes);
const $96b555d07bba5a98$var$skinTones = [
    {
        id: '-1f3fb',
        skinToneModifier: 'light'
    },
    {
        id: '-1f3fc',
        skinToneModifier: 'mediumLight'
    },
    {
        id: '-1f3fd',
        skinToneModifier: 'medium'
    },
    {
        id: '-1f3fe',
        skinToneModifier: 'mediumDark'
    },
    {
        id: '-1f3ff',
        skinToneModifier: 'dark'
    }
];
const $96b555d07bba5a98$var$getSkinTone = (emojiId)=>{
    if (!emojiId) return {};
    for (const { id: id, skinToneModifier: skinToneModifier } of $96b555d07bba5a98$var$skinTones){
        if (emojiId.indexOf(id) !== -1) return {
            skinToneModifier: skinToneModifier,
            baseEmojiId: emojiId.replace(id, '')
        };
    }
    return {};
};
const $96b555d07bba5a98$export$d69b5cd43769bb6b = (attributes)=>$96b555d07bba5a98$var$emojiPickerEvent('clicked', {
        ...$96b555d07bba5a98$var$getSkinTone(attributes.emojiId),
        ...attributes
    }, 'emoji');
const $96b555d07bba5a98$export$8e021f755a07e0d2 = (attributes)=>$96b555d07bba5a98$var$emojiPickerEvent('clicked', attributes, 'category');
const $96b555d07bba5a98$export$d800a6d814034c48 = (attributes)=>$96b555d07bba5a98$var$emojiPickerEvent('searched', attributes, 'query');
const $96b555d07bba5a98$var$skintoneSelectorEvent = (action, attributes = {})=>$96b555d07bba5a98$var$createEvent('ui', action, 'emojiSkintoneSelector', undefined, attributes);
const $96b555d07bba5a98$export$e559e98af3da9d17 = (attributes)=>$96b555d07bba5a98$var$skintoneSelectorEvent('clicked', attributes);
const $96b555d07bba5a98$export$7274b855c80879c4 = (attributes)=>$96b555d07bba5a98$var$skintoneSelectorEvent('opened', attributes);
const $96b555d07bba5a98$export$301f0d0181307f7 = ()=>$96b555d07bba5a98$var$skintoneSelectorEvent('cancelled');
const $96b555d07bba5a98$var$emojiUploaderEvent = (action, actionSubjectId, attributes)=>$96b555d07bba5a98$var$createEvent('ui', action, 'emojiUploader', actionSubjectId, attributes);
const $96b555d07bba5a98$export$be48de448ed1f64f = ()=>$96b555d07bba5a98$var$emojiUploaderEvent('clicked', 'addButton');
const $96b555d07bba5a98$export$b82a2393560e5893 = (attributes)=>$96b555d07bba5a98$var$emojiUploaderEvent('clicked', 'confirmButton', attributes);
const $96b555d07bba5a98$export$47ef032c3ec0a60a = ()=>$96b555d07bba5a98$var$emojiUploaderEvent('clicked', 'cancelButton');
const $96b555d07bba5a98$export$6aed2b90719a7d39 = (attributes)=>$96b555d07bba5a98$var$createEvent('operational', 'finished', 'emojiUploader', undefined, attributes);
const $96b555d07bba5a98$export$18cfbd0c8c6d2297 = (attributes)=>$96b555d07bba5a98$var$createEvent('operational', 'failed', 'emojiUploader', undefined, attributes);
const $96b555d07bba5a98$export$d74d89c79fff5a67 = (attributes)=>$96b555d07bba5a98$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiTrigger', attributes);
const $96b555d07bba5a98$export$87a8007f9e978b47 = (attributes)=>$96b555d07bba5a98$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiConfirm', attributes);
const $96b555d07bba5a98$export$9877255e5a8f0cde = (attributes)=>$96b555d07bba5a98$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiCancel', attributes);
const $96b555d07bba5a98$export$fc14407a1d009938 = ()=>$96b555d07bba5a98$var$createEvent('ui', 'clicked', 'emojiUploader', 'selectFile');
const $96b555d07bba5a98$var$extractCommonAttributes = (query, emojiList)=>{
    return {
        queryLength: query ? query.length : 0,
        spaceInQuery: query ? query.indexOf(' ') !== -1 : false,
        emojiIds: emojiList ? emojiList.map((emoji)=>emoji.id).filter(Boolean).slice(0, 20) : []
    };
};
const $96b555d07bba5a98$export$89566522a5321393 = (duration, query, emojiList)=>$96b555d07bba5a98$var$createEvent('ui', 'cancelled', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$96b555d07bba5a98$var$extractCommonAttributes(query, emojiList)
    });
const $96b555d07bba5a98$var$getPosition = (emojiList, selectedEmoji)=>{
    if (emojiList) {
        const index = emojiList.findIndex((emoji)=>emoji.id === selectedEmoji.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $96b555d07bba5a98$export$475603c082d8a174 = (pressed, duration, emoji, emojiList, query, exactMatch)=>$96b555d07bba5a98$var$createEvent('ui', pressed ? 'pressed' : 'clicked', 'emojiTypeahead', undefined, {
        duration: duration,
        position: $96b555d07bba5a98$var$getPosition(emojiList, emoji),
        ...$96b555d07bba5a98$var$extractCommonAttributes(query, emojiList),
        ...$96b555d07bba5a98$var$getSkinTone(emoji.id),
        emojiType: emoji.type,
        exactMatch: exactMatch || false
    });
const $96b555d07bba5a98$export$bbbb081930a4e19d = (duration, query, emojiList)=>$96b555d07bba5a98$var$createEvent('operational', 'rendered', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$96b555d07bba5a98$var$extractCommonAttributes(query, emojiList)
    });
const $96b555d07bba5a98$export$524400435f62e003 = (emoji, options)=>()=>{
        if (options && options.createAnalyticsEvent) (0, $eWRwJ.default)('editor')($96b555d07bba5a98$export$3125c3f60f61a0a9(emoji)((0, $aGYoD.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
    };
const $96b555d07bba5a98$export$d1176b797f0912b8 = (emoji, options)=>(err)=>{
        if (options && options.createAnalyticsEvent) (0, $eWRwJ.default)('editor')($96b555d07bba5a98$export$ccd0c8bcbda28b7a(emoji)((0, $aGYoD.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
        return Promise.reject(err);
    };
const $96b555d07bba5a98$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};
module.exports["createAndFireEventInElementsChannel"] = $96b555d07bba5a98$export$53eef0dcd9611650;
module.exports["recordSucceededEmoji"] = $96b555d07bba5a98$export$3125c3f60f61a0a9;
module.exports["recordFailedEmoji"] = $96b555d07bba5a98$export$ccd0c8bcbda28b7a;
module.exports["openedPickerEvent"] = $96b555d07bba5a98$export$956acef77052d363;
module.exports["closedPickerEvent"] = $96b555d07bba5a98$export$151c59c3f6a1ff5f;
module.exports["pickerClickedEvent"] = $96b555d07bba5a98$export$d69b5cd43769bb6b;
module.exports["categoryClickedEvent"] = $96b555d07bba5a98$export$8e021f755a07e0d2;
module.exports["pickerSearchedEvent"] = $96b555d07bba5a98$export$d800a6d814034c48;
module.exports["toneSelectedEvent"] = $96b555d07bba5a98$export$e559e98af3da9d17;
module.exports["toneSelectorOpenedEvent"] = $96b555d07bba5a98$export$7274b855c80879c4;
module.exports["toneSelectorClosedEvent"] = $96b555d07bba5a98$export$301f0d0181307f7;
module.exports["uploadBeginButton"] = $96b555d07bba5a98$export$be48de448ed1f64f;
module.exports["uploadConfirmButton"] = $96b555d07bba5a98$export$b82a2393560e5893;
module.exports["uploadCancelButton"] = $96b555d07bba5a98$export$47ef032c3ec0a60a;
module.exports["uploadSucceededEvent"] = $96b555d07bba5a98$export$6aed2b90719a7d39;
module.exports["uploadFailedEvent"] = $96b555d07bba5a98$export$18cfbd0c8c6d2297;
module.exports["deleteBeginEvent"] = $96b555d07bba5a98$export$d74d89c79fff5a67;
module.exports["deleteConfirmEvent"] = $96b555d07bba5a98$export$87a8007f9e978b47;
module.exports["deleteCancelEvent"] = $96b555d07bba5a98$export$9877255e5a8f0cde;
module.exports["selectedFileEvent"] = $96b555d07bba5a98$export$fc14407a1d009938;
module.exports["recordSelectionSucceededSli"] = $96b555d07bba5a98$export$524400435f62e003;
module.exports["recordSelectionFailedSli"] = $96b555d07bba5a98$export$d1176b797f0912b8;
module.exports["extractErrorInfo"] = $96b555d07bba5a98$export$74aaf4784c2edb2c;

});

parcelRegister("jVQt9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ifWhS = parcelRequire("ifWhS");

const $bd26d8c895ed2132$export$1d569b16c0178739 = ()=>(0, $42omo.useContext)((0, $ifWhS.EmojiPickerListContext));
module.exports["useEmojiPickerListContext"] = $bd26d8c895ed2132$export$1d569b16c0178739;

});

parcelRegister("ifWhS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $46ad92842e68b858$export$968c8d71e683bcd1 = /*#__PURE__*/ (0, $42omo.createContext)({
    currentEmojisFocus: {
        rowIndex: 0,
        columnIndex: 0
    },
    setEmojisFocus: ()=>{}
});
const $46ad92842e68b858$export$6f4d9357992f0254 = (props)=>{
    const [currentEmojisFocus, setEmojisFocus] = (0, $42omo.useState)(props.initialEmojisFocus);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46ad92842e68b858$export$968c8d71e683bcd1.Provider, {
        value: {
            currentEmojisFocus: currentEmojisFocus,
            setEmojisFocus: setEmojisFocus
        }
    }, props.children);
};
module.exports["EmojiPickerListContext"] = $46ad92842e68b858$export$968c8d71e683bcd1;
module.exports["EmojiPickerListContextProvider"] = $46ad92842e68b858$export$6f4d9357992f0254;

});

parcelRegister("4U4Dj", function(module, exports) {

var $fhsiz = parcelRequire("fhsiz");

const $226a50d490a5d3f0$export$c647cb0ee6e282fe = {
    listHeight: (0, $fhsiz.emojiPickerListHeight),
    listHeightNew: (0, $fhsiz.emojiPickerListHeightNew),
    listWidth: (0, $fhsiz.emojiPickerWidth),
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8
};
module.exports["sizes"] = $226a50d490a5d3f0$export$c647cb0ee6e282fe;

});

parcelRegister("kVubj", function(module, exports) {

let $f3c08af2517626cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3c08af2517626cf$var$load("1WCMN"),
    $f3c08af2517626cf$var$load("6wr18"),
    $f3c08af2517626cf$var$load("3Q7uW"),
    $f3c08af2517626cf$var$load("1cGGc"),
    $f3c08af2517626cf$var$load("ljaqI"),
    $f3c08af2517626cf$var$load("a5PnA"),
    $f3c08af2517626cf$var$load("f1x0y"),
    $f3c08af2517626cf$var$load("5t3NJ"),
    $f3c08af2517626cf$var$load("Wowvf"),
    $f3c08af2517626cf$var$load("ffEVr"),
    $f3c08af2517626cf$var$load("1RolH")
]).then(()=>parcelRequire('cqieh'));

});

parcelRegister("5uONf", function(module, exports) {
/* EmojiPreviewComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dcj1K = parcelRequire("dcj1K");

const $2de87e5d0fa59601$var$emojiName = null;
const $2de87e5d0fa59601$var$emojiShortName = null;
const $2de87e5d0fa59601$var$preview = null;
const $2de87e5d0fa59601$var$previewImg = null;
const $2de87e5d0fa59601$var$previewText = null;
const $2de87e5d0fa59601$export$222c91bd2db2d158 = ({ emoji: emoji })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _4cvr1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1bsbzwfg _12s6idpf _1e4didpf _1dvqidpf _vwlxidpf _1gdiidpf _1f45idpf _pdfdidpf _mwo3idpf _5ilezwfg _boltzwfg _1pc7zwfg _u5wqzwfg _w7981kw7 _1vqe1kw7 _1l4xidpf _1l79idpf _118didpf _1pa4idpf _1pglh2mm _1vjf1ssb _1h6o1ssb _8fp6dbra _1os4zwfg _1e7azwfg _7mh21ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $dcj1K.default), {
        key: emoji.id || emoji.shortName,
        emoji: emoji
    })), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1wpz1h6o _19pk1i6y _18u019bv _p12f3sup _1bsb3sup _16jlkb7n _1o9zkb7n"
        ])
    }, emoji.name && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1ule _syazi7uo _1bto1l2s _o5721q9c _299mangw"
        ])
    }, emoji.name), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _1e0c1ule _syazazsu _vwz4kb7n _otyr1i6y _n3tdv77o _1bto1l2s _o5721q9c _10hwfhey _pnmbi7uo"
        ])
    }, emoji.shortName)));
};
module.exports["EmojiPreviewComponent"] = $2de87e5d0fa59601$export$222c91bd2db2d158;

});

parcelRegister("lkJUe", function(module, exports) {
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6882d98e64286c4c$var$isFunction(x) {
    return typeof x === 'function';
}
function $6882d98e64286c4c$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$6882d98e64286c4c$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $6882d98e64286c4c$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}
module.exports["pluginFactory"] = $6882d98e64286c4c$export$3dd00fb488ab385a;

});

parcelRegister("l9G9n", function(module, exports) {
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("kTbzR")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("2pjJ5")).hasDocAsParent);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8m4tT = parcelRequire("8m4tT");


var $2pjJ5 = parcelRequire("2pjJ5");


var $kTbzR = parcelRequire("kTbzR");


var $azNN5 = parcelRequire("azNN5");


var $bYZ53 = parcelRequire("bYZ53");


var $21PP6 = parcelRequire("21PP6");


var $dSVmA = parcelRequire("dSVmA");


var $dIxHZ = parcelRequire("dIxHZ");


var $8Doca = parcelRequire("8Doca");


var $fJNzZ = parcelRequire("fJNzZ");


var $7iE7T = parcelRequire("7iE7T");


var $lkJUe = parcelRequire("lkJUe");


var $3Ter7 = parcelRequire("3Ter7");


var $4vlwG = parcelRequire("4vlwG");



var $lWghV = parcelRequire("lWghV");


var $kOYZR = parcelRequire("kOYZR");


var $juTiU = parcelRequire("juTiU");







var $2diEG = parcelRequire("2diEG");


var $caYZ2 = parcelRequire("caYZ2");


var $d4WtM = parcelRequire("d4WtM");


var $cN8vw = parcelRequire("cN8vw");


var $5mxQU = parcelRequire("5mxQU");


var $TfRUG = parcelRequire("TfRUG");


var $NPJKR = parcelRequire("NPJKR");



var $led7c = parcelRequire("led7c");


var $1HVk8 = parcelRequire("1HVk8");



var $6aq5c = parcelRequire("6aq5c");




var $56SXY = parcelRequire("56SXY");


var $5GR8v = parcelRequire("5GR8v");


var $irKZA = parcelRequire("irKZA");


var $b0F8r = parcelRequire("b0F8r");


var $eYlm5 = parcelRequire("eYlm5");


var $6tl2G = parcelRequire("6tl2G");


var $lqWNh = parcelRequire("lqWNh");



var $16GCc = parcelRequire("16GCc");


var $e7tBw = parcelRequire("e7tBw");





var $l03WE = parcelRequire("l03WE");


var $i4oLV = parcelRequire("i4oLV");


var $l9FJJ = parcelRequire("l9FJJ");


var $eDabt = parcelRequire("eDabt");


var $8vgNB = parcelRequire("8vgNB");


var $lNDSG = parcelRequire("lNDSG");


var $2bi6l = parcelRequire("2bi6l");


var $3JtSu = parcelRequire("3JtSu");


const $2af6a548343f3667$export$d4f2631252432abf = 'history$';
function $2af6a548343f3667$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $2af6a548343f3667$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $2af6a548343f3667$export$92d47fcf661e090e = (state)=>{
    return (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $2af6a548343f3667$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $2af6a548343f3667$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2af6a548343f3667$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $2af6a548343f3667$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $2af6a548343f3667$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $2af6a548343f3667$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $2af6a548343f3667$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $2af6a548343f3667$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $kTbzR.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $kTbzR.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $2af6a548343f3667$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $kTbzR.isEmptyParagraph)(node) && (0, $2pjJ5.hasDocAsParent)($anchor);
}
module.exports["pmHistoryPluginKey"] = $2af6a548343f3667$export$d4f2631252432abf;
module.exports["shallowEqual"] = $2af6a548343f3667$export$d36bdfa510afb180;
module.exports["isSelectionInsideLastNodeInDocument"] = $2af6a548343f3667$export$51bf7c6695e13879;
module.exports["isInListItem"] = $2af6a548343f3667$export$92d47fcf661e090e;
module.exports["findFarthestParentNode"] = $2af6a548343f3667$export$6b982788a5f0ccef;
module.exports["insideTableCell"] = $2af6a548343f3667$export$1350ff12653c84d4;
module.exports["checkNodeDown"] = $2af6a548343f3667$export$d0951c59cd3dac0f;
module.exports["isEmptyNode"] = $2af6a548343f3667$export$641fdf56f693bfbc;
module.exports["isNodeEmpty"] = $2af6a548343f3667$export$cd58ff1081f6abe9;
module.exports["isInEmptyLine"] = $2af6a548343f3667$export$3b68253250b41118;

});

parcelRegister("21PP6", function(module, exports) {
const $322f4dab81de9e93$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};
module.exports["getExtensionLozengeData"] = $322f4dab81de9e93$export$4fd8ecadd193bea0;

});

parcelRegister("7iE7T", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");


var $8m4tT = parcelRequire("8m4tT");

const $3b2d37886a4003ec$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $3b2d37886a4003ec$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $3b2d37886a4003ec$export$996213f7c272fc6f = (nodes)=>nodes.every($3b2d37886a4003ec$export$4c39e41e39b3c449);
const $3b2d37886a4003ec$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $3b2d37886a4003ec$export$d7ae8c533ae18832 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $3b2d37886a4003ec$export$1879817ac5c922b7 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.nodes.text);
const $3b2d37886a4003ec$export$5dfeda3a9e6fe056 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.marks.link);
var $3b2d37886a4003ec$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});
const $3b2d37886a4003ec$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $3b2d37886a4003ec$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $3b2d37886a4003ec$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $3b2d37886a4003ec$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $8m4tT.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $3b2d37886a4003ec$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $3b2d37886a4003ec$export$54fd2c36b5cc6731(node) {
    return $3b2d37886a4003ec$var$transformer.encode(node);
}
function $3b2d37886a4003ec$export$3a858d3babd60825(node) {
    return $3b2d37886a4003ec$var$transformer.encodeNode(node);
}
module.exports["isParagraph"] = $3b2d37886a4003ec$export$d7ae8c533ae18832;
module.exports["isText"] = $3b2d37886a4003ec$export$1879817ac5c922b7;
module.exports["isLinkMark"] = $3b2d37886a4003ec$export$5dfeda3a9e6fe056;
module.exports["SelectedState"] = $3b2d37886a4003ec$export$a6212ae0c82963af;
module.exports["isNodeSelectedOrInRange"] = $3b2d37886a4003ec$export$5125f50e751e84db;
module.exports["isSupportedInParent"] = $3b2d37886a4003ec$export$b6e38334b1fb4d1b;
module.exports["isMediaNode"] = $3b2d37886a4003ec$export$d6ca4605aefeca32;
module.exports["isNodeBeforeMediaNode"] = $3b2d37886a4003ec$export$cfaa7840b0c93780;
module.exports["toJSON"] = $3b2d37886a4003ec$export$54fd2c36b5cc6731;
module.exports["nodeToJSON"] = $3b2d37886a4003ec$export$3a858d3babd60825;

});

parcelRegister("5mxQU", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

const $02615ba219e18bae$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $aXG5V.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};
module.exports["isTextInput"] = $02615ba219e18bae$export$3e6057b9bf6b0bbb;

});

parcelRegister("TfRUG", function(module, exports) {
const $789182d0618bed14$export$15a09f5ef055bcfa = '\u200b';
const $789182d0618bed14$export$2b4d00c13dcd3c1f = '\u200d';
module.exports["ZERO_WIDTH_SPACE"] = $789182d0618bed14$export$15a09f5ef055bcfa;
module.exports["ZERO_WIDTH_JOINER"] = $789182d0618bed14$export$2b4d00c13dcd3c1f;

});

parcelRegister("led7c", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $2T4ch = parcelRequire("2T4ch");

// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $26c28de5be6088e2$var$nodeViewRenderedEventsCounter = 0;
const $26c28de5be6088e2$var$DEFAULT_SAMPLING_RATE = 100;
const $26c28de5be6088e2$var$DEFAULT_SLOW_THRESHOLD = 7;
function $26c28de5be6088e2$export$9838b97af1c61be(view) {
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $26c28de5be6088e2$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $26c28de5be6088e2$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $26c28de5be6088e2$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $2T4ch.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $26c28de5be6088e2$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $2T4ch.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$26c28de5be6088e2$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}
module.exports["getPerformanceOptions"] = $26c28de5be6088e2$export$9838b97af1c61be;
module.exports["startMeasureReactNodeViewRendered"] = $26c28de5be6088e2$export$2630f5971dfad231;
module.exports["stopMeasureReactNodeViewRendered"] = $26c28de5be6088e2$export$dc5a82f0bfc526c3;

});

parcelRegister("1HVk8", function(module, exports) {
const $a8192fbeb99723d4$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $a8192fbeb99723d4$var$RACE_COMPLETE = 'race_complete';
const $a8192fbeb99723d4$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $a8192fbeb99723d4$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>Boolean(document?.querySelector($a8192fbeb99723d4$var$SELECTORS.GRAMMARLY)),
            async: (detected, cleanup)=>{
                // First check to see if grammarly already exists on page
                const exists = Boolean(document?.querySelector($a8192fbeb99723d4$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue){
                        for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($a8192fbeb99723d4$var$SELECTORS.GRAMMARLY));
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer?.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $a8192fbeb99723d4$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $a8192fbeb99723d4$var$registerDetectors(options.extensions, $a8192fbeb99723d4$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $a8192fbeb99723d4$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}
module.exports["sniffUserBrowserExtensions"] = $a8192fbeb99723d4$export$4cd1ca2600761f65;

});

parcelRegister("56SXY", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

function $052f9b220c82ebdf$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        const types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $aXG5V.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}
module.exports["autoJoinTr"] = $052f9b220c82ebdf$export$c7c1e59168a7f554;

});

parcelRegister("5GR8v", function(module, exports) {
const $219363623091e0b7$export$d35a68bd2e0b55da = (state, node)=>{
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
        return !found;
    });
    return found;
};
const $219363623091e0b7$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !node.attrs?.localId) return true;
        const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
        if (!normalizedId) return true;
        if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: fragmentMark?.attrs?.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $219363623091e0b7$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $219363623091e0b7$var$getSelectedLocalIds(state, node);
    const allNodes = $219363623091e0b7$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $219363623091e0b7$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!idsToBeDeleted?.length) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $219363623091e0b7$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = searchSet.pop();
        if (allNodes[id]) {
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $219363623091e0b7$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $219363623091e0b7$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $219363623091e0b7$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$219363623091e0b7$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $219363623091e0b7$var$getNodeNameById(id, allNodes),
        amount: $219363623091e0b7$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $219363623091e0b7$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        const targets = $219363623091e0b7$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $219363623091e0b7$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $219363623091e0b7$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            name = name ?? allNodes[localId]?.name;
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $219363623091e0b7$var$getSelectedLocalIds = (state, node)=>{
    if (!node) return new Set([]);
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    return localIds;
};
const $219363623091e0b7$export$651544f548703224 = (state, node)=>{
    return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
};
module.exports["isReferencedSource"] = $219363623091e0b7$export$d35a68bd2e0b55da;
module.exports["removeConnectedNodes"] = $219363623091e0b7$export$657e59857351232d;
module.exports["getChildrenInfo"] = $219363623091e0b7$export$c98d43680e607ac1;
module.exports["getNodeName"] = $219363623091e0b7$export$651544f548703224;

});

parcelRegister("eYlm5", function(module, exports) {
const $42b7f669665818db$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';
module.exports["gridTypeForLayout"] = $42b7f669665818db$export$27813bf9aa3826dc;

});

parcelRegister("e7tBw", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $iu6m9 = parcelRequire("iu6m9");


var $d925B = parcelRequire("d925B");


var $dAtrv = parcelRequire("dAtrv");


var $adhil = parcelRequire("adhil");


var $kTbzR = parcelRequire("kTbzR");


var $7iE7T = parcelRequire("7iE7T");

const $4be293a911874993$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};
const $4be293a911874993$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $4be293a911874993$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
function $4be293a911874993$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $5SAOw.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $ks2lK.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}
const $4be293a911874993$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })($4be293a911874993$export$c2d9390f63354627());
const $4be293a911874993$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$4be293a911874993$var$canMoveUp(state) && $4be293a911874993$var$canCreateParagraphNear(state)) {
        $4be293a911874993$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $4be293a911874993$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$4be293a911874993$var$canMoveDown(state) && $4be293a911874993$var$canCreateParagraphNear(state)) {
        $4be293a911874993$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $4be293a911874993$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $ks2lK.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $4be293a911874993$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $ks2lK.TextSelection)) {
            if ($4be293a911874993$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $4be293a911874993$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $4be293a911874993$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4be293a911874993$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $4be293a911874993$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $ks2lK.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $4be293a911874993$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $4be293a911874993$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $7iE7T.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $ks2lK.TextSelection) && !(0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) {
        if (!selection.empty) return true;
    }
    return !$4be293a911874993$export$e9083e8cbe24bec0(state);
}
function $4be293a911874993$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $7iE7T.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $ks2lK.TextSelection) && !(0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) {
        if (!selection.empty) return true;
    }
    return !$4be293a911874993$export$4ca816540352da02(state);
}
function $4be293a911874993$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $4be293a911874993$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
const $4be293a911874993$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $4be293a911874993$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $kTbzR.isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $4be293a911874993$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        const [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        const [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $ks2lK.TextSelection)(getSelectionResolvedPos(tr)));
};
const $4be293a911874993$export$55f1e30b4664ff16 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtStartOfTextBlock = state.doc.resolve($from.start($from.depth - 1));
            const parentOfTextBlock = $posAtStartOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to if the textblock is the first node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const firstChildOfBlockTaskItem = parentOfTextBlock.firstChild;
                if (firstChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the first node in the blockTaskItem,
                    // check if the selection is at the start of the textblock
                    const firstTextPosInTextBlock = $from.start($from.depth);
                    return $from.pos === firstTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the start of the blockTaskItem
            const blockTaskItemDepth = $from.depth;
            const firstPosInBlockTaskItem = $from.start(blockTaskItemDepth);
            // Is the selection at the first possible position inside the blockTaskItem
            return $from.pos === firstPosInBlockTaskItem;
        }
    }
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $adhil.GapCursorSelection));
};
const $4be293a911874993$export$aedf35c057f77b82 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtEndOfTextBlock = state.doc.resolve($from.end($from.depth - 1));
            const parentOfTextBlock = $posAtEndOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to know if the textblock is the last node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const lastChildOfBlockTaskItem = parentOfTextBlock.lastChild;
                if (lastChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the last node in the blockTaskItem,
                    // check if the selection is at the end of the textblock
                    const lastTextPosInTextBlock = $from.end($from.depth);
                    return $from.pos === lastTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the end of the blockTaskItem
            const lastPosInBlockTaskItem = $from.end();
            return $from.pos === lastPosInBlockTaskItem;
        }
    }
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $adhil.GapCursorSelection));
};
module.exports["walkNextNode"] = $4be293a911874993$export$a5ae75c0b3dfe1c0;
module.exports["walkPrevNode"] = $4be293a911874993$export$cab15df6ad89b5a0;
module.exports["insertNewLineWithAnalytics"] = $4be293a911874993$export$67efd148fa31066c;
module.exports["createNewParagraphAbove"] = $4be293a911874993$export$fd094c1e3c1540bf;
module.exports["createParagraphNear"] = $4be293a911874993$export$d0f80ac1b4510888;
module.exports["createNewParagraphBelow"] = $4be293a911874993$export$d4296e42f66d8dc6;
module.exports["deleteEmptyParagraphAndMoveBlockUp"] = $4be293a911874993$export$a52ade1f964aef2c;
module.exports["insertContentDeleteRange"] = $4be293a911874993$export$1a87582f65bdc5db;
module.exports["isEmptySelectionAtStart"] = $4be293a911874993$export$55f1e30b4664ff16;
module.exports["isEmptySelectionAtEnd"] = $4be293a911874993$export$aedf35c057f77b82;
module.exports["filterCommand"] = $4be293a911874993$export$3dea766d36a8935f;

});

parcelRegister("dAtrv", function(module, exports) {
function $3f18fece9c4d518d$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state, {
                            currentDoc: tr.doc
                        });
                        if (dynamicPayload) {
                            analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}
module.exports["withAnalytics"] = $3f18fece9c4d518d$export$af9baadf0e4f6e13;

});

parcelRegister("l03WE", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $ke2AI = parcelRequire("ke2AI");


var $jbKei = parcelRequire("jbKei");

const $675194dd3a255bc3$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi?.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $675194dd3a255bc3$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $aXG5V.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $aXG5V.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $jbKei.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return $675194dd3a255bc3$export$56e87122f905fac0(match, handler);
};
const $675194dd3a255bc3$export$56e87122f905fac0 = (match, handler, allowsBackwardMatch = false)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $ke2AI.closeHistory)(tr);
        },
        allowsBackwardMatch: allowsBackwardMatch
    };
};
module.exports["inputRuleWithAnalytics"] = $675194dd3a255bc3$export$333ee6e3f01bb8f9;
module.exports["createWrappingJoinRule"] = $675194dd3a255bc3$export$6341edfa2d147bc;
module.exports["createRule"] = $675194dd3a255bc3$export$56e87122f905fac0;

});

parcelRegister("jbKei", function(module, exports) {
var $d8e57328e993bafb$export$a9b79b94eb5ffad = /*#__PURE__*/ function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
    return DELETE_DIRECTION;
}({});
var $d8e57328e993bafb$export$c3c848735ee9408a = /*#__PURE__*/ function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    return LIST_TEXT_SCENARIOS;
}({});
var $d8e57328e993bafb$export$43e6a678b13eb45f = /*#__PURE__*/ function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
var $d8e57328e993bafb$export$ed4ba8ac11f6cbc8 = /*#__PURE__*/ function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    return OUTDENT_SCENARIOS;
}({});
module.exports["DELETE_DIRECTION"] = $d8e57328e993bafb$export$a9b79b94eb5ffad;
module.exports["LIST_TEXT_SCENARIOS"] = $d8e57328e993bafb$export$c3c848735ee9408a;
module.exports["JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST"] = $d8e57328e993bafb$export$43e6a678b13eb45f;
module.exports["OUTDENT_SCENARIOS"] = $d8e57328e993bafb$export$ed4ba8ac11f6cbc8;

});

parcelRegister("i4oLV", function(module, exports) {
function $2f95adf5eda4267e$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
              .,
    .      _,'f----.._
    |\ ,-'"/  |     ,'
    |,_  ,--.      /
    /,-. ,'`.     (_
    f  o|  o|__     "`-.
    ,-._.,--'_ `.   _.,-`
    `"' ___.,'` j,-'
      `-.__.,--'
    Gotta go fast!
 */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}
module.exports["dedupe"] = $2f95adf5eda4267e$export$f3a259b74a77132f;

});

parcelRegister("l9FJJ", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $kTbzR = parcelRequire("kTbzR");

function $a4e77ca3d010585b$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $kTbzR.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $a4e77ca3d010585b$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $8m4tT.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $a4e77ca3d010585b$export$656aa714448bfa8a(state, type, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
	 * To wrap a media group we need to start the range from one position
	 * before a media selection's from position.
	 */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
	 * Added a check to avoid wrapping codeblock
	 */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wrapping = isAllowedChild && range && (0, $aXG5V.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}
module.exports["createWrapSelectionTransaction"] = $a4e77ca3d010585b$export$d5c308539c2b2123;

});

parcelRegister("eDabt", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $irKZA = parcelRequire("irKZA");

// Taken from `editor-plugin-content-insertion`
function $f39dd7712775e946$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $5SAOw.Slice).maxOpen((0, $5SAOw.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $ks2lK.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $f39dd7712775e946$export$f4c81471ccea5042(tr, node) {
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $8m4tT.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $8m4tT.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos?.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode?.node.content.forEach((child)=>{
        if ((0, $irKZA.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $8m4tT.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $f39dd7712775e946$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
    const nodeOfOriginalList = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}
module.exports["transformNodeIntoListItem"] = $f39dd7712775e946$export$f4c81471ccea5042;

});

parcelRegister("8vgNB", function(module, exports) {

var $l9FJJ = parcelRequire("l9FJJ");

function $de1704326a4798fc$export$f63f505240212912(type) {
    return function(state, dispatch) {
        const tr = (0, $l9FJJ.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}
module.exports["wrapSelectionIn"] = $de1704326a4798fc$export$f63f505240212912;

});

parcelRegister("lNDSG", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

const $68fa3b7808a54c2b$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH = 20;
const $68fa3b7808a54c2b$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
        short selection above a long paragraph
        eg. short {<}heading
        The purpose of this text is to show the selection range{>}.
        The horizontal positioning should center around "heading",
        not where it ends at "range".
        Note: if it was "head<b>ing</b>" then it would only center
        around "head". Undesireable but matches the current renderer.
      */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $68fa3b7808a54c2b$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $68fa3b7808a54c2b$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const moreRovoOptionsButton = document.querySelector('button[aria-label="More Rovo options"], [aria-label="More Rovo options"]');
        const isMoreRovoOptionsButtonVisible = !!moreRovoOptionsButton && moreRovoOptionsButton instanceof HTMLElement && !!moreRovoOptionsButton.offsetParent;
        let range = null;
        if (isMoreRovoOptionsButtonVisible) {
            if (selection && selection.getRangeAt && selection.rangeCount > 0) {
                const maybeRange = selection.getRangeAt(0);
                if (maybeRange instanceof Range) range = maybeRange;
            }
        } else if (selection && !selection.isCollapsed && selection.getRangeAt && selection.rangeCount > 0) {
            const maybeRange = selection.getRangeAt(0);
            if (maybeRange instanceof Range) range = maybeRange;
        }
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $68fa3b7808a54c2b$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        let leftCoord = Math.max(0, left - wrapperBounds.left);
        if (leftCoord + toolbarRect.width > wrapperBounds.width) {
            const scrollbarWidth = $68fa3b7808a54c2b$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH;
            leftCoord = Math.max(0, wrapperBounds.width - (toolbarRect.width + scrollbarWidth));
        }
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: leftCoord
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $68fa3b7808a54c2b$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};
const $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop = 10;
const $68fa3b7808a54c2b$var$scrollbarWidth = 20;
const $68fa3b7808a54c2b$var$offsetTopOnColumnSelection = 4;
const $68fa3b7808a54c2b$export$2d9cc331fb808a87 = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        const { selection: selection } = editorView.state;
        if (!(selection instanceof (0, $7XFGZ.CellSelection))) return nextPos;
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const anchorCellDOM = (0, $8m4tT.findDomRefAtPos)($anchorCell.pos, domAtPos);
        const headCellDOM = (0, $8m4tT.findDomRefAtPos)($headCell.pos, domAtPos);
        if (!(anchorCellDOM instanceof HTMLElement) || !(headCellDOM instanceof HTMLElement)) return nextPos;
        const anchorCellRect = anchorCellDOM.getBoundingClientRect();
        const headCellRect = headCellDOM.getBoundingClientRect();
        const toolbarRect = toolbar.getBoundingClientRect();
        let top;
        if (headCellRect.top <= anchorCellRect.top) // Display Selection toolbar at the top of the selection
        top = headCellRect.top - toolbarRect.height - $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop;
        else // Display Selection toolbar at the bottom of the selection
        top = headCellRect.bottom + $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top && headCellRect.top <= anchorCellRect.top) top = anchorCellRect.bottom + $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop;
        let left;
        if (headCellRect.left < anchorCellRect.left) left = headCellRect.left;
        else if (headCellRect.left === anchorCellRect.left) left = headCellRect.left + headCellRect.width / 2;
        else left = headCellRect.right;
        // If a user selected multiple columns via clicking on a drag handle
        // (clicking first on the left column and then shift clicking on the right column),
        // the $headcell stays in place and $anchorcell changes position. If they clicked on the right column
        // and then shift clicked on the left, the $headCell will change while $anchor stays in place.
        // Where is no way to know if user was dragging to select the cells or clicking on the drag handle.
        // So if all cells in columns are selected, we will align the Text Formatting toolbar
        // relative to center of the selected area.
        if (selection.isColSelection()) {
            if (headCellRect.left < anchorCellRect.left) left = headCellRect.left + (anchorCellRect.right - headCellRect.left) / 2;
            else if (headCellRect.left === anchorCellRect.left) left;
            else left = anchorCellRect.left + (headCellRect.right - anchorCellRect.left) / 2;
            // When column is selected, adjust top position to ensure that the toolbar does not
            // touch column drag handle
            top = top - $68fa3b7808a54c2b$var$offsetTopOnColumnSelection;
        }
        let adjustedLeft = Math.max(0, left - toolbarRect.width / 2 - wrapperBounds.left);
        if (adjustedLeft + toolbarRect.width > wrapperBounds.width) adjustedLeft = Math.max(0, wrapperBounds.width - (toolbarRect.width + $68fa3b7808a54c2b$var$scrollbarWidth));
        // If the toolbar is to be placed at the bottom of the selection (it happens when
        // there is no sufficient space above) and the bottom of the selection is not in the view,
        // place the toolbar at the bottom of the visible part of selection
        if (selection.isColSelection() && top + toolbarRect.height > wrapperBounds.bottom) top = top - (top - wrapperBounds.bottom) - (toolbarRect.height + 2 * $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop);
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: adjustedLeft
        };
    };
module.exports["calculateToolbarPositionAboveSelection"] = $68fa3b7808a54c2b$export$5966a251e0deb6ac;
module.exports["calculateToolbarPositionTrackHead"] = $68fa3b7808a54c2b$export$4fdfbe77de19eec;
module.exports["calculateToolbarPositionOnCellSelection"] = $68fa3b7808a54c2b$export$2d9cc331fb808a87;

});

parcelRegister("2bi6l", function(module, exports) {
const $501c60a5b21a582b$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};
module.exports["findNodePosByLocalIds"] = $501c60a5b21a582b$export$947fc26275418e36;

});

parcelRegister("3JtSu", function(module, exports) {

var $dDZcC = parcelRequire("dDZcC");


var $1A9t2 = parcelRequire("1A9t2");

const $2ac2e591b1565c3c$export$46a7f65963d82cf5 = (doc)=>{
    const pageElementCounts = {
        elements: {},
        textFormats: {},
        macros: {},
        unexpectedElements: {}
    };
    (0, $1A9t2.reduce)(doc, (acc, node)=>{
        if (node.type === 'text') {
            if (node.marks) node.marks.forEach((mark)=>{
                const markType = mark.type;
                acc.textFormats[markType] = (acc.textFormats[markType] ?? 0) + 1;
            });
            acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        } else if (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension' || node.type === 'multiBodiedExtension' || node.type === 'extensionFrame') {
            if ('attrs' in node && node.attrs && 'extensionKey' in node.attrs && node.attrs.extensionKey) {
                let extensionKey = node.attrs.extensionKey;
                // If there is a nested table extension
                if ((0, $dDZcC.isNestedTableExtension)(node)) {
                    if ('parameters' in node.attrs && node.attrs.parameters && 'adf' in node.attrs.parameters) {
                        // Check to see if the ADF contains a nested table
                        const adfString = node.attrs.parameters.adf;
                        const adf = JSON.parse(adfString);
                        if (adfString.includes('{"type":"table"')) {
                            if ($2ac2e591b1565c3c$var$getHasNestedTable(adf)) acc.unexpectedElements['tablesNestedMoreThanOnce'] = (acc.unexpectedElements['tablesNestedMoreThanOnce'] ?? 0) + 1;
                        }
                    }
                }
                // If macros extensionKey has <UUID>/<UUID>/static/ prepended to it, remove the prefix
                if (extensionKey.includes('/static/')) {
                    const extensionKeyParts = extensionKey.split('/');
                    extensionKey = extensionKeyParts[extensionKeyParts.length - 1];
                }
                acc.macros[extensionKey] = (acc.macros[extensionKey] ?? 0) + 1;
            }
        } else acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        return acc;
    }, pageElementCounts);
    return pageElementCounts;
};
/**
 * Return true is the JSON document contains a table nested within a table
 */ const $2ac2e591b1565c3c$var$getHasNestedTable = (node)=>{
    return (0, $1A9t2.reduce)(node, (hasNestedTable, node)=>{
        if (hasNestedTable) return hasNestedTable;
        if (node.type === 'table') {
            // The first node that we pass into the reduce function is a table node, and we need to ignore it
            let foundFirstTable = false;
            return (0, $1A9t2.reduce)(node, (hasNestedTable, node)=>{
                if (hasNestedTable) return hasNestedTable;
                if (node.type === 'table' && foundFirstTable) return true;
                else if (node.type === 'table') foundFirstTable = true;
                return hasNestedTable;
            }, false);
        }
        return hasNestedTable;
    }, false);
};
module.exports["getPageElementCounts"] = $2ac2e591b1565c3c$export$46a7f65963d82cf5;

});

parcelRegister("2GVu1", function(module, exports) {
/* ToolbarDropdownItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dAYOx = parcelRequire("dAYOx");


var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $5v3PK = parcelRequire("5v3PK");

const $d0623f38ad0eaa49$var$styles = {
    toolbarDropdownItem: "_11c8fhey _18zrutpp _1rjc1b66 _1e0c1txw _kqswh2mm _bfhksm61 _1bsb1osq _1tkezwfg _1ul9eoa3 _syazazsu _1bas12b0 _1ah31i6y",
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1053azsu _9oik1r31 _1bnxglyw _jf4cnqa1 _30l3azsu",
    enabled: "_irr31dpa _1di6fcek",
    disabled: "_syaz1gmx _80om13gf",
    selected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp"
};
const $d0623f38ad0eaa49$var$CustomDropdownMenuItemButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, tabIndex: tabIndex, title: title }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        role: (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? 'menuitem' : undefined,
        testId: testId,
        xcss: (0, $1Whri.cx)($d0623f38ad0eaa49$var$styles.toolbarDropdownItem, ariaDisabled ? $d0623f38ad0eaa49$var$styles.disabled : ariaPressed ? $d0623f38ad0eaa49$var$styles.selected : $d0623f38ad0eaa49$var$styles.enabled),
        onClick: onClick,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-pressed": (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? undefined : ariaPressed,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? 'menu-item' : undefined,
        ref: ref,
        title: (0, $1oCLl.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? title : undefined,
        children: children
    }));
const $d0623f38ad0eaa49$var$CustomDropdownMenuItemAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, tabIndex: tabIndex, href: href, target: target, rel: rel, title: title, ...dataAttributes }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        role: (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? 'menuitem' : undefined,
        testId: testId,
        xcss: (0, $1Whri.cx)($d0623f38ad0eaa49$var$styles.toolbarDropdownItem, $d0623f38ad0eaa49$var$styles.anchor, ariaDisabled ? $d0623f38ad0eaa49$var$styles.disabled : ariaPressed ? $d0623f38ad0eaa49$var$styles.selected : $d0623f38ad0eaa49$var$styles.enabled),
        onClick: onClick,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-pressed": (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? undefined : ariaPressed,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": "menu-item",
        ref: ref,
        href: href,
        target: target,
        rel: rel,
        title: title,
        ...dataAttributes,
        children: children
    }));
const $d0623f38ad0eaa49$export$abcb00136d206988 = ({ onClick: onClick, elemBefore: elemBefore, elemAfter: elemAfter, isSelected: isSelected, children: children, isDisabled: isDisabled, hasNestedDropdownMenu: hasNestedDropdownMenu, triggerRef: triggerRef, title: title, shouldTitleWrap: shouldTitleWrap = true, testId: testId, ariaKeyshortcuts: ariaKeyshortcuts, href: href, target: target, rel: rel, ...dataAttributes })=>{
    const parentContext = (0, $5v3PK.useToolbarDropdownMenu)();
    const injectedElemAfter = (()=>{
        if (!/*#__PURE__*/ (0, $42omo.isValidElement)(elemAfter)) return elemAfter;
        const elementProps = elemAfter.props;
        if ('isDisabled' in elementProps) return elemAfter;
        return /*#__PURE__*/ (0, $42omo.cloneElement)(elemAfter, {
            ...elementProps,
            isDisabled: isDisabled
        });
    })();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    ), {
        onClick: (e)=>{
            if (!hasNestedDropdownMenu) parentContext?.closeMenu(e);
            onClick?.(e);
        },
        elemBefore: elemBefore,
        elemAfter: injectedElemAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        "aria-haspopup": hasNestedDropdownMenu,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": ariaKeyshortcuts,
        ref: triggerRef,
        href: href,
        target: target,
        rel: rel,
        component: href ? (0, $1oCLl.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? $d0623f38ad0eaa49$var$CustomDropdownMenuItemAnchor : undefined : $d0623f38ad0eaa49$var$CustomDropdownMenuItemButton,
        testId: testId,
        "data-toolbar-component": "menu-item",
        title: title,
        shouldTitleWrap: shouldTitleWrap,
        ...(0, $1oCLl.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? dataAttributes : {},
        children: children
    });
};
module.exports["ToolbarDropdownItem"] = $d0623f38ad0eaa49$export$abcb00136d206988;

});

parcelRegister("5v3PK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $3d7023a12eab06cb$var$ToolbarDropdownMenuContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $3d7023a12eab06cb$export$4a532e97cc88ad2f = ()=>{
    return (0, $42omo.useContext)($3d7023a12eab06cb$var$ToolbarDropdownMenuContext);
};
const $3d7023a12eab06cb$export$7baf0d20f25b94dd = ({ children: children, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isOpenInternal, setIsOpenInternal] = (0, $42omo.useState)(false);
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $8hoW2.useToolbarUI)();
    const openMenu = (event)=>{
        if (setIsOpen !== undefined) setIsOpen(true);
        else setIsOpenInternal(true);
        onDropdownOpenChanged({
            isOpen: true,
            event: event
        });
    };
    const closeMenu = (event)=>{
        if (setIsOpen !== undefined) setIsOpen(false);
        else setIsOpenInternal(false);
        onDropdownOpenChanged({
            isOpen: false,
            event: event
        });
    };
    const contextValue = {
        openMenu: openMenu,
        closeMenu: closeMenu,
        isOpen: isOpen !== undefined ? isOpen : isOpenInternal
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($3d7023a12eab06cb$var$ToolbarDropdownMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["useToolbarDropdownMenu"] = $3d7023a12eab06cb$export$4a532e97cc88ad2f;
module.exports["ToolbarDropdownMenuProvider"] = $3d7023a12eab06cb$export$7baf0d20f25b94dd;

});

parcelRegister("iIVVb", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

const $769eb2f07aee64ec$export$7293ce116b97b92a = ({ content: content, shortcut: shortcut, children: children, position: position = 'top', delay: delay })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: content,
        position: position,
        delay: delay,
        shortcut: shortcut,
        children: children
    });
};
module.exports["ToolbarTooltip"] = $769eb2f07aee64ec$export$7293ce116b97b92a;

});

parcelRegister("bTiiT", function(module, exports) {
/* ToolbarDropdownMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $52EPl = parcelRequire("52EPl");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");


var $8hoW2 = parcelRequire("8hoW2");


var $7ERUE = parcelRequire("7ERUE");


var $5v3PK = parcelRequire("5v3PK");

const $301345521f026167$var$styles = {
    sectionMargin: "_1mouv77o",
    firstSectionSeparator: "_18l8n7od",
    scrollContainer: "_c71lnklw _18m91wug"
};
const $301345521f026167$var$ToolbarDropdownMenuContent = ({ iconBefore: iconBefore, tooltipComponent: tooltipComponent, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, onClick: onClick })=>{
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $8hoW2.useToolbarUI)();
    const menuContext = (0, $5v3PK.useToolbarDropdownMenu)();
    const handleOpenChange = (0, $42omo.useCallback)((args)=>{
        onDropdownOpenChanged(args);
        if (!args.isOpen) menuContext?.closeMenu(args.event);
    }, [
        menuContext,
        onDropdownOpenChanged
    ]);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        if (!menuContext?.isOpen) menuContext?.openMenu(e);
        else menuContext?.closeMenu(e);
    }, [
        menuContext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        trigger: (triggerProps)=>{
            const toolbarButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
                ref: triggerProps.triggerRef,
                isSelected: triggerProps.isSelected,
                "aria-expanded": triggerProps['aria-expanded'],
                "aria-haspopup": triggerProps['aria-haspopup'],
                "aria-controls": triggerProps['aria-controls'],
                onBlur: triggerProps.onBlur,
                onClick: (e)=>{
                    onClick && onClick(e, !menuContext?.isOpen);
                    handleClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                onFocus: triggerProps.onFocus,
                id: (0, $1oCLl.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? id : undefined,
                testId: testId,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                label: label
            });
            if (tooltipComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(tooltipComponent, {
                children: toolbarButton
            });
            return toolbarButton;
        },
        onOpenChange: handleOpenChange,
        isOpen: menuContext?.isOpen,
        children: children
    });
};
const $301345521f026167$export$fffc3e0cfea7888f = ({ iconBefore: iconBefore, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, hasSectionMargin: hasSectionMargin = true, enableMaxHeight: enableMaxHeight = false, onClick: onClick, tooltipComponent: tooltipComponent })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($301345521f026167$var$ToolbarDropdownMenuContent, {
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        id: (0, $1oCLl.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? id : undefined,
        testId: testId,
        label: label,
        onClick: onClick,
        tooltipComponent: tooltipComponent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1bHXt.cx)(hasSectionMargin && $301345521f026167$var$styles.sectionMargin, enableMaxHeight && $301345521f026167$var$styles.scrollContainer, $301345521f026167$var$styles.firstSectionSeparator),
            "data-toolbar-component": "menu",
            children: children
        })
    });
};
module.exports["ToolbarDropdownMenu"] = $301345521f026167$export$fffc3e0cfea7888f;

});

parcelRegister("7ERUE", function(module, exports) {
/* ToolbarButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $fVUfS = parcelRequire("fVUfS");


var $8hoW2 = parcelRequire("8hoW2");

const $ce07609a59c94f1e$var$styles = {
    button: "_zulp12x7 _2rko12b0 _11c8fhey _1e0c1txw _bfhksm61 _o5721q9c _4cvr1h6o _1bah1h6o _1tke1f4h _syazazsu _19bvu2gc _u5f3u2gc _1ah3idpf _g0pbkb7n _oh03h2mm",
    enabled: "_irr31dpa _1di6fcek",
    disabled: "_syaz1gmx _80om13gf",
    selected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp"
};
const $ce07609a59c94f1e$export$e5c1a33878e86e9e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onBlur: onBlur, onFocus: onFocus, testId: testId, id: id, isDisabled: isDisabled, ariaKeyshortcuts: ariaKeyshortcuts, label: label, interactionName: interactionName }, ref)=>{
    const { preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: ctxDisabled } = (0, $8hoW2.useToolbarUI)();
    const disabled = Boolean(ctxDisabled || isDisabled);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        ref: ref,
        xcss: (0, $1Whri.cx)($ce07609a59c94f1e$var$styles.button, disabled ? $ce07609a59c94f1e$var$styles.disabled : isSelected ? $ce07609a59c94f1e$var$styles.selected : $ce07609a59c94f1e$var$styles.enabled),
        "aria-pressed": isSelected,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "aria-controls": ariaControls,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "aria-label": label,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        testId: testId,
        id: id,
        isDisabled: disabled,
        onMouseDown: (event)=>{
            if (preventDefaultOnMouseDown) event.preventDefault();
        },
        "data-toolbar-component": "button",
        interactionName: interactionName,
        children: [
            iconBefore,
            children
        ]
    });
});
module.exports["ToolbarButton"] = $ce07609a59c94f1e$export$e5c1a33878e86e9e;

});

parcelRegister("lcPXp", function(module, exports) {
function $f70305999585f159$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $f70305999585f159$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $f70305999585f159$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $f70305999585f159$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $f70305999585f159$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $f70305999585f159$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $f70305999585f159$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $f70305999585f159$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $f70305999585f159$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $f70305999585f159$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $f70305999585f159$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $f70305999585f159$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $f70305999585f159$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $f70305999585f159$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $f70305999585f159$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $f70305999585f159$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $f70305999585f159$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $f70305999585f159$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $f70305999585f159$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $f70305999585f159$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $f70305999585f159$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $f70305999585f159$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $f70305999585f159$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $f70305999585f159$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $f70305999585f159$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $f70305999585f159$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $f70305999585f159$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $f70305999585f159$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $f70305999585f159$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $f70305999585f159$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $f70305999585f159$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $f70305999585f159$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $f70305999585f159$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $f70305999585f159$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $f70305999585f159$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $f70305999585f159$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $f70305999585f159$var$fromHex_1 = $f70305999585f159$var$fromHex, $f70305999585f159$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $f70305999585f159$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $f70305999585f159$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $f70305999585f159$var$fromRgb_1 = $f70305999585f159$var$fromRgb, $f70305999585f159$var$fromCssRgb_1 = $f70305999585f159$var$fromCssRgb, $f70305999585f159$var$fromHsl_1 = $f70305999585f159$var$fromHsl, $f70305999585f159$var$fromCssHsl_1 = $f70305999585f159$var$fromCssHsl, $f70305999585f159$var$fromHsv_1 = $f70305999585f159$var$fromHsv, $f70305999585f159$var$fromCmyk_1 = $f70305999585f159$var$fromCmyk, $f70305999585f159$var$fromYiq_1 = $f70305999585f159$var$fromYiq, $f70305999585f159$var$fromXYZ_1 = $f70305999585f159$var$fromXYZ, $f70305999585f159$var$fromxyY_1 = $f70305999585f159$var$fromxyY, $f70305999585f159$var$fromLms_1 = $f70305999585f159$var$fromLms, $f70305999585f159$var$fromCieLab_1 = $f70305999585f159$var$fromCieLab, $f70305999585f159$var$fromCieLuv_1 = $f70305999585f159$var$fromCieLuv, $f70305999585f159$var$fromCieLch_1 = $f70305999585f159$var$fromCieLch, $f70305999585f159$var$fromHsluv = $f70305999585f159$var$fromCieLch$1, $f70305999585f159$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $f70305999585f159$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $f70305999585f159$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $f70305999585f159$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $f70305999585f159$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $f70305999585f159$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $f70305999585f159$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $f70305999585f159$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $f70305999585f159$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $f70305999585f159$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $f70305999585f159$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $f70305999585f159$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $f70305999585f159$var$fromHsluv
    }
}, $f70305999585f159$var$adapt_1 = $f70305999585f159$var$adapt, $f70305999585f159$var$adjacent_1 = $f70305999585f159$var$adjacent, $f70305999585f159$var$brightness_1 = $f70305999585f159$var$brightness, $f70305999585f159$var$complementary_1 = $f70305999585f159$var$complementary, $f70305999585f159$var$contrast_1 = $f70305999585f159$var$contrast, $f70305999585f159$var$contrastRatio_1 = $f70305999585f159$var$contrastRatio, $f70305999585f159$var$convert_1 = $f70305999585f159$var$convert, $f70305999585f159$var$difference_1 = $f70305999585f159$var$difference, $f70305999585f159$var$fade_1 = $f70305999585f159$var$fade, $f70305999585f159$var$greyscale_1 = $f70305999585f159$var$greyscale, $f70305999585f159$var$hue_1 = $f70305999585f159$var$hue, $f70305999585f159$var$invert_1 = $f70305999585f159$var$invert, $f70305999585f159$var$invertLightness_1 = $f70305999585f159$var$invertLightness, $f70305999585f159$var$mid_1 = $f70305999585f159$var$mid, $f70305999585f159$var$multiply_1 = $f70305999585f159$var$multiply, $f70305999585f159$var$saturation_1 = $f70305999585f159$var$saturation, $f70305999585f159$var$sepia_1 = $f70305999585f159$var$sepia, $f70305999585f159$var$shade_1 = $f70305999585f159$var$shade, $f70305999585f159$var$temperature_1 = $f70305999585f159$var$temperature, $f70305999585f159$var$tetrad_1 = $f70305999585f159$var$tetrad, $f70305999585f159$var$triad_1 = $f70305999585f159$var$triad, $f70305999585f159$var$index$2 = {
    adapt: $f70305999585f159$var$adapt_1,
    adjacent: $f70305999585f159$var$adjacent_1,
    brightness: $f70305999585f159$var$brightness_1,
    complementary: $f70305999585f159$var$complementary_1,
    contrast: $f70305999585f159$var$contrast_1,
    contrastRatio: $f70305999585f159$var$contrastRatio_1,
    convert: $f70305999585f159$var$convert_1,
    difference: $f70305999585f159$var$difference_1,
    fade: $f70305999585f159$var$fade_1,
    greyscale: $f70305999585f159$var$greyscale_1,
    hue: $f70305999585f159$var$hue_1,
    invert: $f70305999585f159$var$invert_1,
    invertLightness: $f70305999585f159$var$invertLightness_1,
    mid: $f70305999585f159$var$mid_1,
    multiply: $f70305999585f159$var$multiply_1,
    saturation: $f70305999585f159$var$saturation_1,
    sepia: $f70305999585f159$var$sepia_1,
    shade: $f70305999585f159$var$shade_1,
    temperature: $f70305999585f159$var$temperature_1,
    tetrad: $f70305999585f159$var$tetrad_1,
    triad: $f70305999585f159$var$triad_1
}, $f70305999585f159$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $f70305999585f159$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $f70305999585f159$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($f70305999585f159$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $f70305999585f159$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($f70305999585f159$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $f70305999585f159$var$api_1 = $f70305999585f159$var$api, $f70305999585f159$var$helpers = {
    getIlluminant: function(r) {
        return $f70305999585f159$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $f70305999585f159$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $f70305999585f159$var$index)if ($f70305999585f159$var$index.hasOwnProperty(e) && $f70305999585f159$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $f70305999585f159$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $f70305999585f159$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $f70305999585f159$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $f70305999585f159$var$constants, s));
            default:
                return null;
        }
    }
}, $f70305999585f159$var$helpers_1 = $f70305999585f159$var$helpers, $f70305999585f159$var$dependencies = {
    conversions: $f70305999585f159$var$index,
    operations: $f70305999585f159$var$index$2,
    helpers: $f70305999585f159$var$helpers_1
}, $f70305999585f159$var$entry = $f70305999585f159$var$api_1($f70305999585f159$var$dependencies, $f70305999585f159$var$constants);
var $f70305999585f159$export$2e2bcd8739ae039 = $f70305999585f159$var$entry;
module.exports["default"] = $f70305999585f159$export$2e2bcd8739ae039;

});

parcelRegister("fnia6", function(module, exports) {
$parcel$export(module.exports, "EmojiPicker", () => (parcelRequire("lGf1F")).default);

var $dwp40 = parcelRequire("dwp40");



var $eTjjM = parcelRequire("eTjjM");


var $etuMO = parcelRequire("etuMO");


var $lGf1F = parcelRequire("lGf1F");




var $kVNt7 = parcelRequire("kVNt7");


var $8hpYf = parcelRequire("8hpYf");


var $ibzAc = parcelRequire("ibzAc");






var $injKz = parcelRequire("injKz");

var $cGMbZ = parcelRequire("cGMbZ");


var $fhsiz = parcelRequire("fhsiz");






var $jYWS5 = parcelRequire("jYWS5");


var $aGYoD = parcelRequire("aGYoD");

var $554b7b79acaeef8c$export$2e2bcd8739ae039 = (0, $lGf1F.default);

});

parcelRegister("kVNt7", function(module, exports) {
/* EmojiTypeAheadItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $jYWS5 = parcelRequire("jYWS5");


var $2s0fd = parcelRequire("2s0fd");


var $40rXS = parcelRequire("40rXS");


var $5uONf = parcelRequire("5uONf");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $247233a1d8067c94$export$dca0df2a2f0ab6cf = 'emoji-typeahead-element';
const $247233a1d8067c94$export$9b2d029b494a863e = 'emoji-typeahead-list-container';
const $247233a1d8067c94$export$214089244105a739 = 'emoji-typeahead-selected';


const $d1013f202cbb053e$var$typeAheadWidth = 350;
const $d1013f202cbb053e$var$typeAheadItem = null;
const $d1013f202cbb053e$var$selectedStyles = null;
const $d1013f202cbb053e$var$typeAheadItemRow = null;
function $d1013f202cbb053e$export$616ca81e9448d046(props) {
    const { emoji: emoji, onSelection: onSelection, onMouseMove: onMouseMove, selected: selected, emojiProvider: emojiProvider, forwardedRef: forwardedRef } = props;
    const onEmojiSelected = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if ((0, $2s0fd.leftClick)(event) && onSelection) {
            event.preventDefault();
            onSelection((0, $40rXS.toEmojiId)(emoji), emoji, event);
        }
    }, [
        emoji,
        onSelection
    ]);
    const onEmojiMenuItemMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (onMouseMove) onMouseMove((0, $40rXS.toEmojiId)(emoji), emoji, event);
    }, [
        emoji,
        onMouseMove
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jYWS5.EmojiCommonProvider), {
        emojiProvider: emojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _80omtlke _1e0c1ule _2mzuglyw _1bsb1edt",
            selected && "_bfhki8nm",
            `ak-emoji-typeahead-item ${selected ? (0, $247233a1d8067c94$export$214089244105a739) : ''}`
        ]),
        onMouseDown: onEmojiSelected,
        onMouseMove: onEmojiMenuItemMouseMove,
        "data-emoji-id": emoji.shortName,
        ref: forwardedRef,
        role: (0, $dh538.fg)('platform_suppression_removal_fix_reactions') ? 'button' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1n261g80 _s7n4nkob"
        ])
    }, emoji && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5uONf.EmojiPreviewComponent), {
        emoji: emoji
    }))));
}
const $d1013f202cbb053e$var$EmojiTypeAheadItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1013f202cbb053e$export$616ca81e9448d046, {
        ...props,
        forwardedRef: ref
    }));
var $d1013f202cbb053e$export$2e2bcd8739ae039 = $d1013f202cbb053e$var$EmojiTypeAheadItem;
module.exports["default"] = $d1013f202cbb053e$export$2e2bcd8739ae039;

});

parcelRegister("3KVX0", function(module, exports) {
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $2bc29ecddddf3571$var$isArray(value) {
    return !Array.isArray ? $2bc29ecddddf3571$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $2bc29ecddddf3571$var$INFINITY = 1 / 0;
function $2bc29ecddddf3571$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$2bc29ecddddf3571$var$INFINITY ? '-0' : result;
}
function $2bc29ecddddf3571$var$toString(value) {
    return value == null ? '' : $2bc29ecddddf3571$var$baseToString(value);
}
function $2bc29ecddddf3571$var$isString(value) {
    return typeof value === 'string';
}
function $2bc29ecddddf3571$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $2bc29ecddddf3571$var$isBoolean(value) {
    return value === true || value === false || $2bc29ecddddf3571$var$isObjectLike(value) && $2bc29ecddddf3571$var$getTag(value) == '[object Boolean]';
}
function $2bc29ecddddf3571$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $2bc29ecddddf3571$var$isObjectLike(value) {
    return $2bc29ecddddf3571$var$isObject(value) && value !== null;
}
function $2bc29ecddddf3571$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $2bc29ecddddf3571$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $2bc29ecddddf3571$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $2bc29ecddddf3571$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $2bc29ecddddf3571$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $2bc29ecddddf3571$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $2bc29ecddddf3571$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $2bc29ecddddf3571$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $2bc29ecddddf3571$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $2bc29ecddddf3571$var$hasOwn = Object.prototype.hasOwnProperty;
class $2bc29ecddddf3571$var$KeyStore {
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $2bc29ecddddf3571$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
}
function $2bc29ecddddf3571$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($2bc29ecddddf3571$var$isString(key) || $2bc29ecddddf3571$var$isArray(key)) {
        src = key;
        path = $2bc29ecddddf3571$var$createKeyPath(key);
        id = $2bc29ecddddf3571$var$createKeyId(key);
    } else {
        if (!$2bc29ecddddf3571$var$hasOwn.call(key, 'name')) throw new Error($2bc29ecddddf3571$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($2bc29ecddddf3571$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($2bc29ecddddf3571$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $2bc29ecddddf3571$var$createKeyPath(name);
        id = $2bc29ecddddf3571$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $2bc29ecddddf3571$var$createKeyPath(key) {
    return $2bc29ecddddf3571$var$isArray(key) ? key : key.split('.');
}
function $2bc29ecddddf3571$var$createKeyId(key) {
    return $2bc29ecddddf3571$var$isArray(key) ? key.join('.') : key;
}
function $2bc29ecddddf3571$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$2bc29ecddddf3571$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$2bc29ecddddf3571$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($2bc29ecddddf3571$var$isString(value) || $2bc29ecddddf3571$var$isNumber(value) || $2bc29ecddddf3571$var$isBoolean(value))) list.push($2bc29ecddddf3571$var$toString(value));
            else if ($2bc29ecddddf3571$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $2bc29ecddddf3571$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $2bc29ecddddf3571$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $2bc29ecddddf3571$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $2bc29ecddddf3571$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $2bc29ecddddf3571$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $2bc29ecddddf3571$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $2bc29ecddddf3571$var$Config = {
    ...$2bc29ecddddf3571$var$BasicOptions,
    ...$2bc29ecddddf3571$var$MatchOptions,
    ...$2bc29ecddddf3571$var$FuzzyOptions,
    ...$2bc29ecddddf3571$var$AdvancedOptions
};
const $2bc29ecddddf3571$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $2bc29ecddddf3571$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($2bc29ecddddf3571$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $2bc29ecddddf3571$var$FuseIndex {
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($2bc29ecddddf3571$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($2bc29ecddddf3571$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$2bc29ecddddf3571$var$isDefined(doc) || $2bc29ecddddf3571$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$2bc29ecddddf3571$var$isDefined(value)) return;
            if ($2bc29ecddddf3571$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$2bc29ecddddf3571$var$isDefined(value)) continue;
                    if ($2bc29ecddddf3571$var$isString(value) && !$2bc29ecddddf3571$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($2bc29ecddddf3571$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($2bc29ecddddf3571$var$isString(value) && !$2bc29ecddddf3571$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
    constructor({ getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}){
        this.norm = $2bc29ecddddf3571$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
}
function $2bc29ecddddf3571$var$createIndex(keys, docs, { getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $2bc29ecddddf3571$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($2bc29ecddddf3571$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $2bc29ecddddf3571$var$parseIndex(data, { getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $2bc29ecddddf3571$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $2bc29ecddddf3571$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $2bc29ecddddf3571$var$Config.distance, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $2bc29ecddddf3571$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $2bc29ecddddf3571$var$MAX_BITS = 32;
function $2bc29ecddddf3571$var$search(text, pattern, patternAlphabet, { location: location = $2bc29ecddddf3571$var$Config.location, distance: distance = $2bc29ecddddf3571$var$Config.distance, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $2bc29ecddddf3571$var$MAX_BITS) throw new Error($2bc29ecddddf3571$var$PATTERN_LENGTH_TOO_LARGE($2bc29ecddddf3571$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $2bc29ecddddf3571$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $2bc29ecddddf3571$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $2bc29ecddddf3571$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $2bc29ecddddf3571$var$BitapSearch {
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $2bc29ecddddf3571$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
    constructor(pattern, { location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $2bc29ecddddf3571$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $2bc29ecddddf3571$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $2bc29ecddddf3571$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $2bc29ecddddf3571$var$MAX_BITS), i);
                i += $2bc29ecddddf3571$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $2bc29ecddddf3571$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
}
class $2bc29ecddddf3571$var$BaseMatch {
    static isMultiMatch(pattern) {
        return $2bc29ecddddf3571$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $2bc29ecddddf3571$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
    constructor(pattern){
        this.pattern = pattern;
    }
}
function $2bc29ecddddf3571$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $2bc29ecddddf3571$var$ExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !fire
class $2bc29ecddddf3571$var$InverseExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: ^file
class $2bc29ecddddf3571$var$PrefixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !^fire
class $2bc29ecddddf3571$var$InversePrefixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: .file$
class $2bc29ecddddf3571$var$SuffixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !.file$
class $2bc29ecddddf3571$var$InverseSuffixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
class $2bc29ecddddf3571$var$FuzzyMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
    constructor(pattern, { location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $2bc29ecddddf3571$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
}
// Token: 'file
class $2bc29ecddddf3571$var$IncludeMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// ❗Order is important. DO NOT CHANGE.
const $2bc29ecddddf3571$var$searchers = [
    $2bc29ecddddf3571$var$ExactMatch,
    $2bc29ecddddf3571$var$IncludeMatch,
    $2bc29ecddddf3571$var$PrefixExactMatch,
    $2bc29ecddddf3571$var$InversePrefixExactMatch,
    $2bc29ecddddf3571$var$InverseSuffixExactMatch,
    $2bc29ecddddf3571$var$SuffixExactMatch,
    $2bc29ecddddf3571$var$InverseExactMatch,
    $2bc29ecddddf3571$var$FuzzyMatch
];
const $2bc29ecddddf3571$var$searchersLen = $2bc29ecddddf3571$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $2bc29ecddddf3571$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $2bc29ecddddf3571$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $2bc29ecddddf3571$var$parseQuery(pattern, options = {}) {
    return pattern.split($2bc29ecddddf3571$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($2bc29ecddddf3571$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $2bc29ecddddf3571$var$searchersLen){
                const searcher = $2bc29ecddddf3571$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $2bc29ecddddf3571$var$searchersLen){
                const searcher = $2bc29ecddddf3571$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $2bc29ecddddf3571$var$MultiMatchSet = new Set([
    $2bc29ecddddf3571$var$FuzzyMatch.type,
    $2bc29ecddddf3571$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $2bc29ecddddf3571$var$ExtendedSearch {
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($2bc29ecddddf3571$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $2bc29ecddddf3571$var$parseQuery(this.pattern, this.options);
    }
}
const $2bc29ecddddf3571$var$registeredSearchers = [];
function $2bc29ecddddf3571$var$register(...args) {
    $2bc29ecddddf3571$var$registeredSearchers.push(...args);
}
function $2bc29ecddddf3571$var$createSearcher(pattern, options) {
    for(let i = 0, len = $2bc29ecddddf3571$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $2bc29ecddddf3571$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $2bc29ecddddf3571$var$BitapSearch(pattern, options);
}
const $2bc29ecddddf3571$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $2bc29ecddddf3571$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $2bc29ecddddf3571$var$isExpression = (query)=>!!(query[$2bc29ecddddf3571$var$LogicalOperator.AND] || query[$2bc29ecddddf3571$var$LogicalOperator.OR]);
const $2bc29ecddddf3571$var$isPath = (query)=>!!query[$2bc29ecddddf3571$var$KeyType.PATH];
const $2bc29ecddddf3571$var$isLeaf = (query)=>!$2bc29ecddddf3571$var$isArray(query) && $2bc29ecddddf3571$var$isObject(query) && !$2bc29ecddddf3571$var$isExpression(query);
const $2bc29ecddddf3571$var$convertToExplicit = (query)=>({
        [$2bc29ecddddf3571$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $2bc29ecddddf3571$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $2bc29ecddddf3571$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$2bc29ecddddf3571$var$isExpression(query)) return next($2bc29ecddddf3571$var$convertToExplicit(query));
        if ($2bc29ecddddf3571$var$isLeaf(query)) {
            const key = isQueryPath ? query[$2bc29ecddddf3571$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$2bc29ecddddf3571$var$KeyType.PATTERN] : query[key];
            if (!$2bc29ecddddf3571$var$isString(pattern)) throw new Error($2bc29ecddddf3571$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $2bc29ecddddf3571$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $2bc29ecddddf3571$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($2bc29ecddddf3571$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$2bc29ecddddf3571$var$isExpression(query)) query = $2bc29ecddddf3571$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $2bc29ecddddf3571$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $2bc29ecddddf3571$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $2bc29ecddddf3571$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$2bc29ecddddf3571$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$2bc29ecddddf3571$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $2bc29ecddddf3571$var$transformScore(result, data) {
    data.score = result.score;
}
function $2bc29ecddddf3571$var$format(results, docs, { includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, includeScore: includeScore = $2bc29ecddddf3571$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($2bc29ecddddf3571$var$transformMatches);
    if (includeScore) transformers.push($2bc29ecddddf3571$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $2bc29ecddddf3571$export$2e2bcd8739ae039 {
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $2bc29ecddddf3571$var$FuseIndex)) throw new Error($2bc29ecddddf3571$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $2bc29ecddddf3571$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$2bc29ecddddf3571$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $2bc29ecddddf3571$var$isString(query) ? $2bc29ecddddf3571$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $2bc29ecddddf3571$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($2bc29ecddddf3571$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $2bc29ecddddf3571$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $2bc29ecddddf3571$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2bc29ecddddf3571$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $2bc29ecddddf3571$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $2bc29ecddddf3571$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($2bc29ecddddf3571$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $2bc29ecddddf3571$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$2bc29ecddddf3571$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$2bc29ecddddf3571$var$isDefined(value)) return [];
        let matches = [];
        if ($2bc29ecddddf3571$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2bc29ecddddf3571$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
    constructor(docs, options = {}, index){
        this.options = {
            ...$2bc29ecddddf3571$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $2bc29ecddddf3571$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
}
$2bc29ecddddf3571$export$2e2bcd8739ae039.version = '6.6.2';
$2bc29ecddddf3571$export$2e2bcd8739ae039.createIndex = $2bc29ecddddf3571$var$createIndex;
$2bc29ecddddf3571$export$2e2bcd8739ae039.parseIndex = $2bc29ecddddf3571$var$parseIndex;
$2bc29ecddddf3571$export$2e2bcd8739ae039.config = $2bc29ecddddf3571$var$Config;
$2bc29ecddddf3571$export$2e2bcd8739ae039.parseQuery = $2bc29ecddddf3571$var$parse;
$2bc29ecddddf3571$var$register($2bc29ecddddf3571$var$ExtendedSearch);
module.exports["default"] = $2bc29ecddddf3571$export$2e2bcd8739ae039;

});

parcelRegister("aCXDM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
function $7bcbb766a0cbdbe5$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $7bcbb766a0cbdbe5$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $7bcbb766a0cbdbe5$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7bcbb766a0cbdbe5$export$2e2bcd8739ae039 = $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37;
module.exports["clsx"] = $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37;
module.exports["default"] = $7bcbb766a0cbdbe5$export$2e2bcd8739ae039;

});

parcelRegister("hslaz", function(module, exports) {
$parcel$export(module.exports, "lib", () => $cb5578fef35f05de$export$16c08b91f883959a, (v) => $cb5578fef35f05de$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $cb5578fef35f05de$export$e6e34fd1f2686227, (v) => $cb5578fef35f05de$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $cb5578fef35f05de$export$844ec244b1367d54, (v) => $cb5578fef35f05de$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $cb5578fef35f05de$export$a4f4bb6b1453fff5, (v) => $cb5578fef35f05de$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $cb5578fef35f05de$export$5ccde1ea0c14bb03, (v) => $cb5578fef35f05de$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $cb5578fef35f05de$export$db8a17c6655f7e2c, (v) => $cb5578fef35f05de$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $cb5578fef35f05de$export$644a8f5b13b2a36d, (v) => $cb5578fef35f05de$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $cb5578fef35f05de$export$73bfc63873071f74, (v) => $cb5578fef35f05de$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $cb5578fef35f05de$export$4cf11838cdc2a8a8, (v) => $cb5578fef35f05de$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $cb5578fef35f05de$export$f78478f71955b6bc, (v) => $cb5578fef35f05de$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $cb5578fef35f05de$export$1d5ccafae59b4926, (v) => $cb5578fef35f05de$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $cb5578fef35f05de$export$3c52dd84024ae72c, (v) => $cb5578fef35f05de$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $cb5578fef35f05de$export$829a0d33ae4e744, (v) => $cb5578fef35f05de$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $cb5578fef35f05de$export$4888a643af800fc1, (v) => $cb5578fef35f05de$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $cb5578fef35f05de$export$bc616c8f7dc20d5d, (v) => $cb5578fef35f05de$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $cb5578fef35f05de$export$20ef46802c8744b, (v) => $cb5578fef35f05de$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $cb5578fef35f05de$export$16c08b91f883959a;
var $cb5578fef35f05de$export$e6e34fd1f2686227;
var $cb5578fef35f05de$export$844ec244b1367d54;
var $cb5578fef35f05de$export$a4f4bb6b1453fff5;
var $cb5578fef35f05de$export$5ccde1ea0c14bb03;
var $cb5578fef35f05de$export$db8a17c6655f7e2c;
var $cb5578fef35f05de$export$644a8f5b13b2a36d;
var $cb5578fef35f05de$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $cb5578fef35f05de$export$4cf11838cdc2a8a8;
var $cb5578fef35f05de$export$f78478f71955b6bc;
var $cb5578fef35f05de$export$1d5ccafae59b4926;
var $cb5578fef35f05de$export$3c52dd84024ae72c;
var $cb5578fef35f05de$export$829a0d33ae4e744;
var $cb5578fef35f05de$export$4888a643af800fc1;
var $cb5578fef35f05de$export$bc616c8f7dc20d5d;
var $cb5578fef35f05de$export$20ef46802c8744b;
'use strict';
function $cb5578fef35f05de$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $cb5578fef35f05de$var$isString(obj) {
    return $cb5578fef35f05de$var$_class(obj) === '[object String]';
}
var $cb5578fef35f05de$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $cb5578fef35f05de$var$has(object, key) {
    return $cb5578fef35f05de$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $cb5578fef35f05de$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $cb5578fef35f05de$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $cb5578fef35f05de$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $cb5578fef35f05de$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $cb5578fef35f05de$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $cb5578fef35f05de$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $cb5578fef35f05de$var$UNESCAPE_ALL_RE = new RegExp($cb5578fef35f05de$var$UNESCAPE_MD_RE.source + '|' + $cb5578fef35f05de$var$ENTITY_RE.source, 'gi');
var $cb5578fef35f05de$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $7j3pV = parcelRequire("7j3pV");

function $cb5578fef35f05de$var$replaceEntityPattern(match, name) {
    var code;
    if ($cb5578fef35f05de$var$has($7j3pV, name)) return $7j3pV[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $cb5578fef35f05de$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($cb5578fef35f05de$var$isValidEntityCode(code)) return $cb5578fef35f05de$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $cb5578fef35f05de$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($cb5578fef35f05de$var$UNESCAPE_MD_RE, '$1');
}
function $cb5578fef35f05de$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($cb5578fef35f05de$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $cb5578fef35f05de$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $cb5578fef35f05de$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $cb5578fef35f05de$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $cb5578fef35f05de$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $cb5578fef35f05de$var$replaceUnsafeChar(ch) {
    return $cb5578fef35f05de$var$HTML_REPLACEMENTS[ch];
}
function $cb5578fef35f05de$var$escapeHtml(str) {
    if ($cb5578fef35f05de$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($cb5578fef35f05de$var$HTML_ESCAPE_REPLACE_RE, $cb5578fef35f05de$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $cb5578fef35f05de$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $cb5578fef35f05de$var$escapeRE(str) {
    return str.replace($cb5578fef35f05de$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $cb5578fef35f05de$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $cb5578fef35f05de$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $eSMp5 = parcelRequire("eSMp5");

// Currently without astral characters support.
function $cb5578fef35f05de$var$isPunctChar(ch) {
    return $eSMp5.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $cb5578fef35f05de$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $cb5578fef35f05de$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$cb5578fef35f05de$export$16c08b91f883959a = {};

$cb5578fef35f05de$export$16c08b91f883959a.mdurl = (parcelRequire("kYaO1"));

$cb5578fef35f05de$export$16c08b91f883959a.ucmicro = (parcelRequire("bx7Sb"));
$cb5578fef35f05de$export$e6e34fd1f2686227 = $cb5578fef35f05de$var$assign;
$cb5578fef35f05de$export$844ec244b1367d54 = $cb5578fef35f05de$var$isString;
$cb5578fef35f05de$export$a4f4bb6b1453fff5 = $cb5578fef35f05de$var$has;
$cb5578fef35f05de$export$5ccde1ea0c14bb03 = $cb5578fef35f05de$var$unescapeMd;
$cb5578fef35f05de$export$db8a17c6655f7e2c = $cb5578fef35f05de$var$unescapeAll;
$cb5578fef35f05de$export$644a8f5b13b2a36d = $cb5578fef35f05de$var$isValidEntityCode;
$cb5578fef35f05de$export$73bfc63873071f74 = $cb5578fef35f05de$var$fromCodePoint;
$cb5578fef35f05de$export$4cf11838cdc2a8a8 = $cb5578fef35f05de$var$escapeHtml;
$cb5578fef35f05de$export$f78478f71955b6bc = $cb5578fef35f05de$var$arrayReplaceAt;
$cb5578fef35f05de$export$1d5ccafae59b4926 = $cb5578fef35f05de$var$isSpace;
$cb5578fef35f05de$export$3c52dd84024ae72c = $cb5578fef35f05de$var$isWhiteSpace;
$cb5578fef35f05de$export$829a0d33ae4e744 = $cb5578fef35f05de$var$isMdAsciiPunct;
$cb5578fef35f05de$export$4888a643af800fc1 = $cb5578fef35f05de$var$isPunctChar;
$cb5578fef35f05de$export$bc616c8f7dc20d5d = $cb5578fef35f05de$var$escapeRE;
$cb5578fef35f05de$export$20ef46802c8744b = $cb5578fef35f05de$var$normalizeReference;

});

parcelRegister("flZnN", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $b2d86e83f9686c86$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $b2d86e83f9686c86$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $b2d86e83f9686c86$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $b2d86e83f9686c86$var$Token;

});

parcelRegister("dgyOV", function(module, exports) {
$parcel$export(module.exports, "HTML_TAG_RE", () => $9a87c79b003d7609$export$6db61d2c3a16e419, (v) => $9a87c79b003d7609$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $9a87c79b003d7609$export$cd48660d06f74639, (v) => $9a87c79b003d7609$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $9a87c79b003d7609$export$6db61d2c3a16e419;
var $9a87c79b003d7609$export$cd48660d06f74639;
'use strict';
var $9a87c79b003d7609$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $9a87c79b003d7609$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $9a87c79b003d7609$var$single_quoted = "'[^']*'";
var $9a87c79b003d7609$var$double_quoted = '"[^"]*"';
var $9a87c79b003d7609$var$attr_value = '(?:' + $9a87c79b003d7609$var$unquoted + '|' + $9a87c79b003d7609$var$single_quoted + '|' + $9a87c79b003d7609$var$double_quoted + ')';
var $9a87c79b003d7609$var$attribute = '(?:\\s+' + $9a87c79b003d7609$var$attr_name + '(?:\\s*=\\s*' + $9a87c79b003d7609$var$attr_value + ')?)';
var $9a87c79b003d7609$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $9a87c79b003d7609$var$attribute + '*\\s*\\/?>';
var $9a87c79b003d7609$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $9a87c79b003d7609$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $9a87c79b003d7609$var$processing = '<[?][\\s\\S]*?[?]>';
var $9a87c79b003d7609$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $9a87c79b003d7609$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $9a87c79b003d7609$var$HTML_TAG_RE = new RegExp('^(?:' + $9a87c79b003d7609$var$open_tag + '|' + $9a87c79b003d7609$var$close_tag + '|' + $9a87c79b003d7609$var$comment + '|' + $9a87c79b003d7609$var$processing + '|' + $9a87c79b003d7609$var$declaration + '|' + $9a87c79b003d7609$var$cdata + ')');
var $9a87c79b003d7609$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $9a87c79b003d7609$var$open_tag + '|' + $9a87c79b003d7609$var$close_tag + ')');
$9a87c79b003d7609$export$6db61d2c3a16e419 = $9a87c79b003d7609$var$HTML_TAG_RE;
$9a87c79b003d7609$export$cd48660d06f74639 = $9a87c79b003d7609$var$HTML_OPEN_CLOSE_TAG_RE;

});

parcelRegister("jPINf", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $38ac0318a728994d$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}
module.exports["UfoErrorBoundary"] = $38ac0318a728994d$export$5ef1c2550074a375;

});

parcelRegister("li2rw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cGMbZ = parcelRequire("cGMbZ");

const $f66bc0c5639e4191$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f66bc0c5639e4191$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            (0, $cGMbZ.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f66bc0c5639e4191$var$useConstructor(()=>{
        (0, $cGMbZ.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};
module.exports["useSampledUFOComponentExperience"] = $f66bc0c5639e4191$export$f959821a7419dee1;

});

parcelRegister("fXFeB", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6a963eddf114ad3d$export$9fab6c37a453c65e = (0, $42omo.createContext)(null);
module.exports["EmojiContext"] = $6a963eddf114ad3d$export$9fab6c37a453c65e;

});

parcelRegister("hpdQE", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $bqMS3 = parcelRequire("bqMS3");

function $5dc3e3095b1b3f43$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $6jPem.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $bqMS3.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}
module.exports["sanitizeNodeForPrivacy"] = $5dc3e3095b1b3f43$export$8a32f625580e0a06;

});

parcelRegister("03yfx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fXFeB = parcelRequire("fXFeB");


var $fB3RY = parcelRequire("fB3RY");

const $cff70d8c603770b6$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $42omo.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $42omo.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $fB3RY.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fXFeB.EmojiContext).Provider, {
        value: memoizedEmojiContextValue
    }, children);
};
module.exports["EmojiContextProvider"] = $cff70d8c603770b6$export$f4a09143833145ed;

});

parcelRegister("2s0fd", function(module, exports) {
function $0c5717a6aae5ba6f$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $0c5717a6aae5ba6f$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $0c5717a6aae5ba6f$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}
module.exports["leftClick"] = $0c5717a6aae5ba6f$export$34ebdaf2c517ae75;

});

parcelRegister("7j3pV", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("hxrg0"));

});


$parcel$global.rlb("1WCMN")
//# sourceMappingURL=simpleHasher.92df7f9b.js.map
